const STATES = {
  AN: {
    cities: {
      'South Andaman': [
        744104, 744107, 744206, 744105, 744103, 744112, 744102, 744211, 744207,
        744101, 744106,
      ],
      'North And Middle Andaman': [
        744202, 744205, 744201, 744209, 744210, 744203, 744204,
      ],
      Nicobar: [744302, 744301, 744303, 744304],
    },
    name: 'AN',
  },
  AP: {
    cities: {
      Ananthapur: [
        515004, 515731, 515002, 515766, 515415, 515822, 515445, 515001, 515741,
        515775, 515455, 515465, 515751, 515867, 515763, 515767, 515722, 515863,
        515425, 515402, 515761, 515787, 515413, 515870, 515871, 515411, 515408,
        515401, 515812, 515701, 515865, 515414, 515842, 515405, 515611, 515721,
        515711, 515765, 515803, 515832, 515005, 515801, 515872, 515774, 515435,
        515003, 515621, 515124, 515311, 515281, 515154, 515556, 515144, 515301,
        515651, 515661, 515631, 515672, 515501, 515134, 515571, 515110, 515305,
        515261, 515211, 515641, 515341, 515212, 515331, 515202, 515271, 515591,
        515531, 515123, 515511, 515241, 515303, 515601, 515122, 515101, 515541,
        515551, 515291, 515521, 515671, 515321, 515164, 515581, 515159, 515231,
        515561, 515286, 515201, 515133,
      ],
      Cuddapah: [
        515465, 516270, 516269, 516150, 516215, 516259, 516193, 516501, 516003,
        516001, 516107, 516257, 516105, 516228, 516104, 516203, 516247, 516267,
        516227, 516502, 516101, 516503, 516162, 516128, 516129, 516233, 516130,
        516110, 516214, 516108, 516126, 516217, 516002, 516004, 516152, 516504,
        516163, 516268, 516213, 516237, 516505, 516151, 516127, 516115, 516339,
        516421, 516454, 516396, 516350, 516356, 516391, 516293, 516434, 516172,
        516355, 516321, 516484, 516390, 516362, 516289, 516359, 516411, 516175,
        516474, 516312, 516432, 516401, 516433, 516349, 516431, 516380, 516218,
        516361, 516464, 516310, 516444, 516360, 516216, 516173, 516330, 516309,
        516311, 516439, 516329,
      ],
      Chittoor: [
        517425, 517403, 517280, 517124, 517415, 517421, 517326, 517390, 517432,
        517247, 517167, 517401, 517129, 517370, 517424, 517351, 517127, 517418,
        517416, 517426, 517422, 517132, 517123, 517423, 517408, 517257, 517419,
        517417, 517002, 517004, 517126, 517319, 517001, 517599, 517131, 517125,
        517130, 517352, 517429, 517128, 517414, 517391, 517350, 517325, 517507,
        517643, 517592, 517589, 517591, 517587, 517214, 517640, 517536, 517645,
        517571, 517582, 517588, 517291, 517641, 517619, 517551, 517236, 517581,
        517642, 517520, 517102, 517277, 517504, 517561, 517213, 517194, 517501,
        517569, 517237, 517590, 517505, 517192, 517101, 517526, 517583, 517305,
        517113, 517193, 517541, 517234, 517112, 517152, 517503, 517172, 517620,
        517235, 517644, 517297, 517586, 517299, 517584, 517502, 517506,
      ],
      Kurnool: [
        518467, 518533, 518302, 518301, 518225, 518405, 518465, 518463, 518220,
        518395, 518216, 518390, 518313, 518005, 518347, 518422, 518350, 518222,
        518007, 518344, 518006, 518598, 518323, 518401, 518396, 518348, 518218,
        518462, 518599, 518004, 518411, 518508, 518412, 518432, 518468, 518206,
        518002, 518380, 518221, 518464, 518345, 518442, 518308, 518346, 518333,
        518360, 518452, 518010, 518466, 518385, 518003, 518349, 518217, 518343,
        518001, 518102, 518101, 518523, 518123, 518543, 518145, 518196, 518112,
        518165, 518134, 518135, 518176, 518124, 518502, 518573, 518510, 518583,
        518122, 518155, 518512, 518553, 518594, 518511, 518513, 518166, 518674,
        518593, 518186, 518563, 518501,
      ],
      Prakasam: [
        523372, 523328, 523356, 523373, 523357, 523330, 523315, 523326, 523368,
        523305, 523335, 523370, 523331, 523336, 523320, 523346, 523333, 523334,
        523332, 523327, 523367, 523329, 523369, 523371, 523316, 523171, 523001,
        523201, 523169, 523240, 523274, 523304, 523212, 523286, 523182, 523112,
        523180, 523116, 523281, 523270, 523101, 523301, 523115, 523211, 523253,
        523214, 523292, 523170, 523271, 523110, 523225, 523113, 523245, 523261,
        523223, 523254, 523226, 523246, 523252, 523167, 523104, 523114, 523265,
        523155, 523183, 523108, 523157, 523247, 523263, 523109, 523262, 523303,
        523291, 523260, 523135, 523181, 523279, 523227, 523111, 523117, 523190,
        523187, 523186, 523264, 523241, 523280, 523224, 523166, 523228, 523165,
        523185, 523302, 523105, 523272, 523230, 523168, 523213, 523002, 523156,
        523184, 523273,
      ],
      'West Godavari': [
        534267, 534266, 534260, 534235, 534320, 534280, 534126, 534240, 534208,
        534202, 534330, 534250, 534230, 534217, 534199, 534123, 534134, 534243,
        534207, 534201, 534206, 534124, 534216, 534204, 534281, 534269, 534268,
        534275, 534227, 534239, 534237, 534328, 534225, 534244, 534211, 534326,
        534122, 534265, 534247, 534236, 534222, 534338, 534210, 534209, 534238,
        534218, 534327, 534324, 534245, 534215, 534416, 534456, 534449, 534427,
        534455, 534448, 534401, 534003, 534426, 534002, 534312, 534460, 534475,
        534001, 534425, 534007, 534462, 534451, 534004, 534406, 534432, 534442,
        534461, 534006, 534005, 534467, 534450, 534437, 534447, 534452, 534311,
        534197, 534198, 534331, 534196, 534146, 534111, 534341, 534101, 534186,
        534145, 534340, 534302, 534112, 534156, 534411, 534313, 534315, 534301,
        534342, 534176, 534316, 534305, 534195, 534166, 534318, 534350, 534102,
        534329, 534165,
      ],
      Krishna: [
        521333, 521390, 521213, 521340, 521343, 521324, 521312, 521327, 521330,
        521215, 521202, 521261, 521106, 521345, 521207, 521105, 521301, 521263,
        521111, 521260, 521214, 521329, 521325, 521148, 521322, 521323, 521321,
        521201, 521326, 521311, 521344, 521366, 521149, 521369, 521122, 521121,
        521138, 521001, 521136, 521120, 521131, 521126, 521002, 521132, 521003,
        521125, 521150, 521356, 521157, 521133, 521328, 521332, 521156, 521135,
        521331, 521130, 521162, 521158, 520003, 521226, 520012, 520008, 521212,
        521250, 521245, 521101, 521181, 521109, 521165, 521403, 521190, 521175,
        520002, 521286, 521229, 521211, 520007, 520015, 521102, 521178, 520011,
        521163, 521182, 521151, 521185, 521230, 520010, 521227, 521180, 521456,
        521401, 521183, 521235, 520001, 521139, 521170, 521402, 521108, 521225,
        521256, 521104, 520004, 521241, 521247, 521246, 521228, 521457, 521164,
        521153, 521110, 520013, 521107, 521134, 521137,
      ],
      Nellore: [
        524342, 524129, 524405, 524121, 524131, 524345, 524132, 524404, 524407,
        524123, 524321, 524126, 524127, 524402, 524421, 524410, 524415, 524412,
        524309, 524414, 524343, 524403, 524134, 524341, 524320, 524406, 524408,
        524409, 524323, 524413, 524101, 524401, 524411, 524124, 524002, 524142,
        524318, 524312, 524203, 524152, 524315, 524303, 524302, 524344, 524225,
        524004, 524306, 524223, 524304, 524322, 524222, 524307, 524236, 524310,
        524226, 524228, 524003, 524230, 524240, 524319, 524346, 524305, 524221,
        524137, 524224, 524227, 524239, 524308, 524201, 524316, 524311, 524317,
        524313, 524234, 524314, 524301, 524366, 524001, 524005,
      ],
      Guntur: [
        522004, 522237, 522015, 522007, 522020, 522236, 522017, 522235, 522005,
        522112, 522503, 522302, 522018, 522502, 522002, 522001, 522508, 522305,
        522303, 522003, 522006, 522019, 522016, 522509, 522034, 522501, 522510,
        522009, 522402, 522612, 522647, 522659, 522617, 522415, 522529, 522410,
        522658, 522603, 522616, 522611, 522601, 522409, 522436, 522412, 522663,
        522411, 522549, 522613, 522408, 522626, 522437, 522661, 522615, 522435,
        522649, 522614, 522234, 522414, 522233, 522619, 522403, 522426, 522421,
        522657, 522413, 522660, 522646, 522438, 522401, 522439, 522102, 522262,
        522312, 522256, 522259, 522314, 522124, 522325, 522257, 522213, 522301,
        522211, 522310, 522316, 522309, 522306, 522261, 522101, 522268, 522265,
        522311, 522341, 522324, 522315, 522212, 522111, 522113, 522330, 522201,
        522313, 522304, 522264, 522258, 522308, 522307, 522202, 522317, 522329,
        522318,
      ],
      'East Godavari': [
        507130, 534315, 533577, 533252, 533247, 533216, 533211, 533217, 533201,
        533214, 533222, 533236, 533248, 533235, 533229, 533212, 533221, 533210,
        533228, 533215, 533213, 533250, 533244, 533240, 533223, 533274, 533251,
        533218, 533253, 533220, 533254, 533239, 533238, 533249, 533241, 533237,
        533242, 533408, 533449, 533401, 533428, 533407, 533448, 533436, 533406,
        533437, 533005, 533016, 533468, 533006, 533431, 533429, 533003, 533445,
        533433, 533483, 533450, 533444, 533432, 533446, 533344, 533461, 533002,
        533430, 533291, 533464, 533463, 533004, 533001, 533435, 533434, 533462,
        533447, 533260, 533440, 533262, 533288, 533233, 533101, 533305, 533284,
        533342, 533307, 533106, 533256, 533340, 533104, 533289, 533126, 533343,
        533263, 533285, 533290, 533124, 533292, 533296, 533295, 533261, 533286,
        533287, 533339, 533232, 533234, 533103, 533125, 533341, 533294, 533102,
        533297, 533105, 533107, 533309, 533293, 533346, 533345, 533306, 533264,
        533308, 533255,
      ],
      Visakhapatnam: [
        531022, 531027, 531115, 531077, 531035, 531040, 531030, 531002, 531117,
        531055, 531001, 531118, 531111, 531084, 531028, 531151, 531149, 531036,
        531034, 531031, 531011, 531029, 531085, 531021, 531113, 531082, 531023,
        531081, 531087, 531026, 531020, 531025, 531083, 531024, 531032, 531105,
        531133, 531061, 531114, 531126, 531075, 531127, 531019, 531033, 531060,
        531116, 530003, 530053, 530016, 531162, 530052, 531219, 530040, 530012,
        530044, 531163, 531173, 530047, 530002, 530020, 530043, 530031, 530029,
        530046, 530001, 530026, 530005, 530048, 530045, 530004, 530027, 530022,
        530007, 530008, 530017, 530011, 530018, 530009, 530014, 530013, 530041,
        530024, 530049, 530028, 530051, 530032, 530035, 530015, 535005, 535145,
        535250, 535273, 535183,
      ],
      Vizianagaram: [
        535547, 535502, 535546, 535124, 535573, 535126, 535523, 535557, 535525,
        535593, 535521, 535579, 535101, 535578, 535527, 535591, 535559, 535102,
        535128, 535558, 535594, 535524, 535463, 535526, 535125, 535534, 535592,
        535501, 535568, 535522, 532407, 532127, 532122, 531162, 535281, 535218,
        535216, 535240, 535204, 535250, 535003, 535280, 535273, 535005, 535161,
        535214, 535260, 535183, 535270, 535145, 535160, 535215, 535581, 535580,
        535217, 535002, 535006, 535004, 535148, 535220, 535221, 535213, 535001,
      ],
      Srikakulam: [
        532440, 532462, 535125, 532148, 532460, 535128, 532443, 532461, 532403,
        532127, 532203, 532186, 532219, 532459, 532190, 532425, 532445, 532426,
        532185, 532218, 532429, 532122, 532123, 532404, 532168, 532222, 532401,
        532409, 532264, 532457, 532455, 532406, 532263, 532456, 532322, 532290,
        532484, 532430, 532220, 532427, 532405, 532312, 532408, 532292, 532214,
        532195, 532284, 532212, 532432, 532216, 532242, 532458, 532402, 532421,
        532211, 532291, 532410, 532243, 532221, 532005, 532407, 532428, 532213,
        532215, 532474, 532001, 532201,
      ],
    },
    name: 'AP',
  },
  AR: {
    cities: {
      'Lower Dibang Valley': [792110],
      'East Siang': [791102, 791104, 791103],
      'Dibang Valley': [792101, 792110],
      'West Siang': [791001, 791101, 791125, 791003],
      Lohit: [792102, 792001, 792103, 792104, 792105, 792111],
      'Papum Pare': [
        791111, 791112, 791123, 792104, 791113, 791121, 791119, 791110, 791109,
        791001, 790001,
      ],
      Tawang: [790104, 790106, 790105],
      'West Kameng': [790002, 790114, 790001, 790116, 790101, 790102, 790003],
      'East Kameng': [790102, 790103],
      'Lower Subansiri': [791120, 791113, 791119],
      Changlang: [792056, 792120, 792122, 792055, 792103, 792121, 792123],
      Tirap: [792130, 792129, 792131],
      'Kurung Kumey': [791118],
      'Upper Siang': [791102, 791002, 791105],
      'Upper Subansiri': [791122],
    },
    name: 'AR',
  },
  AS: {
    cities: {
      Lakhimpur: [
        787032, 787054, 787052, 787031, 784165, 784161, 787055, 784163, 787053,
        787033, 787023, 784164, 787051, 784160, 787035, 787034, 787056, 787001,
      ],
      Dibrugarh: [
        785676, 786613, 786101, 786692, 786621, 786002, 786003, 786007, 786184,
        786610, 786611, 786004, 786191, 786103, 786612, 786010, 785675, 786102,
        786001, 786602, 786012, 786005, 786614, 786008, 786006, 786622, 786623,
        786183, 786189,
      ],
      Dhemaji: [
        787059, 787110, 787057, 787058, 787026, 787061, 787060, 787034, 787053,
        787035,
      ],
      Marigaon: [
        782412, 782103, 782410, 782105, 782121, 782127, 782411, 782104, 782106,
        782126, 782413, 782001,
      ],
      Nagaon: [
        782002, 782123, 782124, 782120, 782445, 782136, 782122, 782003, 782138,
        782425, 782435, 782446, 782442, 782103, 782140, 782144, 782102, 782141,
        782428, 782142, 782125, 782439, 782137, 782143, 782121, 782101, 782440,
        782135, 782426, 782481, 782460, 782429, 782427, 782447, 782001, 782139,
        782410, 785602,
      ],
      'Karbi Anglong': [
        782410, 782461, 782481, 782448, 782450, 782139, 782462, 782441, 782482,
        782470, 782425, 782447, 782490, 782480, 782485, 782460, 782486, 782446,
        782435, 782442,
      ],
      Golaghat: [
        785702, 785614, 785622, 785625, 785611, 785104, 785612, 785602, 785626,
        785603, 785618, 785615, 785691, 785613, 785619, 785610, 785705, 785601,
        785671, 785703, 785621, 785609, 785699,
      ],
      Sibsagar: [
        785663, 785690, 785664, 785697, 785681, 785680, 785682, 785696, 785674,
        785667, 785671, 785685, 785683, 785692, 785693, 785684, 785661, 785640,
        785701, 785691, 785687, 785670, 785689, 785673, 785705, 785688, 785672,
        785666, 785107, 785662, 785669, 785686, 785665, 785698, 785633, 785006,
        785614, 785602, 785616,
      ],
      Jorhat: [
        785108, 785013, 785106, 785101, 785633, 785107, 785009, 785635, 785004,
        785104, 785630, 785112, 785110, 785001, 785632, 785014, 785006, 785631,
        785703, 785105, 785616, 785010, 785102, 785008, 785015, 785700, 785634,
        785111, 785636, 785601, 785007, 785666, 785704,
      ],
      Tinsukia: [
        786171, 786174, 786187, 786181, 786157, 786160, 786154, 786170, 786189,
        786601, 786183, 786150, 786182, 786188, 786152, 786156, 786151, 786126,
        786146, 786179, 786192, 786125, 786190, 786173, 786145, 786147, 786158,
        786153, 786155, 786159,
      ],
      Karimganj: [
        788701, 788722, 788712, 788806, 788723, 788006, 788803, 788720, 788726,
        788728, 788710, 788713, 788781, 788725, 788733, 788727, 788724, 788166,
        788711, 788709, 788719, 788120,
      ],
      Hailakandi: [
        788161, 788150, 788164, 788156, 788734, 788801, 788162, 788155, 788152,
        788736, 788117, 788163, 788737, 788735, 788165, 788802, 788160, 788168,
      ],
      Cachar: [
        788101, 788030, 788004, 788119, 788009, 788025, 788011, 788115, 788113,
        788026, 788110, 788107, 788815, 788121, 788102, 788015, 788817, 788123,
        788120, 788010, 788099, 788114, 788126, 788005, 788116, 788002, 788007,
        788003, 788112, 788111, 788001, 788013, 788106, 788031, 788804, 788151,
        788805, 788127, 788816, 788104, 788098, 788006, 788108, 788109, 788103,
        788014, 788118,
      ],
      'North Cachar Hills': [
        788931, 788820, 788818, 788819, 788830, 788832, 788113, 788831, 788108,
      ],
      Darrang: [
        784524, 784510, 784514, 784148, 784527, 784529, 784522, 784145, 784146,
        784509, 784144, 784525, 784190, 784147, 784507, 784523, 784513, 784508,
        784528, 784113, 784114, 784116, 784526, 784115, 784125, 784521,
      ],
      Sonitpur: [
        784112, 784178, 784101, 784170, 784167, 784103, 784502, 784182, 784172,
        784175, 784174, 784027, 784171, 784117, 784154, 784153, 784149, 784506,
        784111, 784179, 784166, 784150, 784177, 784105, 784184, 784504, 784176,
        784110, 784501, 784169, 784505, 784180, 784168, 784104, 784001, 784189,
        784026, 784102, 784173, 784028, 784025, 784010,
      ],
      Bongaigaon: [
        783388, 783384, 783392, 783391, 783393, 783390, 783382, 783380, 783394,
        783383, 783389, 783373, 783385, 783134, 783381, 783360,
      ],
      Kokrajhar: [
        783346, 783337, 783360, 783345, 783350, 783347, 783332, 783372, 783336,
        783370, 783354, 783376, 783375, 783333, 783361, 783369, 783127,
      ],
      Goalpara: [
        783120, 783123, 783129, 783124, 783130, 783125, 783121, 783101, 783126,
        783122, 783134, 783132, 783133,
      ],
      Dhubri: [
        783335, 783330, 783323, 783339, 783331, 783349, 783334, 783348, 783131,
        783337, 783127, 783324, 783371, 783135, 783301, 783325, 783128, 783345,
        783388, 783383,
      ],
      Kamrup: [
        781128, 781137, 781102, 781127, 781025, 781023, 781026, 781031, 781014,
        781027, 781134, 781003, 781006, 781017, 781366, 781381, 781380, 781124,
        781103, 781141, 781021, 781364, 781354, 781101, 781030, 781382, 781104,
        781135, 781121, 781136, 781029, 781122, 781028, 781132, 781123, 781009,
        781365, 781018, 781015, 781120, 782402, 781150, 781133, 781376, 781011,
        781012, 781125, 782403, 782401, 781005, 781001, 781035, 781016, 781129,
        781038, 781036, 781039, 781032, 781013, 781019, 781010, 781022, 781004,
        781007, 781020, 781034, 781008, 781037, 781171, 781131, 781040, 781024,
        781350,
      ],
      Nalbari: [
        781126, 781372, 781373, 781369, 781306, 781367, 781343, 781344, 781360,
        781347, 781334, 781339, 781355, 781377, 781348, 781310, 781368, 781340,
        781378, 781341, 781349, 781312, 781303, 781375, 781346, 781351, 781333,
        781337, 781304, 781138, 781371, 781309, 781335, 781338, 781350, 781305,
        781329, 781370, 781353, 781374, 781317,
      ],
      Barpeta: [
        781329, 781316, 781325, 781317, 781307, 781318, 781327, 781308, 781328,
        781330, 781311, 781302, 781313, 781319, 781326, 781314, 781315, 781350,
        781301, 781309, 781305, 781352, 781321, 781367,
      ],
    },
    name: 'AS',
  },
  BR: {
    cities: {
      Begusarai: [
        851128, 851111, 848204, 851131, 848202, 851118, 851112, 851133, 851132,
        848201, 851113, 851116, 851129, 851217, 851211, 851114, 851115, 851101,
        851120, 851135, 851134, 851127, 851130, 851117, 851126, 851218, 851210,
        851215, 811106,
      ],
      Khagaria: [
        851216, 848203, 851214, 851205, 851203, 851204, 851213, 851212, 852161,
        851201, 851215, 851202, 853203, 811202,
      ],
      Darbhanga: [
        847121, 847304, 847115, 847427, 847201, 847203, 847405, 847233, 847101,
        847103, 847106, 847105, 847104, 846007, 846005, 846002, 847337, 847422,
        847428, 847303, 847423, 846003, 847306, 847122, 847123, 847204, 847307,
        846004, 847301, 846009, 847302, 847407, 846001, 846008, 847429, 847107,
        846006, 847239, 847102, 847424, 852216, 848209, 848213, 848506, 848205,
        848207,
      ],
      Madhubani: [
        847303, 847122, 847230, 847402, 847234, 847401, 847109, 847222, 847108,
        847308, 847215, 847224, 847409, 847226, 847239, 847223, 847408, 847227,
        847102, 847411, 847228, 847421, 847225, 847212, 847305, 847236, 847403,
        847452, 847404, 847410, 847235, 847231, 847240, 847229, 847232, 847238,
        847213, 847424, 847214, 847211,
      ],
      Muzaffarpur: [
        847107, 847307, 843113, 842002, 843118, 843125, 843111, 843104, 843123,
        843119, 842001, 843103, 843129, 844120, 843128, 843312, 843109, 843105,
        843121, 843117, 842004, 843120, 843127, 844112, 843112, 843101, 843321,
        843115, 843102, 844127, 843122, 842003, 843126, 843108, 843107, 843106,
        843124, 843130, 843143, 843146, 842005, 844111, 844118,
      ],
      Samastipur: [
        847301, 847105, 848130, 848205, 848505, 848209, 848132, 848127, 848114,
        848502, 848236, 848210, 848101, 848506, 848504, 848160, 848501, 848117,
        848125, 848207, 848206, 848102, 848503, 848302, 848134, 848208, 848211,
        848216, 848129, 848113, 848115, 848122, 848301, 848121, 848133, 848213,
        848131, 844506, 844501,
      ],
      Sitamarhi: [
        847307, 847302, 843360, 843351, 843302, 843334, 843324, 843330, 843313,
        843311, 843314, 843323, 843320, 843333, 843317, 843325, 843319, 843327,
        843332, 843331, 843326, 843328, 843315, 843316, 843318, 843322, 843301,
      ],
      'East Champaran': [
        845301, 845413, 845417, 845433, 845401, 845428, 845303, 845411, 845429,
        845415, 845435, 845315, 845437, 845418, 845456, 845436, 845434, 845424,
        845457, 845412, 845422, 845304, 845426, 845302, 845420, 845416, 845305,
        845423, 845427, 845425, 845432, 845406, 845430, 845414, 845419, 845458,
        845440, 845431,
      ],
      Supaul: [
        847452, 847451, 847408, 852138, 852109, 852218, 852108, 852105, 852214,
        852139, 852131, 852123, 852215, 852130, 854339, 854340, 852110, 852125,
        854338, 852137, 852111,
      ],
      Vaishali: [
        844112, 843102, 844120, 843114, 844123, 844126, 843110, 844125, 844506,
        844113, 844111, 844103, 844505, 844114, 844504, 844502, 844124, 844509,
        844503, 844122, 844501, 844118, 844102, 844116, 844508, 844115, 844128,
        844117, 844119, 844507, 844101, 844121,
      ],
      Purnia: [
        854330, 854327, 854204, 854102, 854205, 854316, 854315, 854202, 854303,
        854325, 854201, 854203, 854326, 854317, 854304, 854337, 854301, 854306,
        854305, 854113, 854333, 854335, 854302, 853204,
      ],
      Araria: [
        854336, 854332, 854318, 854311, 854312, 854334, 854329, 854333, 854335,
        854316, 854102, 854325, 854331, 854328,
      ],
      Katihar: [
        854317, 854112, 855114, 855102, 854101, 855113, 854113, 854106, 855105,
        854116, 854115, 854114, 854107, 854104, 854108, 854103, 854117, 854105,
        854335, 854109, 853204,
      ],
      Kishanganj: [855107, 855115, 855108, 855101, 855116, 855117, 855106],
      Madhepura: [
        852213, 852116, 852122, 852115, 852121, 852112, 852219, 852128, 852132,
        852101, 852114, 852113, 852127, 852218, 852124, 852220, 852202, 852108,
        853204, 813204,
      ],
      Saharsa: [
        852216, 852221, 852126, 852202, 852217, 852124, 852123, 852127, 852106,
        852212, 852107, 852129, 852116, 852201, 852121,
      ],
      Saran: [
        841207, 841414, 841411, 841421, 841208, 841401, 841219, 841213, 841402,
        841221, 841424, 841417, 841224, 841442, 841204, 841412, 841419, 841215,
        841101, 841205, 841403, 841206, 841212, 841201, 841202, 841410, 841301,
        841311, 841460, 841214, 841415, 841225, 841209, 841211, 841216, 841217,
        841313, 841305, 841316, 841222, 841312, 841443, 841422, 841220, 841218,
        841418, 841223, 841302,
      ],
      Siwan: [
        841223, 841422, 841417, 841504, 841439, 841239, 841286, 841234, 841226,
        841231, 841203, 841236, 841287, 841243, 841506, 841241, 841404, 841406,
        841244, 841237, 841238, 841435, 841245, 841227, 841408, 841232, 841235,
        841210, 841507, 841434, 841240, 841416, 841242, 841233, 841509, 841502,
        841446,
      ],
      Bhojpur: [
        841312, 802202, 802201, 802156, 802155, 802352, 802161, 802154, 802302,
        802222, 802301, 802210, 802203, 802163, 802158, 802207, 802164, 802166,
        802311, 802351, 802312, 802183, 802206, 802209, 802165, 802208, 802152,
        802205, 802314, 802223, 802159, 802157, 802204, 802160, 802313, 802162,
        802316,
      ],
      Sheohar: [843334, 843329, 843325, 843317, 843316, 843313],
      Gopalganj: [
        841405, 841436, 841426, 841423, 841428, 841438, 841508, 841441, 841409,
        841503, 841501, 841425, 841437, 841413, 841427, 841407, 841420, 841440,
        841505,
      ],
      'West Champaran': [
        845459, 845438, 845455, 845450, 845101, 845103, 845452, 845307, 845106,
        845454, 845449, 845105, 845104, 845451, 845453, 845306, 845107, 845102,
      ],
      Gaya: [
        824207, 824221, 824220, 824219, 824116, 824217, 824205, 824210, 824201,
        824211, 824206, 824113, 823001, 804403, 824233, 804421, 824232, 823003,
        824231, 804423, 824236, 823005, 823311, 805135, 823004, 804402, 824237,
        823002, 804404, 824235, 824118, 804419, 804428, 804401, 805236, 804430,
        824209, 804426, 824234, 804435, 804424, 805131, 805128, 805129, 805109,
      ],
      'Aurangabad(BH)': [
        824143, 824103, 824203, 824113, 824111, 824124, 824303, 824116, 824123,
        824120, 824202, 824125, 824101, 824102, 824301, 824302, 824122, 824114,
        824112, 824127, 824208, 824129, 824121, 824115, 824219, 824216, 824207,
      ],
      Arwal: [824115, 824127, 804401, 804402, 804419, 804427],
      Bhagalpur: [
        853204, 812001, 813213, 813210, 813222, 812006, 812005, 853201, 813108,
        813209, 813204, 812004, 853202, 813105, 853203, 813205, 812003, 812002,
        813203, 853205, 813221, 813113, 813206, 813214, 813101, 813212, 812007,
        811211,
      ],
      Banka: [
        813101, 813110, 813103, 813104, 813207, 813221, 813106, 813102, 813107,
        814131, 813202, 813211, 813109, 813205, 813201, 813105, 813108, 813212,
        811308,
      ],
      Munger: [
        813201, 813103, 813221, 813207, 813212, 813211, 853204, 813110, 811211,
        811212, 811202, 811213, 811201, 811214, 811311,
      ],
      Buxar: [
        802116, 802114, 802126, 802111, 802119, 802135, 802129, 802123, 802134,
        802130, 802128, 802133, 802120, 802113, 802112, 802117, 802103, 802101,
        802102, 802125, 802115, 802313, 802122, 802118, 802136, 802131, 802127,
      ],
      Jehanabad: [
        804426, 804425, 804405, 804419, 804432, 804417, 804423, 804428, 804422,
        804407, 804418, 804429, 804427, 824232, 804424, 804406, 804420, 804408,
        804434, 824118, 804421, 824235,
      ],
      Patna: [
        804406, 804426, 811302, 811104, 803213, 803214, 801304, 803211, 803303,
        803306, 803212, 803110, 803307, 803302, 803301, 803221, 801305, 801103,
        801109, 801110, 801108, 801507, 801102, 804453, 801104, 800012, 801505,
        803203, 803202, 801113, 800002, 800025, 800020, 801503, 800001, 800022,
        800026, 801501, 800017, 804454, 800014, 804451, 800007, 801111, 800004,
        803201, 801112, 804452, 800018, 800009, 800019, 800008, 801506, 800011,
        800003, 800024, 801105, 800023, 800016, 800006, 800027, 800029, 800013,
        800028, 800015, 800005, 800010, 800021,
      ],
      Sheikhpura: [
        811105, 811304, 811103, 811101, 811315, 811107, 811201, 811102,
      ],
      Jamui: [
        811301, 811314, 811317, 811313, 811312, 811315, 811303, 811305, 811308,
        811316, 811307, 811311,
      ],
      Lakhisarai: [
        811112, 811106, 811309, 811311, 811302, 811107, 811304, 811310, 811201,
        811315,
      ],
      Nalanda: [
        811101, 811103, 811104, 811102, 801303, 803107, 803114, 803120, 801305,
        801302, 803101, 803119, 801307, 803113, 803118, 801301, 803110, 803108,
        801304, 803117, 803111, 803116, 803216, 803115, 801306, 803215, 803121,
        803213, 805105, 803109, 805130,
      ],
      Nawada: [
        803109, 805123, 805125, 805122, 805108, 805109, 805124, 805129, 805132,
        805111, 805126, 805103, 805121, 805101, 805130, 805104, 805107, 805102,
        805127, 805128, 805106, 805112, 805110, 805133, 805141,
      ],
      Rohtas: [
        802226, 821312, 802213, 821301, 821113, 821104, 821309, 821310, 821302,
        802214, 821107, 802218, 802211, 802215, 802216, 821311, 821303, 821111,
        821306, 821305, 821304, 802217, 802220, 802212, 802219, 821112, 821307,
        821115, 802221, 821308, 821108,
      ],
      'Kaimur (Bhabua)': [
        821102, 802132, 821101, 821108, 821109, 821106, 821103, 821110, 821105,
        821104, 802213, 802218,
      ],
    },
    name: 'BR',
  },
  CG: {
    cities: {
      // Chandigarh: [
      //   140119, 160003, 160004, 140125, 160036, 160047, 160017, 160014, 160101,
      //   160012, 160018, 160002, 160001, 140133, 160025, 160102, 160019, 160011,
      //   160015, 160020, 160022, 160023, 160030, 160009,
      // ],

      Bilaspur: [495001],
      Raipur: [
        492001, 492002, 492004, 492005, 492006, 492007, 492008, 492009, 492010,
        492012, 492013, 492014, 492015, 492016, 492017, 492018, 492019, 492020,
        492021, 492022, 492023, 492024, 492025, 492026, 492027, 492028, 492101,
        492102, 492103, 492104, 492105, 492106, 492108, 492109, 492110, 492111,
        492112, 492113, 492114, 492115, 492116, 492117, 492118, 492150, 492332,
        492336, 493111, 493118, 493195, 493196,
      ],
      Durg: [
        491001, 491002, 491003, 491004, 491005, 491006, 491007, 491008, 491009,
        491010, 491011, 491012, 491013, 491014, 491015, 491016, 491017, 491018,
        491019, 491020, 491021, 491022, 491023, 491024, 491025, 491026, 491027,
        491028, 491029, 491030, 491031, 491032, 491033, 491034, 491035, 491036,
        491037, 491038, 491040, 491041, 491042, 491043, 491044, 491045, 491046,
        491048, 491051, 491052, 491053, 491054, 491055, 491056, 491057, 491058,
        491059, 491060, 491089, 491105, 491107, 491108, 491110, 491111, 491113,
        491114, 491115, 491116, 491117, 491118, 491227, 491228, 491235, 491242,
        491334,
      ],
      Bhilai: [
        490001, 490005, 490006, 490009, 490010, 490011, 490012, 490013, 490014,
        490015, 490016, 490017, 490018, 490019, 490020, 490021, 490022, 490023,
        490026, 490027, 490031, 490032, 490033, 490034, 490036, 490037, 490038,
        490040, 490041, 490042, 490043, 490044, 490045, 490046, 490047, 490048,
        490049, 490050, 490051, 490052, 490053, 490054, 490055, 490056, 490057,
        490058, 490060, 490061, 490062, 490063, 490064, 490065, 490066, 490067,
        490068, 490069, 490070, 490071, 490072, 490073, 490074, 490075, 490076,
        490077, 490078, 490079, 490080, 490081, 490082, 490083, 490084, 490085,
        490086, 490087, 490088, 490089, 490090, 490091, 490092, 490093, 490094,
        490095, 490096, 490097, 490098, 490099, 490001, 490101, 490102, 490103,
        490104, 490105, 490106, 490107, 490108, 490109, 490110, 490111, 490115,
        490116, 490131, 490136, 490150, 490151, 490154, 490156, 490157, 490159,
        490200, 490204, 490206, 490210, 490213, 490214, 490220, 490233, 490234,
        490236, 490237, 490238, 490240, 490241, 490246, 490260, 490269, 490271,
        490273, 490279, 490290, 490294, 490293, 490001, 491001,
      ],
    },
    name: 'CG',
  },
  CH: { cities: {}, name: 'CH' },
  DH: {
    cities: {
      Diu: [362520, 362520, 362520, 362520],
      Daman: [
        396210, 396210, 396215, 396215, 396220, 396220, 396191, 396191, 396210,
        396210, 396215, 396215,
      ],
      Silvassa: [396230, 396230],
    },
    name: 'DH',
  },
  DN: { cities: {}, name: 'DN' },
  DD: { cities: {}, name: 'DD' },
  DL: {
    cities: {
      'East Delhi': [
        110092, 110051, 110090, 110032, 110053, 110091, 110095, 110031, 110096,
        110094, 110093,
      ],
      'North East Delhi': [110032, 110053, 110094, 110093, 110090],
      'North West Delhi': [
        110094, 110033, 110036, 110034, 110052, 110039, 110042, 110040, 110086,
        110081, 110009, 110035, 110088, 110082, 110083, 110085, 110056, 110089,
      ],
      'North Delhi': [110006, 110054, 110085, 110084, 110007],
      'Central Delhi': [
        110002, 110055, 110005, 110001, 110008, 110003, 110006, 110012, 110011,
        110060, 110004, 110069,
      ],
      'New Delhi': [110001, 110020, 110029],
      'South Delhi': [
        110025, 110062, 110019, 110076, 110003, 110024, 110049, 110044, 110020,
        110013, 110017, 110065, 110048, 110014, 110080,
      ],
      'South West Delhi': [
        110010, 110038, 110021, 110029, 110047, 110061, 110074, 110030, 110016,
        110037, 110068, 110067, 110097, 110023, 110070, 110066, 110022, 110057,
        110075, 110071, 110077, 110043, 110072, 110045, 110073, 110028, 110078,
        110064, 110046,
      ],
      'West Delhi': [
        110018, 110026, 110041, 110059, 110058, 110015, 110078, 110064, 110027,
        110063, 110087, 110077,
      ],
    },
    name: 'DL',
  },
  GA: {
    cities: {
      'South Goa': [
        403801, 403401, 403702, 403705, 403723, 403107, 403601, 403714, 403701,
        403802, 403703, 403704, 403716, 403713, 403409, 403806, 403706, 403718,
        403712, 403717, 403731, 403711, 403715, 403410, 403708, 403710, 403115,
        403709, 403707, 403725, 403602, 403728, 403404, 403803, 403729, 403724,
        403720, 403804, 403106, 403719, 403406, 403721, 403105, 403722, 403726,
      ],
      'North Goa': [
        403503, 403530, 403512, 403508, 403521, 403509, 403524, 403516, 403507,
        403201, 403202, 403101, 403107, 403529, 403504, 403506, 403001, 403523,
        403510, 403406, 403515, 403110, 403002, 403505, 403006, 403102, 403513,
        403206, 403108, 403403, 403527, 403104, 403404, 403109, 403114, 403004,
        403517, 403105, 403203, 403401, 403501, 403511, 403005, 403103, 403502,
        403204, 403526, 403402,
      ],
    },
    name: 'GA',
  },
  GJ: {
    cities: {
      Ahmedabad: [
        380006, 380058, 380026, 380007, 380016, 380024, 380009, 382427, 380015,
        382430, 382210, 382425, 380022, 380028, 382433, 382330, 380054, 380004,
        382424, 380019, 380001, 380008, 382435, 380027, 380061, 380050, 380021,
        382405, 382443, 380051, 380055, 380005, 382350, 382345, 382340, 380052,
        380002, 380013, 380014, 382415, 380023, 382480, 380018, 382475, 380063,
        382418, 382440, 382120, 382220, 382460, 382250, 382245, 382255, 382225,
        382463, 382115, 382230, 382150, 382140, 382260, 382170, 382240, 382145,
        382450, 382455, 380060, 382465, 382481, 382213, 382110, 382130, 382470,
        382265, 382449, 382445, 382421, 382315, 380059, 383345,
      ],
      'Gandhi Nagar': [
        382433, 382424, 382016, 382021, 382024, 382028, 382030, 382006, 382007,
        382421, 382640, 382810, 382042, 382721, 382845, 382735, 382305, 382855,
        382308, 382355, 382428, 382422, 382045, 382321, 382729, 382740, 382315,
        382320, 382010, 380060, 382423, 382725, 382835, 382610, 382620, 382630,
        382041, 382650,
      ],
      Banaskantha: [
        385555, 385535, 385566, 385545, 385110, 385010, 385575, 385565, 385410,
        385520, 385320, 385530, 385135, 385210, 385570, 385505, 385560, 385001,
        385120, 385510, 385421, 385310, 385330, 385550, 385130, 385515, 385540,
        385506,
      ],
      Mahesana: [
        382170, 382120, 382115, 382728, 382715, 382870, 382165, 384170, 382710,
        384205, 384210, 382732, 384435, 384335, 384330, 384410, 384355, 384325,
        384120, 384001, 384315, 382705, 384421, 384130, 384215, 382730, 382865,
        384305, 382830, 384360, 382860, 384212, 384012, 382815, 382820, 382825,
        384140, 384430, 384310, 382850, 382840, 384002, 384003, 384340, 384345,
        384320, 384160, 384260,
      ],
      'Surendra Nagar': [
        382130, 360055, 382775, 382780, 363330, 382745, 363520, 363425, 363110,
        363421, 363040, 363030, 382765, 363310, 363510, 363320, 363410, 363423,
        363415, 382750, 363115, 363530, 363440, 382755, 363351, 363430, 363435,
        363427, 363020, 382760, 363001, 363002, 363035,
      ],
      Patan: [
        385360, 384285, 384245, 384255, 384265, 385340, 384240, 384110, 384272,
        384151, 384246, 384275, 384220, 384241, 385350, 384225, 384221, 384230,
        384290, 384229, 384260,
      ],
      Sabarkantha: [
        383460, 383240, 383250, 383276, 383001, 383270, 383422, 383260, 383325,
        383246, 383307, 383210, 383315, 383330, 383310, 383215, 383305, 383345,
        383410, 383251, 383110, 383225, 383235, 383335, 383434, 383255, 383462,
        383205, 383350, 383430, 383316, 383245, 383440, 383230, 383421, 383340,
        383006, 383317, 383120, 383275, 383320, 383220, 383355, 383030, 383010,
        383450,
      ],
      Amreli: [
        364522, 365430, 365450, 365535, 365630, 365220, 365601, 365660, 364521,
        365635, 365620, 365480, 365610, 365540, 365421, 365560, 365440, 365456,
        365460, 365545, 365435, 365565, 365650, 362730, 365645, 364530, 364525,
        365640, 365410, 365555, 364515, 365550, 365455, 365541,
      ],
      Rajkot: [
        365480, 360055, 360360, 364485, 360311, 360490, 360070, 360030, 360450,
        360040, 360050, 360330, 360452, 360421, 360410, 360405, 364490, 360370,
        360035, 360430, 364465, 360460, 364470, 360440, 360320, 360480, 360380,
        360470, 360375, 360110, 363621, 360003, 363641, 360060, 363650, 360025,
        363642, 363660, 360021, 360022, 360020, 363630, 363670, 360005, 360002,
        360023, 360006, 360004, 360024, 360007, 360001,
      ],
      Junagadh: [
        365440, 360490, 362720, 362255, 362222, 362229, 362268, 362150, 362245,
        362220, 362140, 362260, 362565, 362560, 362715, 362263, 362215, 362510,
        362250, 362725, 362610, 362030, 362110, 362120, 362020, 362310, 362130,
        362710, 362135, 362315, 362266, 362275, 362002, 362205, 362037, 362530,
        362227, 362550, 362011, 362269, 362015, 362001, 362004, 362276, 362265,
        362240, 362625, 362620, 362640, 362630, 362225, 362650, 362230, 362226,
        362235,
      ],
      Bhavnagar: [
        364530, 364002, 364765, 364260, 364320, 364081, 364210, 364310, 364270,
        364740, 364760, 364510, 364145, 364710, 364280, 364150, 364290, 364313,
        364720, 364240, 364295, 364505, 364050, 364120, 364005, 364004, 364001,
        364006, 364003, 364060, 364110, 364230, 364750, 364130, 364330, 364140,
        364265, 364730, 364275, 364250, 364070, 364135,
      ],
      Jamnagar: [
        360480, 360490, 361003, 361110, 363655, 360515, 361305, 361006, 361162,
        361280, 361345, 361170, 361160, 361325, 361250, 361230, 361240, 360530,
        360540, 361013, 361315, 361120, 361335, 361002, 361009, 361310, 361011,
        361330, 361306, 360510, 361010, 361220, 360520, 361320, 361012, 361130,
        361210, 361005, 361140, 361001, 361007, 360531, 361008, 361350, 361142,
        361141, 361347, 361004, 361150, 360590, 360110,
      ],
      Porbandar: [
        360490, 360510, 360530, 360545, 360590, 360570, 360560, 362620, 360579,
        362230, 360576, 360550, 362650, 360578, 360575, 360577,
      ],
      Kachchh: [
        370421, 370155, 370135, 370205, 370655, 370605, 370511, 370150, 370140,
        370610, 370165, 370675, 370110, 370665, 370645, 370485, 370105, 370602,
        370475, 370145, 370650, 370427, 370620, 370020, 370660, 370415, 370455,
        370405, 370465, 370625, 370410, 370001, 370130, 370030, 370240, 370160,
        370510, 370450, 370015, 370435, 370430, 370445, 370630, 370040, 370627,
        370490, 370201, 370601, 370640, 370670, 370230, 370210, 370425, 370460,
        370615, 370115, 370203,
      ],
      Anand: [
        388305, 388130, 388210, 388310, 388360, 388543, 388307, 388001, 388110,
        388510, 388205, 388315, 388520, 388220, 388320, 388530, 388540, 388560,
        388365, 388345, 388370, 388325, 388545, 388350, 388330, 388335, 388235,
        388340, 388355, 388306, 388215, 388120, 388121, 388570, 388160, 388450,
        388550, 387240, 388580, 387345, 388430, 388640, 388140, 387310, 388620,
        388180, 387210, 388610, 388625, 388440, 388480, 388460, 388590, 388170,
        388630, 387220, 388150, 388465, 387710, 388470,
      ],
      Kheda: [
        388230, 388225, 388265, 388250, 388255, 388260, 388220, 388215, 388235,
        388245, 388239, 387335, 387650, 387610, 387355, 387430, 387305, 387510,
        387115, 387620, 387130, 387630, 387365, 387570, 387320, 387530, 387001,
        387635, 388180, 388410, 387380, 387370, 387120, 387002, 387350, 388140,
        387315, 387560, 388421, 387640, 387330, 387710, 387210, 387540, 387550,
        387110, 387360, 387325, 387520, 387411, 387340, 387345, 387230, 387375,
        388440,
      ],
      Surat: [
        394150, 394620, 394651, 394355, 394246, 394365, 394350, 394163, 394641,
        394352, 394633, 394250, 394380, 396510, 394630, 394635, 394325, 394170,
        394320, 394375, 394305, 394690, 394340, 394317, 394655, 394335, 394310,
        394715, 394601, 394240, 394360, 394650, 394680, 394640, 394370, 394248,
        394140, 394670, 394660, 394160, 394330, 394180, 394245, 394155, 394315,
        394326, 394327, 394185, 394190, 394716, 394345, 392150, 393130, 393050,
        393125, 395008, 395007, 395009, 394516, 395003, 395017, 394430, 395005,
        394107, 394110, 394410, 394405, 394540, 395001, 394130, 394440, 394210,
        394530, 394125, 394510, 394517, 395023, 394421, 394550, 394445, 395010,
        394230, 395004, 395012, 394270, 395002, 394235, 394111, 394520, 394120,
        395006, 394515, 394101, 394518, 394221, 395011, 395013, 394105,
      ],
      'The Dangs': [394710, 394730, 394720, 394716, 394715],
      Tapi: [
        394651, 394630, 394635, 394633, 394655, 394380, 394365, 394375, 394680,
        394641,
      ],
      Navsari: [
        394730, 396403, 396406, 396040, 396445, 396060, 396360, 396409, 396521,
        396310, 396580, 396540, 396469, 396325, 396475, 396415, 396433, 396439,
        396590, 396427, 396436, 396110, 396321, 396560, 396412, 396472, 396570,
        396530, 396460, 396466, 396380, 396430, 396450, 396350, 396418, 396421,
        396424, 396370, 396440, 396463, 396051,
      ],
      Vadodara: [
        392110, 392030, 393002, 393130, 393105, 392012, 393041, 392150, 392220,
        392140, 392130, 392160, 392180, 393010, 392210, 392015, 388710, 391250,
        391121, 390019, 391145, 391150, 391135, 390022, 391175, 391165, 391115,
        391110, 391107, 391160, 391168, 391170, 391140, 391125, 390001, 391105,
        391152, 391130, 390009, 390004, 390014, 390006, 391155, 390018, 390010,
        390013, 390011, 390025, 391156, 390017, 391421, 391510, 391740, 390020,
        390007, 391760, 391445, 391101, 391761, 391240, 391330, 391775, 391745,
        391244, 390012, 391310, 391243, 391780, 391410, 391520, 391440, 390003,
        391530, 390024, 391210, 391430, 391450, 391774, 391346, 391340, 390008,
        391750, 390002, 391770, 390016, 391320, 391220, 392310, 391350, 391345,
        390023, 390021,
      ],
      Bharuch: [
        392240, 392110, 392130, 394115, 392150, 393025, 393041, 393030, 393110,
        392012, 393010, 393130, 393001, 392025, 394810, 393120, 393017, 392001,
        392155, 393125, 393135, 392210, 392035, 392140, 392230, 392020, 393040,
        392170, 392040, 393020, 391810, 392165, 393155, 393115, 392011, 392135,
        392220, 392015, 393151, 392160, 392180, 392030, 393150, 394116, 393050,
        393145, 392215, 394120,
      ],
      Narmada: [
        393130, 393050, 393140, 393151, 394810, 393120, 393025, 393040, 393145,
        393155, 393041, 392020, 393115, 393150, 392170, 393135, 393125, 393110,
        392040, 393020, 393105, 392025, 391810, 392150, 393001, 391121, 391120,
        391110,
      ],
      Dahod: [
        389130, 389152, 389190, 389140, 389175, 389382, 389154, 389180, 389380,
        389170, 389172, 389160, 389155, 389110, 389151, 389146,
      ],
      'Panch Mahals': [
        389341, 388270, 389115, 389310, 389380, 389001, 389240, 389210, 389110,
        389350, 389232, 389260, 389120, 389365, 389230, 389370, 389180, 389320,
        389340, 389360, 389330, 389250, 388713, 389220, 389390, 389002, 388710,
        389265, 389235, 389190, 389172,
      ],
      Valsad: [
        396105, 396065, 396051, 396145, 396191, 396230, 396126, 396125, 396155,
        396055, 396235, 396050, 396007, 396045, 396020, 396185, 396030, 396385,
        396165, 396195, 396170, 396001, 396375, 396130, 396193, 396140, 396120,
        396115, 396240, 396135, 396150, 396180, 396171, 396002, 396035,
      ],
    },
    name: 'GJ',
  },
  HR: {
    cities: {
      Ambala: [
        133001, 134003, 133205, 134203, 133202, 133005, 134007, 133004, 133201,
        134118, 134201, 133101, 133102, 133203, 134202, 134204, 133006, 134005,
        133104, 133207,
      ],
      Chandigarh: [
        140119, 160003, 160004, 140125, 160036, 160047, 160017, 160014, 160101,
        160012, 160018, 160002, 160001, 140133, 160025, 160102, 160019, 160011,
        160015, 160020, 160022, 160023, 160030, 160009,
      ],
      'Yamuna Nagar': [
        135133, 135101, 135002, 133206, 135021, 135103, 135003, 135102, 133103,
        135001, 135106, 133204, 135004,
      ],
      Panchkula: [
        133301, 134202, 134118, 134102, 134203, 134205, 134104, 134107, 134109,
        134108, 134204, 134101, 134103, 134113, 133302, 134114, 134112, 134117,
        134116,
      ],
      Bhiwani: [
        127307, 127308, 127030, 127026, 127025, 127310, 127031, 127111, 127032,
        127021, 127201, 127045, 127028, 127041, 127043, 127035, 127046, 127029,
        127022, 127027, 127040, 127306, 127309, 127114, 127042,
      ],
      Faridabad: [
        121102, 121106, 121101, 121003, 121004, 121105, 121107, 121002, 121103,
        121007, 121001, 121005, 121008, 121006, 121010, 121013, 121012, 121009,
      ],
      Gurgaon: [
        122104, 122005, 122107, 122001, 122508, 122101, 122105, 122006, 122503,
        122108, 122505, 122103, 122102, 122413, 122017, 122002, 122502, 122008,
        122010, 122016, 123106, 122506, 122009, 122003, 122011, 122018, 122504,
        122052, 122414, 122007, 123401, 122051, 122004, 122015,
      ],
      Rewari: [
        123102, 123035, 123401, 123021, 123412, 123501, 123411, 123103, 123101,
        123302, 123106, 123034, 123301, 123110, 123303,
      ],
      Mahendragarh: [
        123023, 123029, 123501, 123001, 123021, 123027, 123028, 123024, 123034,
        123303, 123411, 123412,
      ],
      Hisar: [
        125033, 125047, 125004, 125001, 125007, 125011, 125042, 125121, 125005,
        125112, 125044, 125039, 125038, 125113, 125052, 125006, 125049, 125120,
        125037, 125051,
      ],
      Sirsa: [
        125104, 125055, 125078, 125102, 125101, 125054, 125075, 125060, 125103,
        125077, 125110, 125201, 125058, 125076, 125056,
      ],
      Fatehabad: [
        125051, 125050, 125106, 125052, 125048, 125111, 125053, 125113, 125120,
        125133,
      ],
      Karnal: [
        132024, 132157, 132040, 132039, 132117, 132037, 132036, 132023, 132114,
        132116, 132054, 132041, 132001, 132046, 132022,
      ],
      Panipat: [
        132113, 132107, 132103, 132105, 132122, 132104, 132140, 132101, 132102,
        132106, 132108, 132145, 132115,
      ],
      Jind: [
        126102, 126111, 126116, 126112, 126113, 126152, 126125, 126110, 126115,
        126114, 126101,
      ],
      Kaithal: [
        136035, 136021, 136034, 136117, 136043, 136027, 136026, 136044, 136020,
        136042, 136033,
      ],
      Kurukshetra: [
        136130, 136136, 136038, 136156, 136119, 136132, 136128, 136030, 136131,
        136118, 136135, 136129,
      ],
      Jhajjar: [
        124106, 124108, 124146, 124103, 124505, 124105, 124201, 124507, 124508,
        124142, 124104, 124107, 124109, 124102, 124504, 124202, 124404, 124506,
        124501,
      ],
      Rohtak: [
        124111, 124411, 124406, 124021, 124501, 124022, 124514, 124010, 124401,
        124303, 124112, 124001, 124412, 124113, 124404, 124513, 124141,
      ],
      Sonipat: [
        131101, 131301, 131103, 131409, 131027, 131023, 131001, 131403, 131021,
        131102, 131304, 131402, 131039, 131022, 131302, 131024, 131306, 131408,
        131305, 131028, 131029,
      ],
    },
    name: 'HR',
  },
  HP: {
    cities: {
      Chamba: [
        176316, 176312, 176313, 176314, 176324, 176303, 176325, 176309, 176311,
        176301, 176321, 176302, 176306, 176318, 176308, 176320, 176315, 176207,
        176323, 176310, 176319, 176305, 176304, 176317,
      ],
      Kangra: [
        176036, 177034, 176031, 176027, 176501, 176054, 176209, 177103, 176208,
        176047, 176037, 176029, 176028, 177114, 177104, 176051, 176502, 176055,
        176025, 176022, 177117, 176214, 177112, 177105, 177111, 176023, 176021,
        177043, 176026, 176033, 176001, 177113, 176056, 177106, 176038, 177101,
        176030, 176053, 177108, 176066, 177107, 176032, 176058, 176082, 176103,
        176217, 176102, 176059, 176094, 176083, 176204, 176062, 176202, 176107,
        176081, 176201, 176225, 176125, 176205, 176086, 176073, 176098, 176403,
        176064, 176084, 176061, 176097, 176101, 176200, 176219, 176206, 176401,
        176210, 176076, 176088, 176402, 176087, 176071, 176077, 176092, 176128,
        176203, 176052, 176216, 176060, 176057, 176215, 176096, 176075, 176065,
        176085, 176211, 176115, 176091, 176095, 176213, 176218, 176093, 176089,
        176063, 177033, 175013, 177110,
      ],
      'Bilaspur (HP)': [
        177114, 174021, 174024, 174029, 174031, 174003, 174001, 174013, 174027,
        174002, 174012, 174015, 174201, 174035, 174004, 174028, 174026, 174023,
        174032, 174034, 174030, 174017, 174011, 174310, 174033, 174036, 174005,
      ],
      'Hamirpur(HP)': [
        176041, 177501, 177020, 177024, 177601, 176048, 177040, 177029, 177021,
        177026, 177118, 174309, 177028, 177048, 176040, 174305, 177022, 174304,
        177044, 176049, 177023, 177001, 176042, 177301, 174312, 177042, 177041,
        177033, 176108, 177038, 176045, 177119, 176110, 177007, 176039, 176111,
        174505, 177401, 177025, 174405, 177005, 176109, 176043, 177027, 174311,
        176044, 177006, 177045,
      ],
      Una: [
        177041, 174301, 177203, 174314, 177204, 177205, 174307, 177109, 174306,
        177209, 177201, 174302, 174303, 174321, 177220, 176601, 174317, 177213,
        177110, 174315, 174316, 177039, 174308, 177210, 177031, 177211, 177212,
        174319, 177208, 177207, 177219, 174503, 177206, 177202, 174507, 174320,
      ],
      Mandi: [
        175032, 175001, 175009, 175121, 175034, 175028, 175035, 175027, 175011,
        175033, 175038, 175012, 175015, 175016, 175106, 175052, 175008, 175124,
        175029, 175024, 175013, 175040, 175030, 175021, 175036, 175042, 175005,
        175017, 175006, 175049, 175004, 175003, 175002, 175047, 175050, 175031,
        175018, 175048, 176090, 175037, 175010, 175025, 175014, 175123, 175023,
        175026, 175007, 175039, 175125, 175019, 175046, 175134, 175051, 175141,
      ],
      Kullu: [
        175101, 175123, 175104, 175138, 175103, 175134, 175125, 175128, 175129,
        175105, 175102, 175131, 175106, 175141, 175136, 175143, 175126, 175122,
        175130, 172026, 172002, 172032, 172025, 172033, 172023, 172201, 172001,
      ],
      'Lahul & Spiti': [
        175142, 175132, 175140, 175139, 175133, 172114, 172113, 172117,
      ],
      Kinnaur: [
        172116, 172109, 172107, 172115, 172106, 172118, 172105, 172104, 172111,
        172101, 172108, 172110, 172112, 172103, 172030,
      ],
      Shimla: [
        172022, 172001, 172027, 172031, 172024, 172030, 172034, 172021, 172028,
        172102, 172101, 172201, 172029, 171003, 171004, 171219, 171206, 171223,
        171207, 171011, 171202, 171225, 171220, 171226, 171007, 171211, 171201,
        171018, 171013, 171213, 171217, 171212, 171210, 171216, 171005, 171001,
        171301, 171103, 171209, 171012, 171208, 171205, 171204, 171214, 171203,
        171019, 171221, 171002, 171218, 171008, 171006, 171009, 171222, 171215,
        171224, 171010, 173217,
      ],
      Sirmaur: [
        171226, 173023, 173032, 173024, 173001, 173029, 173027, 173025, 173101,
        173022, 173104, 173030, 173031, 173223, 173021, 173229, 173026, 173028,
      ],
      Solan: [
        173234, 173208, 173206, 173205, 173218, 173233, 174102, 173221, 173211,
        174103, 174101, 173213, 171102, 173207, 173235, 173229, 173217, 173210,
        173212, 173209, 173201, 173225, 173215, 173204, 173214, 173222, 173220,
        173230, 173223, 173202,
      ],
    },
    name: 'HP',
  },
  JK: {
    cities: {
      Srinagar: [
        190001, 190002, 190003, 190004, 190005, 190006, 190007, 190008, 190009,
        190010, 190011, 190012, 190013, 190014, 190015, 190017, 190018, 190019,
        190020, 190021, 190022, 190023, 190024, 190025, 190026, 190027, 190028,
        190029, 190030, 190031, 190032, 190033, 190034, 190035, 190036, 190037,
        190038, 190040, 190041, 190042, 190043, 190044, 190045, 190046, 190047,
        190048, 190049, 190050, 190051, 190052, 190053, 190054, 190055, 190056,
        190057, 190058, 190059, 190060, 190061, 190062, 190063, 190064, 190065,
        190066, 190067, 190068, 190069, 190070, 190071, 190072, 190073, 190074,
        190075, 190076, 190077, 190078, 190079, 190080, 190081, 190082, 190083,
        190084, 190085, 190086, 190087, 190088, 190089, 190090, 190100, 190101,
        190102, 190103, 190104, 190105, 190106, 190107, 190108, 190109, 190110,
        190111, 190112, 190113, 190114, 190115, 190116, 190117, 190118, 190119,
        190120, 190121, 190122, 190123, 190124, 190125, 190126, 190127, 190128,
        190129, 190130, 190131, 190132, 190133, 190134, 190135, 190136, 190137,
        190138, 190139, 190140, 190141, 190142, 190143, 190144, 190145, 190146,
        190147, 190148, 190149, 190150, 190151, 190152, 190153, 190154, 190155,
        190156, 190157, 190158, 190159, 190160, 190161, 190162, 190163, 190164,
        190165, 190166, 190167, 190168, 190169, 190170, 190171, 190172, 190173,
        190174, 190175, 190176, 190177, 190178, 190179, 190180, 190181, 190182,
        190183, 190184, 190185, 190186, 190187, 190188, 190189, 190190, 190191,
        190192, 190193, 190194, 190195, 190196, 190197, 190198, 190199,
      ],

      Jammu: [
        180001, 180002, 180003, 180004, 180005, 180006, 180007, 180008, 180009,
        180010, 180011, 180012, 180013, 180014, 180015, 180016, 180017, 180018,
        180019, 180020, 180021, 180022, 180023, 180024, 180025, 180026, 180027,
        180028, 180029, 180030, 180031, 180032, 180033, 180034, 180035, 180036,
        180037, 180038, 180039, 180040, 180041, 180042, 180043, 180044, 180045,
        180046, 180047, 180048, 180049, 180050, 180051, 180052, 180053, 180054,
        180055, 180056, 180057, 180058, 180059, 180060, 180061, 180062, 180063,
        180064, 180065, 180066, 180067, 180068, 180069, 180070, 180071, 180072,
        180073, 180074, 180075, 180076, 180077, 180078, 180079, 180080, 180081,
        180082, 180083, 180084, 180085, 180086, 180087, 180088, 180089, 180090,
        180091, 180092, 180093, 180094, 180095, 180096, 180097, 180098, 180099,
        180100, 180101, 180102, 180103, 180104, 180105, 180106, 180107, 180108,
        180109, 180110, 180111, 180112, 180113, 180114, 180115, 180116, 180117,
        180118, 180119, 180120, 180121, 180122, 180123, 180124, 180125, 180126,
        180127, 180128, 180129, 180130, 180131, 180132, 180133, 180134, 180135,
        180136, 180137, 180138, 180139, 180140, 180141, 180142, 180143, 180144,
        180145, 180146, 180147, 180148, 180149, 180150, 180151, 180152, 180153,
        180154, 180155, 180156, 180157, 180158, 180159, 180160, 180161, 180162,
        180163, 180164, 180165, 180166, 180167, 180168, 180169, 180170, 180171,
        180172, 180173, 180174, 180175, 180176, 180177, 180178, 180179, 180180,
        180181, 180182, 180183, 180184, 180185, 180186, 180187, 180188, 180189,
        180190, 180191, 180192, 180193, 180194, 180195, 180196, 180197, 180198,
        180199,
      ],

      Anantnag: [
        192101, 192102, 192103, 192104, 192105, 192106, 192107, 192108, 192109,
        192110, 192122, 192123, 192124, 192125, 192126, 192127, 192128, 192129,
        192201, 192202, 192203, 192204, 192205, 192301, 192302, 192303, 192304,
        192305, 192401, 192402, 192403, 192404, 192405, 192501, 192502, 192504,
        192505, 192506, 192507, 192508, 192509, 192510, 192511, 192512, 192513,
        192514, 192515, 192516, 192517, 192518, 192519, 192520, 192521, 192525,
        192601, 192602, 192603, 192604, 192605, 192606, 192701, 192702, 192703,
        192704, 192705, 192706, 192707, 192708, 192709, 192710, 192711, 192712,
        192713, 192714, 192715, 192716, 192717, 192718, 192719, 192720, 192721,
        192722, 192723, 192724, 192725, 192726, 192727, 192728, 192729, 192730,
        192731, 192732, 192733, 192734, 192735, 192736, 192737, 192738, 192739,
        192740, 192741, 192742, 192743, 192744, 192745, 192746, 192747, 192748,
        192749, 192750, 192751, 192752, 192753, 192754, 192755, 192756, 192757,
        192758, 192759, 192760, 192761, 192762, 192763, 192764, 192765, 192766,
        192767, 192768, 192769, 192770, 192771, 192772, 192773, 192774, 192775,
        192776, 192777, 192778, 192779, 192780, 192781, 192782, 192783, 192784,
        192785, 192786, 192787, 192788, 192789, 192790, 192791, 192792, 192793,
        192794, 192795, 192796, 192797, 192798, 192799,
      ],

      Baramulla: [
        193101, 193102, 193103, 193104, 193105, 193106, 193107, 193108, 193109,
        193110, 193201, 193202, 193203, 193204, 193205, 193206, 193207, 193301,
        193302, 193303, 193304, 193401, 193402, 193403, 193404, 193405, 193501,
        193502, 193503, 193504, 193505, 193506, 193507, 193508, 193509, 193510,
        193511, 193512, 193513, 193514, 193515, 193516, 193517, 193518, 193519,
        193520, 193521, 193522, 193523, 193524, 193525, 193526, 193527, 193528,
        193529, 193530, 193531, 193532, 193533, 193534, 193535, 193536, 193537,
        193538, 193539, 193540, 193541, 193542, 193543, 193544, 193545, 193546,
        193547, 193548, 193549, 193550, 193551, 193552, 193553, 193554, 193555,
        193556, 193557, 193558, 193559, 193560, 193561, 193562, 193563, 193564,
        193565, 193566, 193567, 193568, 193569, 193570, 193571, 193572, 193573,
        193574, 193575, 193576, 193577, 193578, 193579, 193580, 193581, 193582,
        193583, 193584, 193585, 193586, 193587, 193588, 193589, 193590, 193591,
        193592, 193593, 193594, 193595, 193596, 193597, 193598, 193599,
      ],

      'Jammu and Kashmir (Other)': [
        192129, 192130, 192131, 192132, 192133, 192134, 192135, 192136, 192137,
        192138, 192139, 192140, 192141, 192142, 192143, 192144, 192145, 192146,
        192147, 192148, 192149, 192150, 192151, 192152, 192153, 192154, 192155,
        192156, 192157, 192158, 192159, 192160, 192161, 192162, 192163, 192164,
        192165, 192166, 192167, 192168, 192169, 192170, 192171, 192172, 192173,
        192174, 192175, 192176, 192177, 192178, 192179, 192180, 192181, 192182,
        192183, 192184, 192185, 192186, 192187, 192188, 192189, 192190, 192191,
        192192, 192193, 192194, 192195, 192196, 192197, 192198, 192199, 192201,
        192202, 192203, 192204, 192205, 192206, 192207, 192208, 192209, 192210,
        192211, 192212, 192213, 192214, 192215, 192216, 192217, 192218, 192219,
        192220, 192221, 192222, 192223, 192224, 192225, 192226, 192227, 192228,
        192229, 192230, 192231, 192232, 192233, 192234, 192235, 192236, 192237,
        192238, 192239, 192240, 192241, 192242, 192243, 192244, 192245, 192246,
        192247, 192248, 192249, 192250, 192251, 192252, 192253, 192254, 192255,
        192256, 192257, 192258, 192259, 192260, 192261, 192262, 192263, 192264,
        192265, 192266, 192267, 192268, 192269, 192270, 192271, 192272, 192273,
        192274, 192275, 192276, 192277, 192278, 192279, 192280, 192281, 192282,
        192283, 192284, 192285, 192286, 192287, 192288, 192289, 192290, 192291,
        192292, 192293, 192294, 192295, 192296, 192297, 192298, 192299, 192300,
        192301, 192302, 192303, 192304, 192305, 192306, 192307, 192308, 192309,
        192310, 192311, 192312, 192313, 192314, 192315, 192316, 192317, 192318,
        192319, 192320, 192321, 192322, 192323, 192324, 192325, 192326, 192327,
        192328, 192329, 192330, 192331, 192332, 192333, 192334, 192335, 192336,
        192337, 192338, 192339, 192340, 192341, 192342, 192343, 192344, 192345,
        192346, 192347, 192348, 192349, 192350, 192351, 192352, 192353, 192354,
        192355, 192356, 192357, 192358, 192359, 192360, 192361, 192362, 192363,
        192364, 192365, 192366, 192367, 192368, 192369, 192370, 192371, 192372,
        192373, 192374, 192375, 192376, 192377, 192378, 192379, 192380, 192381,
        192382, 192383, 192384, 192385, 192386, 192387, 192388, 192389, 192390,
        192391, 192392, 192393, 192394, 192395, 192396, 192397, 192398, 192399,
        192400, 192401, 192402, 192403, 192404, 192405, 192406, 192407, 192408,
        192409, 192410, 192411, 192412, 192413, 192414, 192415, 192416, 192417,
        192418, 192419, 192420, 192421, 192422, 192423, 192424, 192425, 192426,
        192427, 192428, 192429, 192430, 192431, 192432, 192433, 192434, 192435,
        192436, 192437, 192438, 192439, 192440, 192441, 192442, 192443, 192444,
        192445, 192446, 192447, 192448, 192449, 192450, 192451, 192452, 192453,
        192454, 192455, 192456, 192457, 192458, 192459, 192460, 192461, 192462,
        192463, 192464, 192465, 192466, 192467, 192468, 192469, 192470, 192471,
        192472, 192473, 192474, 192475, 192476, 192477, 192478, 192479, 192480,
        192481, 192482, 192483, 192484, 192485, 192486, 192487, 192488, 192489,
        192490, 192491, 192492, 192493, 192494, 192495, 192496, 192497, 192498,
        192499,
      ],
    },
    name: 'JK',
  },
  JH: {
    cities: {
      Dhanbad: [
        828124, 828201, 828111, 828113, 828130, 828110, 828306, 828109, 828116,
        828101, 828205, 828106, 826005, 828204, 828121, 828301, 827302, 828308,
        828103, 828401, 828302, 828133, 828104, 828402, 828117, 828202, 828135,
        826001, 826004, 828107, 828108, 826003, 828112, 828125, 828309, 828303,
        828129, 828114, 828307, 828115, 828131, 828203, 828207, 828304, 828305,
        828120, 828206, 828132, 828119, 828123, 828122, 828127, 828105, 828126,
        828128,
      ],
      Bokaro: [
        827013, 828134, 828302, 829301, 827001, 827011, 827010, 827302, 827009,
        827014, 828303, 828307, 828125, 827012, 827003, 827004, 827006, 829104,
        825102, 829144, 829121, 829112, 829127, 829132, 829107, 829114, 829123,
        828403, 828404, 829111, 829128, 829113, 829116, 825322, 829149, 825315,
        814155,
      ],
      Giridh: [
        815312, 815311, 825412, 825322, 825108, 815302, 825320, 815314, 815316,
        815318, 825324, 815301, 825167, 825106, 815313, 815317, 815315, 825329,
        825418,
      ],
      Hazaribag: [
        825311, 825302, 825319, 825313, 825312, 825301, 825405, 825402, 825323,
        825406, 825317, 825303, 825336, 825411, 829101, 825315, 825401, 829119,
      ],
      Chatra: [825408, 825401, 825103, 825321, 825404, 825403, 829201],
      Ramgarh: [
        829101, 829143, 829110, 825314, 829134, 829103, 829102, 825101, 825330,
        829105, 829117, 829106, 829135, 829109, 829108, 829119, 825316, 829150,
        829118, 825325, 829130, 829122, 829129, 829125, 829133, 829126, 829131,
        825326,
      ],
      Koderma: [
        825418, 825407, 825132, 825323, 825409, 825109, 825318, 825410, 825413,
        825421,
      ],
      Latehar: [829203, 822119, 829206, 829202, 829204, 822112, 822111, 829207],
      Garhwa: [
        822114, 822112, 822134, 822125, 822133, 829201, 822124, 822128, 822129,
        822132, 822118,
      ],
      Palamau: [
        822121, 822116, 822122, 822118, 822113, 822123, 822115, 822126, 822120,
        822101, 822132, 822110, 822102, 822131, 822117, 829202, 822128,
      ],
      Ranchi: [
        829205, 829210, 829209, 829208, 835204, 834008, 834002, 835102, 835325,
        835227, 835225, 835103, 835210, 834004, 835301, 835216, 835205, 834010,
        835219, 834009, 835303, 835202, 835222, 835234, 835209, 835214, 834006,
        835217, 835101, 834001, 835221, 834003, 834005, 834011, 835215,
      ],
      Gumla: [
        835231, 835203, 835232, 835233, 835208, 835324, 835220, 835229, 835211,
        835206, 835230, 835302, 835212, 835207, 835227, 835214,
      ],
      Simdega: [835211, 835212, 835223, 835226, 835201, 835228, 835235],
      Lohardaga: [835302, 835213, 835218, 835325, 834009, 834004],
      'West Singhbhum': [
        835216, 831013, 833214, 833105, 833204, 833104, 833102, 833221, 833215,
        833103, 833201, 833106, 833212, 833101, 833213, 833203, 833217, 833218,
        833222, 833223, 833202,
      ],
      Khunti: [835235, 835302],
      Deoghar: [
        814143, 814146, 814112, 814152, 815353, 814149, 814142, 815357, 814120,
        814113, 814157, 814114, 814115, 814122, 814150, 814153, 814116,
      ],
      Godda: [
        814160, 814153, 814133, 814154, 814155, 813208, 814147, 814165, 814156,
        815355, 816102, 814102, 814151,
      ],
      Jamtara: [815355, 815359, 815352, 815351, 815354, 814166],
      Sahibganj: [
        816101, 816120, 816110, 816102, 816109, 816116, 816105, 813208, 816108,
        816129, 816115,
      ],
      Dumka: [
        814146, 814102, 814145, 814141, 814103, 814148, 814110, 814158, 816118,
        814119, 814166, 814118, 814144, 814101, 816103, 814151, 814120, 816117,
        814150, 816107, 814167,
      ],
      Pakur: [
        814111, 816104, 816106, 816117, 816102, 816107, 816103, 816105, 814133,
      ],
      'Seraikela-kharsawan': [
        832401, 832109, 833101, 833216, 831002, 832404, 833204, 832108, 833220,
        833102, 832403, 832402, 833105, 831012, 832107, 833219, 832112, 831014,
      ],
      'East Singhbhum': [
        831009, 832301, 832102, 832101, 832302, 832303, 833202, 832110, 832104,
        831002, 832105, 832112, 832304, 831017, 831012, 831019, 831001, 831007,
        831004, 832107, 831015, 831003, 831006, 831005, 831018, 832103, 832111,
        831020, 831016, 832106, 831011, 831010,
      ],
    },
    name: 'JH',
  },
  KA: {
    cities: {
      Bangalore: [
        560063, 560007, 560092, 560024, 560045, 560064, 560047, 560043, 560001,
        560300, 560025, 560103, 560046, 560049, 560093, 560067, 560036, 560077,
        560037, 560071, 560016, 560066, 560005, 560065, 560087, 560008, 560051,
        560048, 560038, 560094, 560006, 560075, 560084, 560033, 560017, 560032,
        560080, 560042, 560030, 560034, 560108, 560050, 560070, 560085, 560002,
        560076, 560083, 560004, 560068, 560056, 560082, 560099, 560035, 560018,
        560081, 560053, 560061, 560060, 560026, 560029, 560062, 560100, 560019,
        560105, 560102, 560078, 560041, 560011, 560095, 560074, 560039, 560098,
        560059, 560027, 560109, 560110, 560073, 560009, 560091, 560079, 560040,
        560021, 560104, 560010, 560014, 560013, 560015, 560112, 560058, 560023,
        560086, 560003, 560055, 560054, 560072, 560096, 560057, 560012, 560020,
        560090, 560097, 560022, 562106, 562107, 562164, 562149, 562157, 562120,
        562130, 562162, 562125,
      ],
      'Bangalore Rural': [
        560067, 560099, 560082, 560083, 560060, 560068, 560107, 560089, 560090,
        560088, 560091, 561101, 561201, 562110, 562162, 561203, 562163, 562123,
        562111, 561204, 562131, 562127, 562122, 562129, 562164, 562135, 562132,
        562114, 561205, 562130, 562119,
      ],
      Ramanagar: [
        562108, 562117, 562120, 562159, 562138, 562119, 562126, 562112, 561201,
        562121, 562109, 562160, 562161, 562128,
      ],
      Bagalkot: [
        587111, 587201, 587330, 587206, 587124, 587119, 587116, 587301, 587155,
        587121, 587118, 587125, 587112, 587311, 587117, 587101, 587103, 587104,
        587204, 587313, 587113, 587114, 587115, 587202, 587207, 587122, 587120,
        587312, 587102, 587315, 587154, 587203, 587205, 587314, 587316, 586125,
        586113,
      ],
      'Bijapur(KAR)': [
        587117, 586213, 586111, 586117, 586123, 586112, 586211, 586104, 586118,
        586201, 586202, 586129, 586216, 586204, 586127, 586203, 586207, 586217,
        586113, 586210, 586128, 586214, 586114, 586125, 586116, 586215, 586119,
        586212, 586103, 586120, 586108, 586101, 586109, 586102, 586124, 586206,
        586115, 586208, 586205, 586130, 586122, 586209, 586121,
      ],
      Belgaum: [
        591110, 591143, 591129, 590020, 590010, 591112, 591108, 591345, 591102,
        590006, 591109, 591126, 591117, 590016, 591115, 591127, 591131, 591111,
        590018, 591103, 591130, 591302, 591124, 591123, 591128, 591120, 590001,
        590019, 590003, 590005, 590017, 590009, 591104, 591125, 591156, 591106,
        591114, 591119, 591153, 591147, 590014, 591301, 591121, 591116, 590011,
        591118, 591346, 591113, 590015, 590008, 591173, 591304, 591248, 591215,
        591303, 591212, 591211, 591317, 591220, 591213, 591241, 591232, 591237,
        591230, 591226, 591265, 591263, 591214, 591222, 591217, 591216, 591201,
        591247, 591287, 591238, 591316, 591219, 591311, 591229, 591235, 591242,
        591240, 591223, 591244, 591234, 591228, 591239, 591315, 591101, 591225,
        591236, 591313, 591218, 591309, 591310, 591221, 591306, 591122, 591305,
        591344, 591243, 591233, 591254, 591312, 591224, 591107, 591307, 591308,
        591227, 591340, 591231, 591314, 591136, 591246,
      ],
      Davangere: [
        583131, 583127, 583137, 583125, 583213, 581119, 577512, 577601, 577534,
        577528, 577556, 577513, 577514, 577003, 577589, 577525, 577516, 577005,
        577001, 577002, 577553, 577518, 577004, 577501, 577006, 577566, 577530,
        577557, 577213, 577217, 577552, 577223, 577219, 577551, 577224, 577231,
        577221, 577218, 577225, 577215, 577230, 577544, 577216, 577243, 577427,
      ],
      Bellary: [
        583114, 583128, 583121, 583220, 583104, 583218, 583135, 583211, 583134,
        583201, 583212, 583115, 583130, 583122, 583103, 583116, 583102, 583124,
        583224, 583214, 583126, 583117, 583216, 583101, 583105, 583152, 583132,
        583120, 583119, 583217, 583223, 583111, 583113, 583129, 583222, 583118,
        583219, 583112, 583215, 583239, 583136, 583203, 583276, 583221, 583123,
        583225, 583275,
      ],
      Bidar: [
        585444, 585328, 585419, 585402, 585414, 585416, 585403, 585326, 585226,
        585436, 585412, 585327, 585443, 585227, 585411, 585401, 585415, 585418,
        585417, 585421, 585437, 585413, 585330, 585353, 585329, 585331,
      ],
      Dharwad: [
        580028, 581207, 582208, 581103, 581201, 580025, 580024, 582201, 580007,
        581113, 581196, 581209, 581204, 580114, 581195, 580023, 580118, 580001,
        580011, 580003, 580008, 580006, 580002, 580009, 580005, 580004, 581105,
        580030, 581107, 580112, 581117, 580029, 580020, 580031, 580021, 580026,
        580032, 581206,
      ],
      Gadag: [
        582111, 582116, 582103, 582205, 582209, 582203, 582118, 582102, 582207,
        582112, 582113, 582204, 582202, 583229, 582120, 582114, 582117, 582101,
        583227, 583282, 582119, 582115, 583226, 582211, 583238, 582206, 583277,
        583233, 583268, 583279, 582210, 583235,
      ],
      Koppal: [
        583277, 583234, 583235, 583226, 583227, 583230, 583238, 583232, 583278,
        583236, 583281, 583282, 583229, 583237, 583280, 583228, 583283, 583268,
        583279, 583231,
      ],
      Yadgir: [
        585223, 585216, 585315, 585290, 585321, 585202, 585221, 585319, 585237,
        585355, 585287, 585304, 585214, 585309, 585220, 585323, 585291, 585215,
        585219, 585224, 585201,
      ],
      Gulbarga: [
        585222, 585301, 585314, 585211, 585302, 585325, 585316, 585303, 585212,
        585306, 585305, 585310, 585322, 585236, 585104, 585309, 585265, 585308,
        585317, 585225, 585228, 585311, 585102, 585312, 585213, 585367, 585313,
        585318, 585307, 585320, 585321, 585324, 585103, 585105, 585101, 585106,
        585217, 585218, 585319, 585210, 585292, 585229,
      ],
      Haveri: [
        581101, 581128, 581115, 581102, 581110, 581109, 581106, 581210, 581203,
        581208, 581104, 581126, 581120, 581202, 581205, 581108, 581211, 581111,
        581145, 581118, 581193, 581119, 581116, 581148, 581213, 581112, 581197,
        581123, 581198, 581212,
      ],
      'Uttara Kannada': [
        581344, 581319, 581348, 581351, 581314, 581354, 581343, 581324, 581350,
        581360, 581440, 581342, 581334, 581308, 581317, 581316, 581302, 581306,
        581423, 581353, 581321, 581320, 581357, 581421, 581333, 581307, 581328,
        581323, 581361, 581400, 581352, 581327, 581345, 581384, 581326, 581362,
        581330, 581332, 581338, 581335, 581396, 581339, 581341, 581301, 581305,
        581303, 581304, 581340, 581355, 581453, 581325, 581322, 581363, 581315,
        581329, 581358, 581349, 581359, 581187, 581356, 581337, 581402, 581129,
        581365, 581336, 581331, 581318, 581403, 581121, 581346, 581401, 581186,
        581347, 581450, 581412, 581411,
      ],
      Raichur: [
        584128, 584123, 584129, 584140, 584125, 584120, 584122, 584111, 584203,
        584113, 584104, 584136, 584102, 584138, 584116, 584167, 584143, 584126,
        584134, 584115, 584127, 584170, 584139, 584135, 584124, 584132, 584202,
        584118, 584133, 584103, 584101,
      ],
      Chickmagalur: [
        577126, 577139, 577547, 577123, 577548, 577111, 577101, 577228, 577182,
        577138, 577550, 577131, 577134, 577179, 577112, 577116, 577122, 577113,
        577135, 577144, 577114, 577132, 577120, 577146, 577127, 577136, 577130,
        577145, 577117, 577549, 577140, 577102, 577180, 577160, 577175, 577118,
        577124, 577133, 577121, 577168, 577181, 577129, 577125, 577142, 577128,
        577137,
      ],
      Chitradurga: [
        577536, 577546, 577518, 577526, 577511, 577558, 577541, 577597, 577598,
        577545, 577557, 577555, 577554, 577527, 577515, 577529, 577522, 577517,
        577599, 577519, 577520, 577521, 577543, 577533, 577532, 577535, 577538,
        577523, 577502, 577501, 577537, 577540, 577524, 577596, 577531, 577539,
        577542,
      ],
      Hassan: [
        573214, 573102, 573116, 573121, 573103, 573128, 573133, 573131, 573225,
        573213, 573212, 573150, 573216, 573210, 573134, 573120, 573215, 573122,
        573202, 573101, 573125, 573112, 573118, 573123, 573162, 573211, 573164,
        573111, 573124, 573115, 573130, 573135, 573136, 573113, 573129, 573220,
        573127, 573217, 573218, 573137, 573201, 573165, 573141, 573142, 573117,
        573119, 573219, 573144, 573126,
      ],
      Kodagu: [
        571236, 571253, 571251, 571235, 571211, 571237, 571218, 571212, 571201,
        571213, 571215, 571217, 571249, 571234, 571252, 571219, 571214, 571216,
        571231, 571254, 571247, 571248, 571232, 571250, 574234, 574314,
      ],
      Chikkaballapur: [
        562105, 562103, 562101, 561213, 561209, 561211, 561208, 562102, 561207,
        562104, 563125, 561206, 563159, 561210, 563123, 561212, 563124, 563121,
        563138, 561228, 563146,
      ],
      Kolar: [
        563161, 563138, 563160, 561213, 563132, 563128, 563113, 562105, 563131,
        563125, 563114, 563133, 563130, 563102, 562104, 563127, 561207, 561211,
        563129, 563139, 563134, 563123, 563115, 563116, 562102, 563124, 563159,
        561208, 563126, 563103, 563117, 563118, 563162, 563120, 562103, 563136,
        563122, 562101, 563121, 563146, 561209, 561228, 563137, 561210, 563135,
        561212, 563101, 563119, 561206,
      ],
      Mandya: [
        571425, 571404, 571475, 571436, 571426, 571605, 571807, 571448, 571434,
        571433, 571424, 571423, 571415, 571427, 571418, 571812, 571431, 571416,
        571432, 571606, 571417, 571419, 571478, 571405, 571422, 571445, 571802,
        571463, 571421, 571429, 571446, 571403, 571455, 571430, 571811, 571476,
        571477, 571428, 571402, 571450, 571435, 571607, 571401, 571438,
      ],
      'Dakshina Kannada': [
        574145, 574142, 575007, 574141, 575017, 575006, 574199, 574154, 574267,
        575011, 575030, 574153, 575002, 575004, 575008, 575003, 575029, 574146,
        575018, 574150, 575001, 574143, 574144, 574151, 574148, 575015, 575023,
        575022, 575014, 575028, 575019, 575005, 575013, 575010, 574509, 575016,
        575025, 575020, 574260, 574211, 574239, 574324, 574227, 574285, 574217,
        574235, 574219, 574253, 574242, 574237, 574314, 574198, 574223, 574210,
        574233, 574241, 574212, 574221, 574232, 574218, 574274, 574326, 574214,
        574203, 574323, 574240, 574213, 574259, 574238, 574325, 574243, 574328,
        574222, 574248, 574201, 574228, 574202, 574216, 574229, 574234, 574220,
        574313, 574265, 574226, 574230, 574197, 574279, 574236, 574327, 574109,
        574224, 574225, 574231, 574107,
      ],
      Udupi: [
        576111, 576121, 574144, 574101, 576117, 574102, 574122, 574129, 576112,
        574110, 574107, 574108, 574104, 574109, 574114, 574244, 576225, 576101,
        574119, 576226, 576283, 574118, 576233, 576227, 576103, 576211, 576212,
        576124, 576213, 576222, 576107, 576223, 574103, 574117, 576224, 576115,
        576234, 576210, 576113, 576221, 574115, 576232, 576214, 576215, 576230,
        576104, 576102, 576201, 576216, 576247, 576235, 574113, 576229, 576217,
        576219, 576282, 576218, 576122, 574106, 576114, 574105, 576120, 576231,
        576105, 574116, 576220, 576106, 576108, 576257, 574111, 574112, 576228,
      ],
      Mysore: [
        570026, 570028, 571107, 571102, 571130, 571604, 571617, 571114, 571108,
        571601, 571189, 571311, 571105, 570015, 571602, 571116, 571121, 570018,
        571103, 570020, 571104, 571125, 570010, 570004, 571610, 570008, 571106,
        571187, 570025, 571603, 570002, 571134, 570016, 570027, 570031, 570012,
        570014, 570001, 570023, 570006, 570005, 570003, 570007, 570022, 570019,
        570009, 570029, 570011, 570030, 570017, 571119, 571128, 571101, 571312,
        571124, 571129, 571110, 571302, 571314, 571120, 571118, 571315, 571122,
        571301,
      ],
      Chamrajnagar: [
        571442, 571439, 571111, 571117, 571127, 571441, 571313, 571316, 571457,
        571123, 571126, 571109, 571115, 571342, 571443, 571440, 571320, 571444,
        571490, 571128, 571110,
      ],
      Shimoga: [
        577204, 577412, 577227, 577413, 577428, 577411, 577427, 577453, 577214,
        577243, 577245, 577233, 577421, 577414, 577426, 577211, 577434, 577423,
        577301, 577431, 577432, 577226, 577232, 577401, 577429, 577115, 577302,
        577418, 577417, 577222, 577436, 577216, 577416, 577422, 577415, 577229,
        577419, 577202, 577213, 577205, 577220, 577433, 577452, 577430, 577448,
        577424, 577201, 577435, 577203, 577225, 577451, 577425,
      ],
      Tumkur: [
        572129, 572216, 572223, 572220, 572222, 572224, 572211, 572111, 572212,
        572213, 572117, 572140, 572106, 572130, 572227, 572121, 572116, 572118,
        572225, 572136, 572175, 572113, 572112, 572217, 572137, 572123, 572119,
        572228, 572214, 572133, 572215, 572114, 572201, 572104, 572219, 572218,
        572107, 572126, 572135, 572120, 572125, 572132, 561202, 572124, 572128,
        572115, 572127, 572141, 572138, 572221, 572142, 572226, 572139, 572102,
        572168, 572122, 572134, 572103, 572105, 572101,
      ],
    },
    name: 'KA',
  },
  KL: {
    cities: {
      Wayanad: [
        673575, 673579, 673593, 673596, 673592, 673595, 673581, 673577, 673122,
        673123, 673121, 673591, 673576, 670644, 670645, 670721, 670646, 670731,
      ],
      Kozhikode: [
        673586, 673602, 673603, 673028, 673572, 673015, 673018, 673032, 673004,
        673020, 673001, 673008, 673002, 673301, 673573, 673601, 673616, 673571,
        673580, 673661, 673655, 673017, 673005, 673303, 673006, 673585, 673632,
        673631, 673016, 673014, 673570, 673302, 673604, 673611, 673613, 673003,
        673582, 673010, 673007, 673009, 673328, 673012, 673011, 673027, 673019,
        673021, 673633, 673029, 673517, 673508, 673513, 673317, 673620, 673507,
        673315, 673528, 673524, 673614, 673541, 673521, 673309, 673612, 673526,
        673509, 673506, 673306, 673304, 673104, 673525, 673527, 673529, 673308,
        673106, 673502, 673574, 673501, 673505, 673523, 673504, 673615, 673102,
        673542, 673307, 673522, 673503, 673305, 673310, 673105, 673103, 673101,
      ],
      Malappuram: [
        673632, 673633, 676525, 673641, 679357, 679332, 679339, 676123, 679322,
        676509, 673637, 679321, 673639, 673638, 679341, 679329, 679334, 673647,
        673635, 676541, 679328, 676504, 679323, 673634, 676521, 679327, 679325,
        673636, 679340, 673645, 676519, 679331, 679326, 676122, 676523, 679324,
        679333, 679330, 673640, 676522, 679338, 676506, 676507, 676505, 676542,
        676121, 676517, 673642, 676305, 679585, 676102, 676301, 676303, 676312,
        679573, 676106, 679576, 679580, 676503, 676561, 676306, 676304, 676510,
        679575, 676319, 676508, 676108, 676501, 676552, 679587, 679579, 679572,
        676103, 673314, 676553, 679582, 679586, 676551, 679584, 679571, 676307,
        676309, 679591, 676562, 676105, 679581, 676528, 679574, 676311, 679578,
        676320, 676109, 676302, 676317, 676502, 679577, 679583, 676107, 676101,
        676104,
      ],
      Kannur: [
        670571, 670008, 670331, 670612, 670307, 670582, 670143, 670561, 670006,
        670009, 670622, 670013, 670621, 670014, 670633, 670592, 670604, 670631,
        670632, 670581, 670301, 670601, 670511, 670011, 670502, 670142, 670002,
        670353, 670591, 670327, 670595, 670306, 670308, 670521, 670309, 670310,
        670334, 670613, 670593, 670504, 670005, 670562, 670602, 670012, 670003,
        670017, 670001, 670567, 670007, 670304, 670611, 670501, 670325, 670302,
        670594, 670563, 670305, 670004, 670503, 670358, 670303, 670141, 670018,
        670010, 670650, 670651, 670701, 670706, 670672, 670705, 670704, 670673,
        670674, 670643, 670102, 670694, 670702, 670692, 670104, 670693, 670106,
        670107, 670642, 670663, 670703, 670676, 673316, 670649, 670675, 670691,
        670741, 670661, 670103, 670662, 670105, 673311, 673313, 670671, 673312,
        670641, 670101,
      ],
      Kasargod: [
        670511, 671351, 671531, 671121, 671543, 671123, 671322, 671323, 671321,
        671551, 671533, 671552, 671541, 671319, 671348, 671124, 671316, 671318,
        671314, 671317, 671532, 671313, 671326, 671324, 671310, 671311, 671542,
        671315, 671312, 671122,
      ],
      Palakkad: [
        679503, 678581, 679302, 678601, 678633, 679303, 679512, 679501, 679551,
        679552, 678583, 679513, 679505, 679536, 679535, 678762, 679304, 679521,
        679522, 679336, 679305, 678582, 679511, 679337, 678595, 679308, 679335,
        679123, 678591, 679515, 678596, 679313, 679122, 679514, 679104, 679506,
        678597, 679504, 679523, 679307, 678632, 679533, 679534, 679554, 679553,
        679301, 679306, 678593, 679502, 679101, 679103, 679121, 678598, 679102,
        679516, 679309, 678008, 678506, 678541, 678011, 678651, 678682, 678554,
        678544, 678556, 678683, 678510, 678508, 678007, 678624, 678611, 678573,
        678102, 678703, 678631, 678572, 678721, 678702, 678706, 678704, 678104,
        678101, 678005, 678574, 678009, 678622, 678684, 678546, 678555, 678502,
        678507, 678512, 678006, 678613, 678003, 678621, 678623, 678701, 678686,
        678534, 678551, 678532, 678503, 678542, 678012, 678543, 678641, 678642,
        678612, 678004, 678501, 678681, 678732, 678557, 678688, 678013, 678687,
        678685, 678571, 678533, 678705, 678592, 678594, 678553, 678722, 678002,
        678014, 678001, 678731, 678505, 678552, 678661, 678531, 678545, 678010,
        678103, 678671, 678504,
      ],
      Alappuzha: [
        688012, 688001, 688011, 688005, 688007, 688561, 688531, 688535, 688534,
        688530, 688538, 688006, 688505, 688537, 688502, 688501, 688506, 688524,
        688539, 688562, 688529, 688522, 688582, 688504, 688527, 688541, 688533,
        688526, 688523, 688503, 688525, 688540, 688521, 688009, 688570, 688014,
        688004, 688003, 688013, 688002, 688008, 688532, 688528, 688555, 688536,
        686534, 686102, 686103, 690513, 690535, 690515, 689505, 690110, 690504,
        690517, 690558, 690503, 690505, 690105, 690507, 690104, 690106, 690532,
        690506, 690534, 689624, 689622, 690108, 690516, 690572, 690527, 690514,
        690501, 690509, 690103, 690533, 689504, 690502, 690508, 689508, 689521,
        689512, 690548, 689623, 690101, 689627, 690511, 690512, 690571, 690510,
        690529, 690107, 690531, 689520, 690559, 690537, 689509, 690102, 690530,
        690547, 689126, 689572, 689122, 689510, 689573, 689121, 689511, 689123,
        689109, 689124, 689571, 689595, 689574, 689506, 689590,
      ],
      Ernakulam: [
        683544, 683541, 686692, 683579, 683511, 683556, 683101, 683581, 686667,
        683572, 683573, 686672, 683545, 683549, 683585, 686670, 686668, 683577,
        686681, 683502, 686671, 683512, 683578, 683514, 686691, 683546, 683571,
        683102, 683561, 686662, 686665, 683594, 686673, 683112, 683513, 683516,
        682311, 683519, 686664, 683574, 683575, 683576, 683562, 686663, 683111,
        683518, 686666, 683565, 683522, 682316, 683587, 686693, 683520, 683105,
        686669, 683589, 683547, 683110, 686661, 683563, 683550, 683515, 683542,
        683543, 683580, 683106, 683108, 683521, 683517, 682041, 682303, 682302,
        682315, 682008, 682313, 682501, 682508, 682308, 682033, 682034, 682027,
        682312, 682037, 682010, 682024, 682502, 682026, 682503, 682035, 682011,
        682031, 682016, 682018, 682306, 683503, 682042, 682309, 682020, 682305,
        682030, 683104, 682017, 682310, 682001, 682004, 682301, 682022, 682506,
        682007, 683501, 682511, 682304, 682029, 682002, 682314, 682504, 682507,
        682307, 682505, 682509, 682040, 682009, 682012, 682025, 682006, 682036,
        682015, 682038, 682039, 682032, 682013, 682005, 682021, 682023, 682028,
        682019, 682003, 680667,
      ],
      Kottayam: [
        686544, 686546, 686508, 686503, 686501, 686517, 686540, 686101, 686106,
        686533, 686520, 686585, 686506, 686543, 686531, 686519, 686512, 686555,
        686510, 686541, 686514, 686539, 686509, 686102, 686535, 686515, 686507,
        686513, 686522, 686502, 686518, 686105, 686532, 686104, 686536, 686542,
        686548, 686538, 686545, 686537, 686521, 686103, 686505, 686504, 686582,
        686580, 686143, 686651, 686561, 686576, 686019, 686144, 686578, 686579,
        686008, 686564, 686574, 686604, 686122, 686562, 686613, 686015, 686146,
        686605, 686603, 686563, 686606, 686584, 686608, 686022, 686581, 686586,
        686004, 686652, 686587, 686577, 686121, 686011, 686631, 686653, 686571,
        686602, 686633, 686611, 686632, 686020, 686610, 686572, 686612, 686583,
        686607, 686002, 686001, 686013, 686003, 686573, 686635, 686017, 686016,
        686005, 686636, 686634, 686041, 686018, 686516, 686609, 686012, 686601,
        686006, 686616, 686014, 686575, 686007, 686021, 686637, 686560, 686009,
        686630, 686123, 686010, 686141,
      ],
      Pathanamthitta: [
        686510, 686511, 685533, 690504, 689711, 689692, 691523, 691525, 689674,
        689648, 691555, 689662, 689649, 689691, 689693, 691556, 689677, 689671,
        689664, 689503, 689650, 689673, 689663, 691551, 689668, 689672, 689643,
        691524, 689656, 689625, 691526, 689675, 689667, 691552, 691553, 689694,
        689514, 689502, 689653, 689654, 689641, 689661, 689501, 689695, 689644,
        689645, 689676, 689666, 689646, 689513, 691530, 689678, 689699, 689647,
        691554, 689507, 689698, 689642, 689652, 690522, 689113, 689112, 689585,
        689582, 689533, 689123, 689612, 689611, 689586, 689594, 689549, 689103,
        686547, 689614, 689532, 689542, 689583, 689547, 689621, 689102, 689108,
        689615, 689105, 689543, 689587, 689531, 689545, 689541, 689588, 689581,
        689546, 689548, 689550, 689106, 689584, 689591, 689107, 689544, 689110,
        689122, 689589, 689551, 689626, 689592, 689602, 689613, 689115, 689597,
        689101, 689111, 689104,
      ],
      Idukki: [
        686513, 686514, 685561, 685590, 685588, 685606, 685509, 685595, 685512,
        685565, 685535, 685613, 685585, 685515, 685591, 685608, 685533, 685619,
        685507, 685552, 685514, 685566, 685554, 685614, 685501, 685553, 685581,
        685618, 685551, 685589, 685612, 685615, 685587, 685605, 685531, 685602,
        685603, 685607, 685562, 685532, 685511, 685620, 685505, 685586, 685601,
        685508, 685582, 685604, 685563, 685503, 685583, 685609, 685616, 685571,
        685584,
      ],
      Thrissur: [
        680302, 680741, 680683, 680305, 680667, 680731, 680309, 680562, 680688,
        680666, 680724, 680686, 680307, 680722, 680681, 680687, 680721, 680571,
        680121, 680684, 680312, 680561, 680308, 680304, 680301, 680699, 680567,
        680568, 680122, 680703, 680671, 680734, 680564, 680125, 680317, 680662,
        680689, 680669, 680682, 680711, 680702, 680123, 680670, 680697, 680664,
        680691, 680311, 680668, 680732, 680733, 680712, 680685, 680661, 680566,
        680665, 680310, 680565, 680663, 680701, 680570, 680303, 680551, 680518,
        680519, 680641, 680602, 680555, 680563, 680006, 679564, 680541, 680523,
        680508, 680618, 679532, 680620, 680102, 680521, 680751, 680581, 680583,
        680306, 680003, 680506, 680104, 680522, 679561, 680586, 680587, 680517,
        680501, 680653, 680008, 679531, 680012, 680604, 680585, 680511, 680026,
        680502, 680027, 680652, 680552, 680515, 680569, 680611, 680510, 680615,
        680589, 680584, 680101, 680103, 680514, 680543, 680014, 680546, 679562,
        680011, 680613, 680594, 680612, 680590, 680544, 680028, 680505, 680656,
        680591, 680601, 680010, 679106, 680504, 680616, 680503, 680007, 680013,
        680651, 680512, 680588, 680617, 680542, 680507, 679105, 680509, 680623,
        680614, 680005, 679563, 680655, 680524, 680545, 680004, 680002, 680642,
        680553, 680631, 680596, 680022, 680520, 680001, 680020, 680009, 680021,
        680516, 680513, 680619, 680654, 680582,
      ],
      Kollam: [
        689696, 691306, 691508, 690520, 691309, 691311, 691307, 690561, 691333,
        691533, 691312, 691310, 691552, 691322, 690522, 691331, 691308, 690521,
        690540, 691332, 689695, 691553, 691522, 691305, 691526, 691573, 691579,
        691516, 690573, 691577, 690547, 691532, 691505, 691501, 690525, 690538,
        691602, 691002, 690542, 691021, 691559, 691302, 691534, 691014, 691536,
        691572, 691583, 691584, 691601, 691557, 691510, 691520, 691543, 691578,
        691502, 690523, 691011, 691531, 691507, 691008, 691535, 691303, 691560,
        690519, 691004, 691576, 690544, 690518, 691537, 691003, 691574, 691590,
        691538, 690536, 691001, 691013, 691541, 691020, 691506, 691571, 691512,
        691521, 691503, 691509, 690526, 690574, 691015, 691585, 691010, 691515,
        691334, 691582, 690524, 691566, 691006, 691301, 691504, 691500, 691304,
        690539, 691581, 691005, 691007, 691016, 691319, 691009, 691012, 691019,
        691589, 690528, 691540, 691511,
      ],
      Thiruvananthapuram: [
        695614, 695102, 695607, 695606, 695306, 695029, 695584, 695309, 695023,
        695101, 695103, 695310, 695305, 695008, 695609, 695024, 695301, 695601,
        695615, 695587, 695142, 695304, 695011, 695141, 695104, 695311, 695004,
        695307, 695605, 695608, 695021, 695583, 695581, 695144, 695582, 695612,
        695604, 695313, 695602, 695611, 695015, 695603, 695312, 695610, 695302,
        695146, 695025, 695145, 695589, 695143, 695316, 695586, 695028, 695303,
        695033, 695588, 695585, 695017, 695001, 695007, 695036, 695016, 695022,
        695034, 695317, 695308, 695035, 695318, 695572, 695122, 695005, 695026,
        695505, 695541, 695551, 695124, 695123, 695032, 695525, 695564, 695126,
        695542, 695009, 695502, 695501, 695522, 695132, 695504, 695013, 695014,
        695563, 695125, 695503, 695562, 695019, 695561, 695040, 695506, 695043,
        695574, 695042, 695512, 695524, 695030, 695002, 695003, 695526, 695099,
        695523, 695571, 695568, 695521, 695527, 695543, 695573, 695133, 695528,
        695020, 695121, 695507, 695027, 695575, 695018, 695508, 695012, 695513,
        695038, 695010, 695006, 695547, 695134,
      ],
    },
    name: 'KL',
  },
  LA: {
    cities: {
      Leh: [194101],
      Kargil: [194103],
      Diskit: [194401],
      Nubra: [194401],
      Hundar: [194401],
      Pangong: [194404],
      Nyoma: [194405],
      Turtuk: [194406],
      Changthang: [194407],
      Hanle: [194408],
      Demchok: [194409],
    },
    name: 'LA',
  },
  LD: {
    cities: {
      Lakshadweep: [
        682553, 682552, 682551, 682554, 682556, 682557, 682555, 682558, 682559,
      ],
    },
    name: 'LD',
  },
  MP: {
    cities: {
      Seoni: [
        480887, 480882, 480771, 480661, 480884, 480667, 480997, 480994, 480888,
        480886, 480996, 480999, 480990, 480880, 480991, 480881, 481226,
      ],
      Balaghat: [
        481445, 481332, 481117, 481335, 481222, 481102, 481111, 481337, 481331,
        481665, 481556, 481441, 481224, 481051, 481001, 481449, 481226, 481105,
        481115, 481551, 481116, 481661,
      ],
      Mandla: [
        481998, 481885, 481995, 481661, 481662, 481664, 481771, 481666, 481668,
        481996, 481672, 481768, 481663, 481776, 481665,
      ],
      Dindori: [481879, 481880, 481882, 481990, 481778, 481884, 481885, 481672],
      Bhopal: [
        462016, 462031, 462020, 462030, 462042, 462022, 462027, 462038, 462041,
        462043, 462026, 463106, 462010, 462045, 464993, 462101, 462044, 462008,
        463111, 462001, 462120, 462003, 462036, 462023, 462024, 462066, 462007,
        462004, 462046, 462047, 462037, 462013, 462033, 462011, 462039, 462002,
      ],
      Raisen: [
        464993, 464884, 464668, 464774, 464886, 464551, 464665, 464776, 464881,
        464986, 464672, 464770, 464671, 464661, 464651, 464990,
      ],
      Chhatarpur: [
        471510, 471315, 472111, 472010, 471606, 471111, 471405, 471301, 471525,
        471201, 471311, 471515, 471001, 471318, 471105, 471313, 471408, 471501,
        471411, 472001, 471625, 471101, 471516,
      ],
      Tikamgarh: [
        472101, 472111, 472221, 472010, 472442, 472447, 472005, 472339, 472331,
        472118, 472246, 472336, 472115, 472446, 472337, 472445, 472001,
      ],
      Panna: [
        488442, 488001, 488220, 488448, 488441, 488222, 488333, 488051, 488050,
        488446, 488059, 488443,
      ],
      Betul: [
        460225, 460553, 460449, 460551, 460665, 460666, 460110, 460330, 460440,
        460554, 460220, 460001, 460004, 460661, 460663, 460668, 460443, 460557,
        480441, 460447, 461111, 461441, 461228,
      ],
      Chhindwara: [
        480221, 480449, 480334, 480331, 480106, 480337, 480551, 480338, 480223,
        480115, 480110, 480224, 480441, 480559, 480109, 480001, 480447, 480557,
        480111, 480003, 480107, 480555, 480553, 480108, 460663, 480105, 480112,
      ],
      Hoshangabad: [
        461661, 461331, 461990, 461223, 461221, 461111, 461668, 461001, 461228,
        461116, 461771, 461441, 461115, 461114, 461775, 461446, 461122, 461881,
        461551, 461110, 461005,
      ],
      Narsinghpur: [
        487881, 487225, 487551, 487555, 487001, 487118, 487661, 487330, 487221,
        487334, 487110, 487441, 487770, 487337, 487114, 461990, 461771,
      ],
      Harda: [461228, 461441, 461331, 461111],
      Satna: [
        485226, 485775, 485115, 485772, 485447, 485773, 485446, 485551, 485881,
        485331, 485334, 485112, 485441, 485005, 485001, 485111, 485221, 485666,
        485774, 485113, 485114, 485778, 485661, 485771,
      ],
      Rewa: [
        486003, 486223, 486556, 486111, 486115, 486550, 486220, 486446, 486445,
        486226, 486447, 486117, 486553, 486448, 486440, 486331, 486441, 486114,
        486123, 486340, 486341, 486450, 486335, 486006, 486333, 486338, 486005,
        486001, 486002, 485331, 486451,
      ],
      Damoh: [
        470661, 470673, 470771, 470675, 470672, 470664, 470772, 470663, 470775,
        470881, 470666, 470880,
      ],
      Sagar: [
        470125, 470339, 470441, 470223, 470001, 470442, 470227, 470118, 470021,
        470228, 470335, 470113, 470226, 470117, 470051, 470120, 470232, 470221,
        470115, 470124, 470337, 470119, 470235, 470004, 470229, 470669, 470002,
        470003, 464240,
      ],
      Anuppur: [
        484881, 484116, 484886, 484330, 484224, 484334, 484440, 484336, 484117,
        484555, 484001, 484113, 484220, 484444, 484887, 484770, 484446,
      ],
      Umaria: [
        484660, 484661, 484001, 484665, 484664, 484552, 484551, 484555, 486661,
      ],
      Shahdol: [
        484774, 484771, 484117, 484110, 484770, 484776, 484001, 484446, 484440,
        484669, 484330, 484114, 484444, 484660, 486669, 484881, 484120,
      ],
      Sidhi: [
        486661, 486670, 486775, 486776, 486771, 486882, 486675, 486886, 486669,
        486666, 486881, 486889, 484771, 486892, 486890, 486887, 486884,
      ],
      Singrauli: [486887, 486886, 486888, 486889, 486885],
      Vidisha: [
        464111, 464113, 464001, 464221, 464114, 464220, 464226, 464228, 464337,
        464224, 464331, 464258, 464240,
      ],
      'Ashok Nagar': [
        473444, 473332, 473331, 473443, 473446, 473330, 473335, 473440,
      ],
      Shivpuri: [
        473585, 473770, 473793, 473781, 473665, 473660, 473880, 473885, 473995,
        473670, 473775, 473551, 473662, 473774, 473990, 473865, 473638,
      ],
      Guna: [
        473101, 473331, 473226, 473105, 473287, 473249, 473115, 473222, 473113,
        473111, 473118, 473110, 473443, 473112, 473001, 473885,
      ],
      Gwalior: [
        474015, 475001, 474001, 475005, 475330, 474006, 475115, 475220, 474020,
        474005, 475686, 475110, 475002, 474004, 474011, 474002, 474003, 474008,
        474009, 474010, 474007, 474012,
      ],
      Datia: [
        475671, 475682, 475673, 475335, 475661, 475685, 475336, 475675, 475686,
      ],
      Bhind: [
        475115, 475110, 477441, 477227, 477555, 477111, 477116, 477445, 477557,
        477331, 477446, 477660, 477332, 477449, 477447, 477333, 477001, 477105,
        477566, 477335, 477117, 477222,
      ],
      Morena: [
        476111, 476224, 476134, 476221, 476001, 476219, 476229, 476115, 476444,
        476554, 476228,
      ],
      Sheopur: [476332, 476337, 476339, 476335, 476355, 477332],
      Indore: [
        452006, 452003, 452005, 452007, 452013, 452001, 452002, 452010, 452016,
        452015, 452011, 452018, 452014, 452009, 452012, 453115, 453551, 453111,
        453441, 453001, 453220, 453771, 452020, 453112, 453661, 453556, 453331,
        453446, 453555, 453332,
      ],
      Dewas: [
        455001, 455116, 455227, 455336, 455332, 455223, 455118, 455115, 455459,
        455111, 455221, 455440, 455339,
      ],
      Dhar: [
        454001, 454446, 454221, 454331, 454441, 454010, 454773, 454660, 454111,
        454552, 454665, 454116, 454335, 454449, 454774, 454775,
      ],
      Katni: [
        483770, 483334, 483990, 483880, 483336, 483225, 483501, 483773, 483330,
        483331, 483222, 483440, 483442, 483332, 483775, 483504, 483220,
      ],
      Jabalpur: [
        482004, 482002, 483053, 483113, 483220, 483110, 482001, 483440, 482021,
        483001, 482008, 483225, 482056, 482051, 483119, 482020, 483105, 482003,
        482011, 482005, 483222, 483880, 482010, 483334, 482009,
      ],
      'East Nimar': [
        450337, 450001, 450331, 450661, 450551, 450117, 451441, 450881, 450116,
        450771, 450110, 450051, 450991, 450445, 450221, 450332, 450114, 450112,
        450554, 450119, 451115,
      ],
      'West Nimar': [
        451332, 451001, 451113, 451111, 451228, 451335, 451224, 451221, 451225,
        451115, 451220, 451331, 451441, 450554, 450771, 451660, 450551, 451442,
        451440,
      ],
      Barwani: [
        451666, 451556, 451551, 451447, 451449, 451770, 451881, 451660, 451442,
      ],
      Khandwa: [450117, 450116, 450661, 450112, 450337, 450554, 450551],
      Burhanpur: [450001, 450445, 450221, 450331, 450332],
      Khargone: [451332, 451660, 451441],
      Neemuch: [
        458113, 458110, 458441, 458330, 458226, 458118, 458220, 458116, 458553,
        458339, 458228, 458336, 458468, 458470,
      ],
      Mandsaur: [
        458883, 458553, 458895, 458888, 458667, 458669, 458002, 458775, 458664,
        458558, 458880, 458556, 458339, 458990, 458389, 458778, 458771, 458001,
      ],
      Jhabua: [
        457550, 457779, 457887, 457882, 457770, 457773, 457888, 457993, 457990,
        457777, 457775, 457661, 457772, 457885,
      ],
      Ratlam: [
        457550, 457114, 457555, 457222, 457336, 457001, 457226, 457331, 457118,
        457441, 457339, 457119, 457340, 457333,
      ],
      Alirajpur: [457887, 457885, 457888],
      Sehore: [
        466111, 466448, 466115, 466665, 466116, 466554, 466446, 466113, 466221,
        466001, 466331, 466125, 466651, 466445, 466114, 466661, 466120, 465693,
        466118,
      ],
      Rajgarh: [
        465669, 465674, 465677, 465697, 465687, 465693, 465667, 465680, 465683,
        465679, 465685, 465689, 465691, 465661,
      ],
      Ujjain: [
        456776, 456441, 456222, 456224, 456221, 456771, 456006, 456337, 456661,
        456770, 456335, 456440, 456443, 456331, 456313, 456665, 456664, 456550,
        456668, 456003, 456010, 456001,
      ],
      Shajapur: [
        465001, 465441, 465223, 465333, 465550, 465447, 465335, 465118, 465445,
        465110, 465226, 465337, 465339, 465220, 465227, 465230, 465449, 465116,
        465106, 465113,
      ],
    },
    name: 'MP',
  },
  MH: {
    cities: {
      Jalna: [
        431132, 431202, 431208, 431204, 431203, 431212, 431211, 431114, 431215,
        431206, 431214, 431209, 431121, 431213, 431137, 431205, 431207, 431134,
        431504, 431512, 431501, 431507, 431502, 431503,
      ],
      Aurangabad: [
        431104, 431007, 431008, 431121, 431110, 431118, 431117, 423701, 431134,
        431103, 431133, 431112, 431113, 431151, 431107, 431002, 431001, 431005,
        431115, 431202, 431120, 431136, 431105, 431116, 431135, 431150, 431004,
        431154, 423703, 431114, 431137, 431111, 431102, 431006, 431147, 431003,
        423702, 431101, 431109, 431009, 431148, 431132, 431106, 431010,
      ],
      Beed: [
        431517, 431153, 431143, 413207, 431523, 431124, 414202, 431131, 431126,
        431127, 431130, 413249, 414203, 431518, 431122, 431530, 414208, 414205,
        431128, 414204, 431129, 431123, 431125, 431144, 431515, 413229, 431519,
        431142, 431520,
      ],
      Jalgaon: [
        425508, 425305, 425303, 425107, 425302, 425507, 425108, 425524, 425304,
        425306, 425301, 425503, 425310, 425201, 425203, 425327, 425505, 424208,
        425311, 425506, 425307, 425114, 424204, 424206, 425501, 425309, 425308,
        425504, 425502, 424207, 424205, 425111, 425110, 424104, 424105, 425420,
        425401, 425002, 425103, 424201, 425115, 425101, 425003, 425113, 424107,
        424119, 425102, 425109, 424106, 425105, 425402, 425104, 425116, 424108,
        424101, 424203, 425112, 424103, 424102, 425001, 424202, 425004,
      ],
      Dhule: [
        424004, 425405, 425408, 425403, 425404, 424301, 424305, 424318, 425407,
        425427, 424006, 424304, 425421, 424002, 424306, 424310, 424303, 425406,
        425428, 424307, 424308, 424311, 424302, 425413, 424001, 424005, 424309,
        425422,
      ],
      Nandurbar: [
        425415, 425409, 425413, 425410, 425417, 425412, 425444, 425411, 425419,
        425423, 425416, 425452, 425426, 425414, 425442, 425432, 425422, 425418,
        425424,
      ],
      Nashik: [
        423502, 423101, 423201, 423208, 422209, 423301, 423302, 423204, 423402,
        423401, 423104, 423303, 423205, 423501, 422205, 423106, 423102, 423117,
        423213, 423212, 424109, 423110, 423206, 423105, 422305, 422308, 423403,
        422303, 423202, 422304, 422306, 423203, 423111, 423108, 422003, 422502,
        422215, 422004, 422211, 422212, 422208, 422207, 422010, 422007, 422204,
        422213, 422012, 422403, 422202, 422301, 422103, 422401, 422210, 422606,
        422005, 422102, 422001, 422201, 422009, 422104, 422112, 422203, 422214,
        422501, 422302, 422011, 422006, 422222, 422402, 422002, 422101, 422113,
        422105, 422221, 422206, 422013, 422008,
      ],
      Nanded: [
        431736, 431708, 431808, 431723, 431804, 431714, 431715, 431811, 431803,
        431721, 431704, 431711, 431710, 431605, 431712, 431606, 431807, 431717,
        431745, 431602, 431746, 431801, 431743, 431741, 431810, 431742, 431805,
        431604, 431806, 431809, 431603, 431707, 431716, 431719, 431709, 431713,
        431802, 431722, 431718, 431731, 431750, 431601,
      ],
      Latur: [
        413521, 413515, 413520, 413530, 413513, 413532, 413524, 413522, 413517,
        413607, 413511, 413519, 413582, 413527, 413518, 413531, 413512, 413514,
        413529, 413516, 413581, 413523, 413510, 431522, 413544, 413502,
      ],
      Osmanabad: [
        413602, 413544, 413582, 413605, 413505, 413507, 413603, 413523, 413521,
        413502, 413504, 413601, 413509, 413604, 413581, 413606, 413528, 413531,
        413506, 413525, 413608, 413527, 431522, 413514, 413607, 413516, 413405,
        413503, 413623, 413508, 413517, 413534, 413526, 413624, 413532, 413510,
        413501, 413518, 413511, 413580, 413524, 413529,
      ],
      Hingoli: [
        431513, 431705, 431703, 431701, 431501, 431512, 431702, 431542, 431509,
      ],
      Parbhani: [
        431503, 431511, 431510, 431540, 431509, 431402, 431514, 431536, 431506,
        431521, 431537, 431508, 431505, 431516, 431541, 431720, 431401,
      ],
      Kolhapur: [
        416236, 416509, 416210, 416526, 416505, 416212, 416106, 416144, 416214,
        416104, 416109, 416112, 416215, 416201, 416552, 416229, 416204, 416235,
        416114, 416220, 416001, 416120, 416208, 416504, 416206, 416118, 416502,
        416213, 416211, 416012, 416221, 416011, 416110, 416205, 416218, 416010,
        416232, 416230, 416209, 416507, 416506, 416503, 416223, 416002, 415101,
        416116, 416119, 416101, 416207, 416107, 416102, 416231, 416501, 416105,
        416103, 416013, 416216, 416005, 416202, 416508, 416203, 416115, 416143,
        416113, 416121, 416551, 416122, 416007, 416234, 416219, 416006, 416111,
        416108, 416003, 416146, 416008, 416004, 416527,
      ],
      Ratnagiri: [
        415726, 415802, 415714, 416707, 415604, 415705, 415712, 415616, 415606,
        416704, 415603, 415709, 415804, 415608, 415730, 415605, 415637, 415641,
        415806, 415203, 416702, 415803, 415634, 415610, 415703, 415643, 416712,
        415708, 415711, 415713, 415722, 415727, 415701, 415208, 416701, 415629,
        415801, 415621, 415612, 415639, 415628, 416713, 415715, 415720, 415807,
        415620, 415619, 415609, 415724, 415640, 415728, 415718, 415706, 415805,
        415710, 415611, 415626, 415615, 415702, 416705, 415614, 415716, 415613,
        415719, 416709, 415717, 415617, 415607, 415602, 415202, 415214, 415601,
        415729,
      ],
      Sindhudurg: [
        416704, 416614, 416810, 416516, 416518, 416510, 416813, 416605, 416628,
        416812, 416520, 416611, 416513, 416514, 416610, 416602, 416521, 416512,
        416511, 416608, 416613, 416601, 416632, 416609, 416523, 416606, 416603,
        416616, 416811, 416604, 416524, 416612, 416630, 416525, 416519, 416801,
        416534, 416549, 416806, 416626, 416529, 416528, 416531, 416620, 416703,
        416522, 416550, 416615, 416623, 416803, 416805, 416804, 416517, 416807,
        416515,
      ],
      Satara: [
        415715, 412206, 412803, 415537, 415205, 415539, 412806, 412802, 415012,
        415014, 415011, 415112, 415506, 415013, 415021, 415002, 415511, 415527,
        415206, 415525, 415508, 415523, 415521, 415020, 415019, 415106, 415518,
        415114, 415116, 415513, 412805, 415519, 415510, 415209, 415514, 415124,
        415507, 412804, 415109, 415526, 415010, 415022, 415501, 415515, 415505,
        415524, 415207, 415503, 415536, 415520, 415122, 415103, 415004, 415538,
        415211, 415509, 415104, 415504, 415111, 415540, 415512, 415105, 415015,
        415522, 415530, 412801, 415528, 415312, 415110, 415502, 415516, 415003,
        415108, 415115, 415023, 415212, 415102, 415107, 415001, 415517,
      ],
      Sangli: [
        416403, 416411, 415311, 415401, 415409, 416419, 416308, 415305, 415303,
        416310, 416311, 416412, 416402, 416416, 416316, 416404, 415408, 416401,
        415415, 416312, 416301, 415301, 416303, 415315, 416302, 415411, 415307,
        416309, 416413, 415410, 416436, 416410, 415306, 415302, 415310, 415309,
        416420, 415402, 416304, 415413, 415405, 415412, 416405, 416305, 416407,
        416315, 416408, 415308, 416415, 416314, 415403, 416313, 415304, 415406,
        416306, 415404, 416307, 416417, 416418, 416406, 415407, 416409, 415414,
        416437, 415313, 416414,
      ],
      Mumbai: [
        400037, 400003, 400012, 400009, 400033, 400014, 400010, 400031, 400015,
        400027, 400029, 400099, 400069, 400053, 400058, 400051, 400050, 400093,
        400052, 400057, 400056, 400059, 400049, 400061, 400054, 400055, 400096,
        400098, 400094, 400085, 400084, 400075, 400082, 400042, 400078, 400074,
        400071, 400089, 400022, 400043, 400086, 400088, 400083, 400070, 400019,
        400081, 400080, 400024, 400087, 400076, 400079, 400077, 400072, 400065,
        400104, 400066, 400091, 400092, 400067, 400068, 400063, 400095, 400060,
        400102, 400101, 400064, 400097, 400103, 400004, 400005, 400001, 400020,
        400032, 400002, 400021, 400011, 400007, 400028, 400030, 400026, 400013,
        400017, 400008, 400034, 400016, 400006, 400025, 400035, 400018,
      ],
      'Raigarh(MH)': [
        400001, 410206, 410221, 410201, 410207, 400702, 410101, 410208, 410203,
        410216, 400707, 410218, 410202, 410210, 410204, 410102, 410220, 410222,
        400704, 402305, 402303, 402403, 402103, 402401, 402203, 402126, 402204,
        402201, 402307, 402107, 402101, 402301, 402106, 402113, 402109, 410205,
        402208, 402114, 402104, 402306, 402120, 402404, 402302, 402308, 402111,
        402110, 402202, 402122, 402105, 415213, 402304, 402102, 402117, 402402,
        402209, 402115, 402309, 402108, 402112, 402125, 402116, 402207,
      ],
      Thane: [
        400708, 400614, 400706, 400701, 400703, 400709, 400710, 421506, 421601,
        421302, 421501, 400610, 421102, 421503, 421402, 400608, 421002, 421603,
        421308, 421312, 400607, 400612, 421203, 421201, 421306, 421403, 400602,
        421505, 400606, 400605, 421301, 421602, 400615, 421401, 421605, 421204,
        421311, 400603, 421103, 421502, 421101, 400601, 421004, 421005, 421305,
        421202, 400604, 421303, 401606, 401102, 401301, 401602, 401501, 401302,
        401103, 401604, 401403, 401601, 401202, 401201, 401303, 401105, 401101,
        401701, 401503, 401603, 401605, 401608, 401502, 401610, 401405, 401106,
        401206, 401203, 401107, 401702, 401208, 401304, 401607, 401204, 401401,
        401402, 401703, 401207, 401209, 401404, 401504, 401609, 401506, 401305,
      ],
      Akola: [
        444126, 444108, 444006, 444002, 444001, 444101, 444401, 444511, 444107,
        444311, 444102, 444003, 444501, 444104, 444302, 444117, 444106, 444506,
        444407, 444103, 444111, 444502, 444109, 444004, 444005, 444405, 444402,
      ],
      Washim: [
        444510, 444503, 444507, 444409, 444404, 444110, 444505, 444004, 444506,
        444504, 444403, 444105, 444106,
      ],
      Amravati: [
        444806, 444901, 444705, 444706, 444801, 444908, 444905, 444717, 444601,
        444802, 444904, 444906, 444602, 444701, 444709, 444702, 444723, 444704,
        444719, 444808, 444708, 444720, 444805, 444807, 444813, 444606, 444707,
        444803, 444710, 444711, 444902, 444605, 444809, 444903, 444804, 444607,
        444907, 444603, 444810, 444604, 442302,
      ],
      Buldhana: [
        443203, 443403, 444203, 443103, 443404, 443206, 443201, 444303, 444312,
        444301, 443301, 443303, 443402, 443101, 444204, 443102, 443106, 443002,
        444306, 443202, 444202, 443204, 443001, 443401, 443308, 443112, 443304,
        443104, 443302, 444201, 444304,
      ],
      Gadchiroli: [
        442707, 442705, 442703, 442605, 442903, 442603, 441207, 441217, 442504,
        441208, 441209, 442604, 442710, 442704, 442709, 442606,
      ],
      Chandrapur: [
        442904, 441206, 442905, 442702, 441221, 442906, 442903, 441207, 442914,
        441223, 441215, 442917, 442403, 442908, 442901, 442701, 441226, 442902,
        441224, 441225, 442502, 442402, 442401, 442501, 442404, 442907, 441212,
        442918, 442916, 442505, 441205, 442605, 441222, 442507, 442504, 442503,
        442710, 442406, 442606,
      ],
      Nagpur: [
        440010, 440003, 440024, 440008, 440037, 440014, 440013, 440001, 440019,
        440012, 440017, 440018, 440036, 440035, 440025, 440022, 440032, 440030,
        440034, 440005, 440002, 440015, 440020, 440027, 440006, 440016, 440033,
        440026, 440007, 440021, 441210, 441107, 440023, 441201, 441401, 441202,
        441110, 441203, 441106, 441108, 441101, 441501, 441304, 441214, 441305,
        441104, 441102, 441113, 441204, 441105, 441301, 441302, 441306, 441502,
        441103, 441123, 441404, 441122, 441111, 441001, 441112, 441303, 441109,
      ],
      Gondia: [
        441614, 441901, 441902, 441911, 441701, 441601, 441807, 441702, 441801,
        441806, 441916,
      ],
      Bhandara: [
        441903, 441908, 441912, 441910, 441802, 441804, 441914, 441907, 441915,
        441805, 441906, 441905, 441803, 441904, 441809, 441924, 441913, 441909,
      ],
      Wardha: [
        442101, 442307, 442001, 442304, 442202, 442201, 442301, 442302, 442104,
        442102, 442203, 442003, 442306, 442106, 442305, 442111, 442303, 442105,
      ],
      Yavatmal: [
        445304, 445210, 445215, 445102, 445302, 445109, 445207, 445301, 445205,
        445402, 445305, 445110, 445105, 445103, 445001, 445101, 445106, 445204,
        445206, 445202, 445002, 445230, 445201, 445303, 445308, 445306, 445307,
        445323, 445203, 445401, 445209, 445211, 445216,
      ],
      'Ahmed Nagar': [
        414001, 413701, 414002, 414005, 414701, 414502, 414102, 414305, 414402,
        414505, 414301, 413201, 413702, 414401, 413703, 414302, 414006, 414504,
        414403, 413205, 414113, 414103, 413728, 414201, 414503, 414105, 414606,
        414106, 414111, 414306, 413704, 414501, 414304, 413204, 414303, 414607,
        414101, 414601, 414602, 413726, 414110, 414003, 422601, 422620, 422610,
        422605, 413715, 413705, 413714, 413738, 423107, 413737, 422602, 422604,
        413725, 414603, 413739, 414609, 414605, 413721, 413708, 423601, 413723,
        423604, 413706, 413710, 422611, 413736, 423603, 414604, 413716, 423607,
        422603, 413719, 413718, 422622, 413709, 423605, 413717, 413720, 423602,
        423109, 413712, 413713, 422608, 413722, 413707, 413711,
      ],
      Solapur: [
        413306, 413212, 413308, 413101, 413307, 413211, 413208, 413309, 413304,
        413305, 413203, 413209, 413301, 413302, 413252, 413202, 413319, 413310,
        413111, 413223, 413315, 413322, 413317, 413113, 413112, 413109, 413210,
        413314, 413251, 413107, 413206, 413250, 413108, 413118, 413228, 413409,
        413215, 413216, 413222, 413214, 413219, 413253, 413221, 413002, 413006,
        413303, 413248, 413008, 413220, 413218, 413255, 413226, 413401, 413403,
        413213, 413406, 413404, 413412, 413005, 413410, 413324, 413402, 413227,
        413003, 413004, 413001, 413411, 413224, 413217, 413007,
      ],
      Pune: [
        411014, 411040, 411032, 411035, 411003, 411027, 411026, 411039, 411037,
        411001, 411031, 411062, 411019, 411033, 411012, 411015, 411028, 411013,
        411057, 411017, 411034, 411048, 411047, 411018, 411060, 411036, 411044,
        411061, 411022, 411006, 411004, 411046, 411051, 411021, 411007, 411002,
        411045, 411008, 411042, 411038, 411020, 411005, 411043, 411041, 411016,
        411052, 411011, 411024, 411023, 411030, 411009, 411058, 410506, 410509,
        413132, 412411, 412205, 412201, 412105, 413801, 412211, 412206, 410507,
        412115, 410401, 412213, 410501, 410505, 410502, 412218, 412408, 412410,
        413114, 412212, 412401, 412207, 412404, 412406, 412402, 412405, 412204,
        413102, 413133, 413103, 412108, 413104, 412303, 412203, 412209, 412214,
        413105, 413130, 412301, 412106, 410513, 413106, 412202, 412208, 410503,
        410515, 412409, 412101, 412112, 412305, 412311, 412109, 413110, 410508,
        412403, 411025, 412216, 410516, 413120, 412210, 412102, 412104, 410504,
        412306, 410402, 412215, 412107, 410403, 410405, 412412, 412219, 412220,
        410512, 413116, 410301, 412110, 412103, 410511, 413802, 410510, 413115,
        412307, 412304, 410406, 412308, 410302, 412312,
      ],
    },
    name: 'MH',
  },
  MN: {
    cities: {
      'Imphal West': [
        795002, 795132, 795136, 795115, 795009, 795116, 795003, 795004, 795146,
        795113, 795001, 795140,
      ],
      Churachandpur: [795143, 795128, 795139, 795117, 795006, 795118],
      Chandel: [795102, 795131, 795127, 795135, 795101],
      Thoubal: [795135, 795149, 795130, 795103, 795138, 795101, 795148, 795132],
      Tamenglong: [795141, 795125, 795159, 795147],
      Ukhrul: [795145, 795142, 795144],
      'Imphal East': [
        795005, 795010, 795114, 795008, 795116, 795003, 795136, 795140,
      ],
      Bishnupur: [795134, 795126, 795133, 795124, 795118],
      Senapati: [
        795118, 795112, 795122, 795104, 795129, 795107, 795007, 795015, 795150,
        795106, 795125,
      ],
    },
    name: 'MN',
  },
  ML: {
    cities: {
      'West Garo Hills': [
        794002, 794115, 794101, 794106, 794103, 794104, 794109, 794005, 794105,
        794112, 794107, 794108, 794001,
      ],
      'East Garo Hills': [
        783123, 794111, 794110, 794108, 794002, 794107, 783134, 793106,
      ],
      'Jaintia Hills': [793150, 793109, 793160, 793200, 793151, 793210],
      'East Khasi Hills': [
        793011, 793106, 793107, 793004, 793111, 793108, 793112, 793109, 793005,
        793012, 793007, 793002, 793110, 793015, 793021, 793022, 793010, 793003,
        793113, 793121, 793016, 793009, 793017, 793008, 793001, 793018, 793019,
        793014, 793006, 793104,
      ],
      'South Garo Hills': [794102, 794114],
      'Ri Bhoi': [793104, 793103, 793101, 793102, 793105, 793122, 793123],
      'West Khasi Hills': [793106, 793119, 793120, 793114, 793121, 793115],
    },
    name: 'ML',
  },
  MZ: {
    cities: {
      Aizawl: [
        796190, 796261, 796001, 796007, 796008, 796161, 796014, 796070, 796005,
        796012, 796009, 796017, 796111, 796471, 796421, 796410, 796004, 796101,
      ],
      Mammit: [796501, 796471, 796431, 796441, 796410, 796421],
      Lunglei: [796571, 796770, 796730, 796581, 796701, 796710, 796751, 796691],
      Kolasib: [796081, 796091, 796070, 796082, 796101],
      Lawngtlai: [796891, 796901, 796770],
      Champhai: [796321, 796370, 796320, 796310, 796290],
      Saiha: [796901],
      Serchhip: [796181, 796370, 796184, 796186],
    },
    name: 'MZ',
  },
  NL: {
    cities: {
      Zunhebotto: [798620, 798619, 797109, 798627],
      Dimapur: [797106, 797115, 797103, 797117, 797116, 797112, 797113, 797118],
      Wokha: [797100, 797111, 797099],
      Phek: [797114, 797104, 797102, 797108, 797107],
      Mokokchung: [
        798601, 798604, 798618, 798613, 798614, 798615, 798617, 798623,
      ],
      Kiphire: [798611],
      Tuensang: [798616, 798612, 798626],
      Mon: [798603, 798622, 798621, 798602],
      Kohima: [
        797109, 797105, 797003, 797121, 797005, 797002, 797001, 797004, 797120,
        797101,
      ],
      Peren: [797110, 797101],
      Longleng: [798625],
    },
    name: 'NL',
  },
  OR: {
    cities: {
      Ganjam: [
        761111, 761144, 761118, 761120, 761121, 761119, 761104, 761108, 761117,
        761110, 761151, 761143, 761131, 761124, 761109, 761101, 761116, 761125,
        761141, 761114, 761107, 761115, 761106, 761123, 761133, 761122, 761126,
        761132, 761103, 761146, 761102, 761140, 761013, 761026, 761029, 761019,
        761012, 761005, 761035, 760010, 761100, 761017, 761043, 761041, 761105,
        761032, 761011, 761006, 761007, 761045, 761018, 761004, 761042, 760001,
        760007, 761010, 761002, 761030, 761054, 761003, 760004, 760002, 761055,
        761031, 761001, 761209, 761028, 761008, 761014, 761020, 760003, 761009,
        761052, 761037, 761027, 760005, 760008, 761025, 760009, 760006,
      ],
      Gajapati: [
        761215, 761211, 761207, 761217, 761016, 761201, 761015, 761214, 761017,
        761206, 761208, 761210, 761213, 761200, 761212, 761018, 761014,
      ],
      Kalahandi: [
        766011, 766018, 766015, 766019, 766102, 766028, 766017, 766036, 766014,
        766002, 766037, 766100, 766023, 766029, 766013, 766020, 766027, 766103,
        766012, 766001, 766101, 766107, 766016, 766031, 766110, 766026, 766118,
        766032,
      ],
      Nuapada: [766106, 766111, 766105, 766104, 766118, 766107, 766108],
      Koraput: [
        764021, 764027, 764055, 764039, 764056, 764005, 764002, 764001, 764037,
        764041, 764040, 764038, 764043, 764014, 764006, 764058, 764057, 764044,
        763008, 765013, 764028, 763003, 764036, 764003, 764011, 764081, 764004,
        764020, 763004, 764042, 763002, 763001,
      ],
      Rayagada: [
        765015, 765020, 765025, 765021, 765017, 765026, 765019, 765002, 765033,
        765016, 765029, 765024, 764062, 765018, 765023, 765013, 765022, 765034,
        764059, 765001,
      ],
      Nabarangapur: [
        764073, 764059, 764063, 764049, 764077, 764075, 764072, 764061, 764076,
        764074, 764070, 764071, 764078, 764085, 764055, 765017, 764088,
      ],
      Malkangiri: [
        764044, 764087, 764052, 764041, 764051, 764047, 764086, 764045, 764046,
        764043, 764048,
      ],
      Kandhamal: [
        762112, 762029, 762021, 762018, 762010, 762012, 762104, 762103, 762101,
        762110, 762002, 762109, 762102, 762022, 762105, 762011, 762027, 762106,
        762028, 762107, 762100, 762019, 762001, 762020,
      ],
      Boudh: [
        762023, 762015, 762020, 762013, 762017, 762026, 762030, 762014, 762024,
        762016, 762018, 762012,
      ],
      Baleswar: [
        756047, 756038, 756049, 756036, 756086, 756043, 756027, 756030, 756034,
        756046, 756045, 756028, 756058, 756048, 756019, 756044, 756079, 756033,
        756026, 756037, 756051, 756001, 756024, 756083, 756003, 756080, 756060,
        756042, 756035, 756029, 756085, 756025, 756056, 756023, 756081, 756021,
        756022, 756039, 756020, 756055, 756084, 756040, 756041, 756059, 756032,
        756002, 756134, 756182, 756126, 756166, 756115, 756133,
      ],
      Bhadrak: [
        756114, 756125, 756128, 756122, 756113, 756124, 756118, 756101, 756129,
        756116, 756112, 756123, 756117, 756115, 756144, 756138, 756139, 756131,
        756168, 756137, 756121, 756165, 756135, 756130, 756164, 756111, 756133,
        756119, 756167, 756100, 756181, 756120, 756163, 756132, 756171, 756127,
        756162,
      ],
      Kendujhar: [
        756121, 755019, 758076, 758043, 758082, 758047, 758022, 758021, 758031,
        758032, 758015, 758016, 758017, 758027, 758044, 758028, 758079, 758014,
        758083, 758045, 758020, 758034, 758037, 758025, 758023, 758026, 758081,
        758038, 758085, 758035, 758018, 758078, 758013, 758080, 758029, 758084,
        758002, 758030, 758046, 758041, 758019, 758040, 758001, 758036,
      ],
      Khorda: [
        751001, 752103, 751022, 751020, 751019, 751003, 751009, 752102, 751014,
        751018, 752100, 752101, 751002, 752115, 751006, 751011, 751016, 751025,
        751015, 751024, 751030, 751017, 751012, 751008, 751010, 751013, 751023,
        751007, 751021, 751005, 751004, 754001, 754012, 754005, 754004, 752021,
        752060, 752054, 752030, 752031, 752066, 752064, 752050, 752035, 752061,
        752023, 752057, 752019, 752056, 752034, 752027, 752062, 752020, 752038,
        752018, 752022, 752055, 752037,
      ],
      Puri: [
        752109, 752110, 752106, 752120, 752121, 752105, 752111, 752118, 752104,
        752107, 752114, 752108, 752113, 752116, 752119, 752016, 752014, 752012,
        752017, 752011, 752002, 752030, 752046, 752045, 752001, 752013, 752015,
        752003,
      ],
      Cuttack: [
        752120, 753012, 754011, 754010, 754009, 753014, 754004, 754005, 754018,
        753001, 754001, 754008, 754006, 754112, 753011, 753002, 754100, 754003,
        753006, 753004, 753003, 754013, 754007, 754105, 753010, 753013, 753008,
        754002, 753007, 753009, 753015, 754209, 754221, 754208, 754204, 754293,
        754202, 754207, 754206, 754203, 754205, 754035, 754030, 754037, 754028,
        754032, 754113, 754029, 754295, 754131, 754134, 754031, 754200, 754022,
        754290, 754201, 754025, 754130, 754027, 754026, 754021, 754023, 754071,
      ],
      Jajapur: [
        755016, 755005, 754205, 755009, 755036, 755013, 755018, 755019, 755004,
        755010, 755001, 755023, 755007, 755027, 755008, 755024, 755012, 755015,
        755017, 755003, 755014, 755062, 755026, 755025, 754292, 755043, 755044,
        755028, 755006, 755022, 755011, 755020, 755050, 755049, 754214, 754024,
        754296, 754023, 754082, 758025,
      ],
      Kendrapara: [
        754220, 754215, 754223, 754228, 754212, 754214, 754250, 754217, 754218,
        754240, 755061, 754231, 754213, 754219, 754245, 754244, 754225, 754227,
        754224, 754289, 754246, 754222, 754253, 754239, 754210, 754248, 754203,
        754216, 754211, 754162, 754141, 754153, 754134,
      ],
      Jagatsinghapur: [
        754119, 754102, 754132, 754108, 754107, 754130, 754103, 754162, 754139,
        754140, 754138, 754120, 754113, 754114, 754106, 754141, 754142, 754136,
        754111, 754135, 754110, 754294, 754137, 754109, 754104, 754159, 754133,
        754134, 754160, 754145, 754143,
      ],
      Mayurbhanj: [
        757025, 757050, 757082, 757052, 757055, 757075, 757048, 757041, 757028,
        757030, 757087, 757001, 757035, 757105, 757043, 757042, 757021, 757018,
        757039, 757083, 757054, 757033, 757032, 757029, 757034, 757019, 757026,
        757016, 757047, 757020, 757084, 757086, 757100, 757053, 757074, 757023,
        757036, 757092, 757040, 757077, 757045, 757051, 757022, 757003, 757014,
        757031, 757046, 757104, 757101, 757024, 757091, 757049, 757107, 757085,
        757038, 757002, 757073, 757037, 757017, 757081, 757102, 757079, 757093,
        757103, 757027, 757106,
      ],
      Nayagarh: [
        752093, 752024, 752078, 752025, 752094, 752065, 752063, 752084, 752068,
        752082, 752077, 752026, 752085, 752070, 752089, 752081, 752080, 752092,
        752091, 752090, 752079, 752083, 752069,
      ],
      Balangir: [
        767066, 767020, 767022, 767033, 767032, 767002, 767016, 767067, 767030,
        767029, 767060, 767038, 767037, 767026, 767025, 767024, 767021, 767001,
        767040, 767027, 767041, 767048, 767028, 767061, 767042, 767035, 767039,
        767065, 767046, 767023, 767068, 767070,
      ],
      Sonapur: [
        767018, 767016, 767045, 767017, 767023, 767019, 767062, 767020, 767068,
      ],
      Angul: [
        759125, 759126, 759122, 759132, 759128, 759100, 759117, 759103, 759129,
        759118, 759143, 759141, 759105, 759116, 759124, 759104, 759119, 759127,
        759130, 759147, 759102, 759111, 759145, 759123, 759146, 759148, 759037,
        759101, 759107, 759040, 759106,
      ],
      Dhenkanal: [
        759146, 759026, 759120, 759024, 759017, 759019, 759020, 759014, 759039,
        759013, 759027, 759025, 759028, 759023, 759016, 759018, 759022, 759121,
        759015, 759021, 759001, 759128,
      ],
      Sambalpur: [
        768006, 768104, 768004, 768113, 768222, 768228, 768221, 768112, 768227,
        768107, 768105, 768025, 768212, 768005, 768106, 768214, 768200, 768001,
        768017, 768026, 768224, 768018, 768016, 768020, 768019, 768045, 768003,
        768002, 768118,
      ],
      Bargarh: [
        768040, 768029, 768031, 768042, 768104, 768103, 768027, 768038, 768032,
        768036, 768052, 768045, 768028, 768039, 768033, 768030, 768034, 768049,
        768035, 768050, 768037, 768102, 768111, 768115, 768048,
      ],
      Jharsuguda: [
        768215, 768202, 768226, 768220, 768219, 768211, 768217, 768218, 768213,
        768216, 768204, 768203, 768234, 768201, 768225, 768233,
      ],
      Debagarh: [768110, 768109, 768108, 768121, 768119, 768107, 768228],
      Sundergarh: [
        770033, 770036, 770017, 770012, 770020, 770016, 770018, 769043, 770021,
        770015, 770014, 770037, 770040, 770019, 770072, 770038, 770022, 770073,
        770031, 770076, 770074, 770051, 770002, 770032, 770035, 770041, 769012,
        770075, 770011, 770024, 769001, 770043, 769004, 770034, 770044, 770001,
        770048, 770013, 769007, 770039, 770023, 770046, 769042, 770070, 769003,
        769015, 770052, 769009, 769010, 769011, 769013, 769014, 769002, 769005,
        769006, 769008, 769016, 770042,
      ],
    },
    name: 'OR',
  },
  PY: { cities: {}, name: 'PY' },
  PB: {
    cities: {
      Chandigarh: [
        140119, 160003, 160004, 140125, 160036, 160047, 160017, 160014, 160101,
        160012, 160018, 160002, 160001, 140133, 160025, 160102, 160019, 160011,
        160015, 160020, 160022, 160023, 160030, 160009,
      ],
      Ropar: [
        140118, 140119, 140125, 140102, 140126, 140133, 140117, 140115, 140108,
        140101,
      ],
      Mohali: [
        140103, 140413, 140604, 140110, 140507, 140112, 160003, 140506, 160104,
        140501, 140901, 140307, 140109, 140201, 160103, 140301, 140603,
      ],
      Rupnagar: [
        140111, 140108, 160055, 140117, 140413, 160014, 140307, 140112, 140101,
        140119, 140114, 140103, 140102, 160059, 160062, 160071, 140301, 140133,
        140306, 140124, 140126, 140123, 140113, 140116, 140308, 140125, 140115,
        140001, 140901,
      ],
      Patiala: [
        140201, 140603, 140506, 147111, 147202, 147201, 140701, 147006, 140802,
        147105, 147102, 147001, 147101, 140601, 141411, 140402, 140412, 140602,
        147103, 147203, 147021, 147104, 147003, 147007, 140417, 140702, 147004,
        140401, 147005, 140406, 141801, 147002,
      ],
      Ludhiana: [
        141003, 141012, 141008, 141013, 141007, 141001, 141014, 141010, 141006,
        141017, 141015, 141016, 141002, 141004, 141105, 141104, 142034, 141116,
        141414, 141401, 141108, 141203, 141107, 142027, 141119, 142021, 141412,
        141205, 141202, 142033, 141416, 142024, 141110, 142032, 141418, 141121,
        141112, 141114, 141109, 141102, 142025, 141415, 141206, 141120, 141422,
        141127, 141421, 141118, 142030, 141417, 142035, 141113, 141204, 142022,
        141101, 142029, 141413, 142036, 141419, 142023, 141106, 141115, 141117,
        142031, 142026, 141122, 141126, 141125, 141103, 141201, 142028, 141123,
        141411, 148107,
      ],
      'Fatehgarh Sahib': [
        141421, 140406, 147203, 140405, 140412, 141411, 140602, 141801, 140407,
        147301, 140417, 140802,
      ],
      Sangrur: [
        148021, 148026, 148022, 148027, 148002, 148024, 148018, 148025, 148031,
        148028, 148106, 148033, 148034, 148102, 148030, 148017, 148001, 148019,
        148023, 148029, 148035, 148020, 148108,
      ],
      Barnala: [
        148105, 148106, 148100, 148101, 148109, 148104, 148103, 148108, 148107,
        148025, 148102, 148024,
      ],
      Amritsar: [
        143502, 143101, 143102, 143116, 143001, 143114, 143108, 143202, 143119,
        143402, 143302, 143601, 143204, 143606, 143117, 143303, 143411, 143305,
        143105, 143006, 143201, 143407, 143304, 143107, 143149, 143409, 143504,
        143109, 143112, 143111, 143009, 143413, 143203, 143205, 143022, 143414,
        143103, 143410, 143603, 143115, 143416, 143406, 143008, 143501, 143113,
        143005, 143412, 143002, 143415, 143301, 143419, 143408,
      ],
      'Tarn Taran': [
        143301, 143419, 143412, 143111, 143304, 143416, 143406, 143118, 143117,
        143303, 143302, 143107, 143408, 143305, 143022, 143601, 143422, 143415,
        143410, 143501, 143114, 143402, 143407, 143112, 143411, 143115, 143413,
        143409, 143113, 143401, 143009,
      ],
      Bathinda: [
        151201, 151108, 151104, 151501, 151102, 151103, 151510, 151005, 151401,
        151301, 151004, 151001, 151302, 151206, 151106, 151105, 151101, 151509,
        151002, 151111, 151003,
      ],
      Mansa: [
        151506, 151507, 151502, 151505, 151510, 151503, 151504, 151501, 151508,
        151509,
      ],
      Muktsar: [
        152114, 152026, 151210, 152025, 152113, 152112, 152032, 152107, 152115,
        152101, 152031, 151211, 151202, 152022,
      ],
      Moga: [
        142053, 142038, 142037, 142011, 142039, 142002, 142048, 142040, 142054,
        142003, 142055, 142046, 142057, 142056, 142001, 142049, 142045, 151208,
        142042, 152028, 142058, 142043,
      ],
      Faridkot: [
        151213, 151207, 151205, 151208, 151212, 151202, 151204, 151209, 151203,
        152025,
      ],
      Firozpur: [
        152116, 152022, 152024, 152021, 152124, 152121, 152117, 152128, 152002,
        152004, 152122, 152123, 142044, 142052, 152132, 152005, 142041, 152003,
        152001, 152033, 152023, 142047, 142050, 142060, 152028, 142043,
      ],
      Fazilka: [152118],
      Gurdaspur: [
        145001, 143511, 143507, 143517, 143527, 143531, 143530, 143529, 143520,
        143534, 143515, 143512, 143505, 143506, 143532, 145023, 143604, 145022,
        143525, 145025, 143513, 143514, 143533, 143528, 145026, 143518, 143516,
        143519, 143605, 143526, 143602, 145101, 143521, 145027, 145029, 145024,
      ],
      Pathankot: [
        145027, 145022, 143533, 145024, 145025, 145101, 145026, 145029, 145023,
        143534,
      ],
      Hoshiarpur: [
        144214, 146024, 146112, 144520, 144404, 146111, 144202, 144207, 144224,
        146102, 144406, 144528, 144223, 144105, 144208, 144522, 146001, 144206,
        146105, 144204, 146104, 146023, 146101, 144306, 144527, 146021, 144519,
        144305, 146113, 144221, 146103, 144213, 144529, 144523, 144210, 144212,
        146110, 144532, 144209, 146022, 144205, 144222, 144530, 146109, 146106,
        146116, 146107, 144211, 146115, 146114, 146108, 144531, 144525, 144521,
        144216,
      ],
      Nawanshahr: [
        144521, 144533, 144526, 144522, 144524, 146115, 144525, 144527, 144532,
        144224, 144514, 144513, 144417, 144505, 144517, 144508, 144518, 144504,
        144516, 144422, 144503, 144506, 144512, 144421, 144507, 144515, 144511,
        144510, 144501, 144509, 144502, 144415, 144029,
      ],
      Jalandhar: [
        144103, 144102, 144106, 144301, 144416, 144002, 144418, 144012, 144021,
        144008, 144001, 144302, 144201, 144003, 144419, 144101, 144409, 144006,
        144025, 144029, 144028, 144009, 144023, 144104, 144502, 144010, 144511,
        144004, 144410, 144005, 144303, 144020, 144030, 144026, 144024, 144007,
        144022, 144417, 144011, 144027, 144014, 144041, 144623, 144703, 144702,
        144629, 144040, 144403, 144044, 144407, 144405, 144039, 144033, 144034,
        144036, 144043, 144630, 144701, 144042, 144805, 144032, 144633, 144311,
        144801, 144035, 144806, 144402, 144037, 144603, 144031,
      ],
      Kapurthala: [
        144603, 144621, 144622, 144601, 144402, 144401, 144804, 144620, 144632,
        144628, 144624, 144411, 144626, 144803, 144606, 144819, 144802, 144623,
        144033, 144625, 144629, 144631, 144702, 144408, 144602, 144403, 144032,
      ],
    },
    name: 'PB',
  },
  RJ: {
    cities: {
      Ajmer: [
        305002, 305801, 305003, 305005, 305001, 305813, 305819, 305206, 305811,
        305004, 305025, 305814, 305022, 305023, 305205, 305812, 305817, 305802,
        305007, 305012, 305021, 305815, 305024, 305009, 305816, 305404, 305207,
        305405, 305922, 305901, 305203, 305601, 305926, 305925, 305624, 305415,
        305401, 305407, 305621, 305628, 305412, 305630, 305403, 305622, 305408,
        305204, 305629, 305623, 305927, 305202, 305201, 305625, 305406, 305402,
        305627, 305923, 305924,
      ],
      Rajsamand: [
        305922, 305925, 313332, 313334, 305921, 313323, 313331, 313325, 313704,
        313324, 313341, 313301, 313322, 313329, 313333, 313321, 313342, 313202,
        313327, 313211, 313206, 313330, 313207, 313328,
      ],
      Bhilwara: [
        311402, 311022, 311204, 311603, 311026, 311025, 311605, 311804, 311201,
        311801, 311404, 311011, 311602, 311023, 311301, 311802, 311001, 311401,
        311021, 311302, 311202, 311203, 311604, 311408, 311024, 311403, 311030,
        311803, 311601, 311805, 311407, 311806,
      ],
      Chittorgarh: [
        312615, 312605, 312203, 312622, 312001, 312027, 312205, 312404, 312022,
        312604, 312619, 312202, 323303, 312402, 312620, 312612, 312602, 312204,
        312601, 323307, 312401, 312024, 312023, 312614, 312207, 312616, 312623,
        312403, 312021, 312901, 312206, 312603, 323304, 312613, 312201, 312617,
        312606, 323306, 323305, 312025, 326501,
      ],
      Banswara: [
        327034, 327022, 327032, 327605, 327021, 327023, 327031, 327602, 327025,
        327001, 327026, 327801, 327601, 327603, 327604, 327606, 327027, 327024,
      ],
      Dungarpur: [
        314024, 314021, 314027, 314030, 314801, 314037, 314025, 314036, 314035,
        314403, 314031, 314804, 314406, 314023, 314402, 314011, 314401, 314038,
        314029, 314404, 314022, 314034, 314001, 314032, 314026, 314028,
      ],
      Kota: [
        325001, 326520, 326518, 325204, 325602, 324002, 325214, 325009, 325004,
        325208, 325207, 325203, 325003, 324001, 325601, 324007, 324009, 326519,
        325201, 324010, 324008, 326529, 324003, 324006, 326517, 324005, 325202,
        326530, 324004,
      ],
      Baran: [
        325217, 325221, 325218, 325209, 325202, 325215, 325223, 325222, 325206,
        325216, 325205, 325220, 325219, 325207,
      ],
      Jhalawar: [
        326022, 326035, 326033, 326038, 326037, 326502, 326039, 326021, 326512,
        326023, 326001, 326036, 326515, 326501, 326513, 326034, 326514, 326516,
        326517,
      ],
      Bundi: [
        323024, 323603, 323803, 323001, 323021, 323022, 323614, 323616, 323301,
        323613, 323801, 323802, 323025, 323602, 323023, 323302, 323601, 323615,
      ],
      Tonk: [
        304023, 304502, 304804, 304503, 304802, 304001, 304501, 304801, 304025,
        304024, 304022, 304505, 304021, 304507, 304504, 304803,
      ],
      Udaipur: [
        313611, 313804, 313027, 313702, 313703, 313604, 313031, 313602, 313701,
        313038, 313601, 313026, 313603, 313905, 313205, 313011, 313803, 313705,
        307025, 313001, 313706, 313802, 313902, 313801, 313906, 313708, 313024,
        313204, 313203, 313003, 313605, 313201, 313903, 313015, 313904, 313022,
        313901, 313206, 313704, 313002, 313004,
      ],
      Alwar: [
        301401, 301035, 301027, 301024, 301001, 301703, 301712, 301412, 301026,
        301713, 321605, 301411, 301405, 301028, 301030, 301414, 301404, 301701,
        301714, 301406, 301410, 301408, 301407, 301402, 301413, 321607, 301021,
        301020, 301709, 321633, 301025, 301702, 301409, 301022, 301019, 301707,
        301427, 301415, 301023, 301706, 301704, 321606, 301604, 301705, 301403,
        301018, 301708, 301002, 301416,
      ],
      Bharatpur: [
        321202, 321001, 321025, 321303, 321022, 321614, 321024, 321615, 321407,
        321602, 321302, 321201, 321028, 321203, 321026, 321023, 321409, 321301,
        321021, 321406, 321205, 321204, 321642, 321601, 321206, 321411, 321408,
        321405, 321403, 321402, 321401, 321410, 321404,
      ],
      Dholpur: [
        328041, 328021, 328025, 328031, 328022, 328024, 328001, 328029, 328023,
        328030, 328028, 328026, 328027,
      ],
      Jaipur: [
        302029, 302006, 302013, 302039, 302018, 302002, 302028, 302004, 302001,
        302015, 302016, 302026, 302022, 302012, 302027, 302003, 302021, 302005,
        302017, 302036, 302031, 302037, 302020, 302040, 302034, 302033, 302019,
        303329, 303908, 303002, 303007, 303338, 303901, 303801, 303804, 303601,
        303120, 303712, 303704, 303302, 303001, 303119, 303604, 303602, 303903,
        303103, 303305, 303603, 303805, 303105, 303109, 303806, 303106, 303706,
        303301, 303102, 303328, 303107, 303110, 303003, 303006, 303701, 303807,
        303803, 303104, 303012, 303348, 303005, 303108, 303904, 303702, 303905,
        303008, 303009, 303503, 303507, 303121, 303509, 303122,
      ],
      Dausa: [
        303326, 303502, 303315, 303303, 303510, 303313, 303323, 322240, 303325,
        303503, 321608, 321609, 303304, 303305, 303507, 321613, 303327, 303501,
        303004, 303504, 303509, 303505, 303511, 321612, 303506, 303508, 303302,
      ],
      'Sawai Madhopur': [
        322701, 322001, 322201, 322027, 322025, 322021, 322212, 322703, 322218,
        322034, 322702, 322211, 322023, 322205, 322214, 322219, 322028, 322029,
        322024, 322033, 322202, 322026, 322215, 322030, 322704, 322243, 322204,
        322203, 322220,
      ],
      Karauli: [
        321611, 322218, 322251, 322241, 322243, 322216, 322204, 322238, 322249,
        322202, 322230, 322215, 322255, 322203, 321610, 322242, 322252, 322213,
        322220, 322236, 322212, 322254, 322033, 322234, 322219,
      ],
      Barmer: [
        344502, 344011, 344033, 344702, 344021, 344034, 344012, 344704, 344031,
        344701, 344706, 344022, 344026, 344001, 344708, 344032, 344501, 344035,
        344043, 344801, 344703, 344044, 344037, 344705, 344024, 344027, 344025,
      ],
      Bikaner: [
        334023, 331801, 334001, 334402, 334802, 334604, 334202, 334305, 331811,
        334601, 334022, 331803, 334803, 334004, 334801, 334303, 334302, 334603,
        334403, 334006, 334021, 334804, 334201, 334401, 334602, 334003, 334808,
      ],
      Churu: [
        331803, 331811, 331801, 331802, 331505, 331403, 331504, 331304, 331517,
        331001, 331022, 331507, 331518, 331303, 331023, 331503, 331506, 331411,
        331301, 331305, 331302, 331701, 331501, 331031, 331502, 331021, 331402,
        331029,
      ],
      Jhujhunu: [
        333001, 333023, 333026, 333029, 333021, 331025, 333027, 333033, 333501,
        333503, 333035, 333502, 331026, 333801, 333307, 333704, 333025, 333705,
        333022, 333031, 333304, 333042, 333516, 333305, 333515, 333041, 333024,
        331030, 333030, 333308, 333032, 333034, 331027, 333053, 333302, 333012,
        333303, 333701, 333707, 332716, 332746, 333504, 333514, 333011, 333702,
        333028, 331028, 333036,
      ],
      Jodhpur: [
        342311, 342001, 342308, 342037, 342606, 342025, 342901, 342014, 342603,
        342605, 342306, 342023, 342027, 342307, 342303, 342301, 342602, 342309,
        342312, 342024, 342801, 342601, 342305, 342022, 342012, 342604, 345001,
        342314, 342802, 342021, 342302, 342015, 342003, 342013, 342011, 342026,
        342005, 342007, 342006, 342028, 342304, 342008, 345021,
      ],
      Jaisalmer: [
        345001, 345023, 345028, 345021, 345027, 345024, 345025, 345034, 345031,
        345026, 342310, 345033, 342302, 345022,
      ],
      Nagaur: [
        341025, 341305, 341303, 341510, 341024, 341506, 341022, 341001, 341513,
        341504, 341508, 341514, 341519, 341319, 342902, 341306, 341302, 341518,
        341031, 341501, 341512, 341503, 341316, 341304, 341533, 341021, 341551,
        341301, 341023, 341505, 341520, 341026, 341516, 341517, 341028, 341509,
        341502, 341542, 341027, 341511, 341029, 341030, 341507, 341317, 341515,
        341318, 305026,
      ],
      Pali: [
        306302, 306103, 306504, 306102, 306703, 306301, 306602, 306303, 306104,
        306001, 306021, 306902, 306708, 306101, 306305, 306502, 306105, 306114,
        306709, 306912, 306701, 306422, 306308, 306901, 306307, 306503, 306702,
        306706, 306306, 306022, 306421, 306707, 306115, 306126, 306401, 306705,
        306601, 306023, 306304, 306603, 306116, 306501, 306119, 306704,
      ],
      Sikar: [
        332402, 332602, 332701, 332315, 332312, 332303, 332002, 332021, 332603,
        332709, 332401, 332023, 332317, 332311, 332715, 332001, 332601, 332403,
        332718, 332305, 332301, 332411, 332405, 332708, 332316, 332031, 332024,
        332714, 332742, 332028, 332025, 332318, 332404, 332713, 332703, 332042,
        332029, 332027, 332710, 332706, 332705, 332702, 332711, 331024, 332302,
        332406, 332721, 332712, 332719, 332026, 332722, 332707, 332304, 332041,
        332030, 332307,
      ],
      Sirohi: [
        307026, 307501, 307510, 307022, 307028, 307512, 307031, 307511, 307043,
        307027, 307001, 307513, 307801, 307514, 307019, 307023, 307024, 307802,
        307515,
      ],
      Jalor: [
        343041, 307030, 307029, 343040, 343039, 343025, 343001, 343049, 343027,
        343042, 343022, 343032, 343028, 343029, 343024, 307803, 343021, 307515,
        343048, 343023, 343030, 343002,
      ],
      Ganganagar: [
        335061, 335707, 335038, 335039, 335051, 335704, 335711, 335001, 335040,
        335073, 335024, 335703, 335041, 335027, 335701, 335705, 335021, 335702,
        335804, 335025, 335062, 335022, 335002, 335023, 335065, 335901, 335037,
        335805,
      ],
      Hanumangarh: [
        335524, 335024, 335802, 335512, 335803, 335501, 335063, 335513, 335523,
        335503, 335504, 335801, 335511, 335502, 335526, 335064, 335525,
      ],
    },
    name: 'RJ',
  },
  SK: {
    cities: {
      'East Sikkim': [
        737135, 737133, 737134, 737106, 737113, 737103, 737131, 737102, 737107,
        737132, 737101, 737136, 737138,
      ],
      'West Sikkim': [737111, 737121, 737113],
      'South Sikkim': [737126, 737139, 737128, 737102, 737121],
      'North Sikkim': [737120, 737117, 737116, 737118, 737119],
    },
    name: 'SK',
  },
  TN: {
    cities: {
      Chennai: [
        600002, 600005, 600094, 600086, 600006, 600017, 600014, 600034, 600004,
        600018, 600082, 600030, 600102, 600040, 600101, 600106, 600023, 600031,
        600003, 600008, 600001, 600084, 600009, 600104, 600038, 600010, 600107,
        600012, 600011, 600013, 600081, 600007, 600039, 600021, 600020, 600083,
        600090, 600032, 600025, 600015, 600036, 600078, 600024, 600085, 600092,
        600033, 600035, 600028, 600022, 600093, 600113, 600041, 600026, 600042,
        600118,
      ],
      Vellore: [
        632506, 632510, 632508, 631002, 632501, 632519, 632507, 631003, 632513,
        632511, 632502, 631001, 632517, 632503, 631151, 632509, 631051, 632505,
        632531, 631102, 632406, 632520, 632504, 632512, 632405, 631004, 632515,
        631101, 631006, 631052, 632404, 632514, 632516, 632318, 632401, 632518,
        632403, 632521, 631152, 631005, 604407, 632319, 632312, 604505, 632311,
        632011, 632010, 632101, 632102, 632009, 632204, 632202, 632107, 632055,
        632106, 632002, 632004, 632014, 632105, 632113, 632059, 632104, 632103,
        632006, 632007, 632012, 632013, 632001, 632058, 632057, 632114, 632008,
        632115, 635651, 635602, 635804, 635653, 632604, 635701, 635814, 635801,
        635802, 635806, 635702, 635652, 635811, 635810, 635601, 635852, 635703,
        635815, 635854, 632602, 635805, 632209, 635751, 635901, 635754, 635813,
        635655, 632603, 635853, 632601, 635809, 635803, 635851, 635654, 635812,
        632201, 635752, 635808, 635710, 632203, 635807,
      ],
      Tiruvannamalai: [
        632511, 632512, 632507, 606905, 606604, 606901, 632317, 604403, 632314,
        631701, 606702, 604408, 604402, 606904, 606753, 604503, 632315, 604405,
        604401, 606804, 606703, 604504, 606808, 606807, 631702, 606709, 632326,
        632301, 606752, 606806, 604407, 604501, 606803, 606708, 606902, 606907,
        606755, 604505, 606603, 606601, 606908, 606701, 606801, 632316, 604410,
        606802, 604404, 606707, 606906, 604406, 604502, 606704, 604601, 632313,
        606903, 632311, 606751, 606805, 606710, 606754, 606611, 606705, 632312,
        606706, 604409, 606811, 632319, 635703, 605702,
      ],
      Kanchipuram: [
        603301, 603001, 603110, 603109, 603003, 603312, 603107, 603307, 603401,
        603204, 603211, 603127, 603405, 603106, 603306, 603101, 603310, 603102,
        603308, 603002, 603302, 603313, 603201, 603202, 603108, 603303, 603305,
        603104, 603203, 603314, 603304, 603105, 603111, 603209, 603319, 603309,
        603311, 603210, 600088, 600016, 600115, 600097, 600091, 600089, 600061,
        600041, 600096, 600119, 603406, 603402, 631603, 631605, 601102, 631561,
        631601, 631502, 631551, 631553, 631604, 602105, 602117, 631501, 602108,
        631552, 631402, 631202, 631606, 602106, 603403, 600116, 600070, 600117,
        600044, 600064, 600059, 600058, 600122, 600073, 600045, 600056, 600047,
        603103, 600127, 603112, 600129, 600069, 600126, 601301, 600125, 600048,
        600100, 600130, 600063, 600043, 600075, 600074, 600046, 600128,
      ],
      Tiruvallur: [
        600107, 600087, 631303, 631209, 631213, 602023, 631301, 602025, 631204,
        631201, 631202, 631210, 631205, 631208, 631206, 631302, 601103, 631207,
        631203, 631304, 602026, 602021, 602002, 602003, 601102, 602024, 631211,
        631402, 631212, 602001, 602105, 601204, 600052, 600067, 600053, 600058,
        600103, 601203, 601201, 600072, 601101, 600054, 600055, 600095, 600077,
        601206, 600065, 600057, 600050, 600066, 600019, 600071, 601202, 600056,
        600099, 601205, 600076, 600062, 600128, 600124, 600051, 600060, 600123,
        600068, 600037, 600120, 600110, 600049, 600098,
      ],
      Villupuram: [
        605402, 604301, 604207, 604101, 604302, 604151, 604303, 605201, 605103,
        604203, 604202, 605651, 604210, 605202, 605108, 605203, 605652, 604152,
        605401, 604307, 605101, 604201, 604001, 605601, 605102, 604208, 604102,
        604304, 604204, 605111, 604206, 605502, 605105, 605302, 605014, 605602,
        605301, 604205, 604154, 605109, 605110, 605501, 604306, 605107, 605106,
        604305, 604153, 607101, 607805, 607201, 606102, 605758, 606213, 606115,
        605701, 606208, 606201, 606204, 607209, 605803, 606107, 606301, 605752,
        606209, 606401, 607107, 605755, 605801, 605751, 606402, 605766, 606305,
        605702, 606207, 605754, 605802, 607202, 607203, 607204, 606202, 606205,
        606203, 605756, 606206, 605759, 606104, 605757,
      ],
      Cuddalore: [
        605106, 605007, 607403, 607402, 607802, 608801, 607302, 608702, 608502,
        607205, 607003, 607101, 607109, 608305, 607301, 608704, 608401, 607106,
        608002, 608301, 607103, 608306, 608201, 608601, 608501, 607102, 607108,
        607801, 607803, 607807, 608302, 608102, 608602, 607005, 608304, 608001,
        607001, 608303, 607104, 607308, 607105, 607006, 607805, 608701, 607303,
        608703, 607112, 607004, 607401, 607002, 606304, 606106, 606108, 606303,
        606111, 606003, 606110, 606104, 606103, 606302, 606105, 607804, 606001,
      ],
      Coimbatore: [
        641110, 641101, 641112, 641108, 641032, 641046, 641019, 641105, 641018,
        641029, 641201, 641049, 641014, 641001, 641021, 641008, 641109, 641016,
        641025, 641006, 641004, 641012, 641107, 641013, 641047, 641022, 641114,
        641010, 641048, 641030, 641035, 641026, 641023, 641042, 641045, 641038,
        641003, 641050, 641062, 641020, 641036, 641031, 641033, 641028, 641011,
        641017, 641037, 641041, 641002, 641009, 641027, 641007, 641043, 641044,
        641005, 641024, 641039, 641034, 641015, 641111, 638462, 638103, 638458,
        642205, 642002, 642111, 642004, 642127, 642110, 642101, 642201, 642102,
        642103, 642104, 642154, 642120, 642007, 642109, 642206, 642207, 642106,
        642202, 642132, 642005, 642112, 642126, 642122, 642001, 642107, 642108,
        642203, 642129, 642003, 642130, 642204, 641202, 642113, 642114, 642105,
        642117, 642125, 642134, 642123, 642133, 642006, 642128, 641652, 641663,
        641302, 641665, 641655, 641653, 641687, 641664, 641402, 641604, 641407,
        641103, 641654, 641603, 641104, 641113, 641658, 641669, 641659, 641305,
        641667, 641697, 641401, 641668, 641666, 641671, 641662, 641602, 641670,
        641601, 641607, 641606, 641301, 638402, 641605, 624622,
      ],
      Dharmapuri: [
        636704, 636807, 636905, 635205, 636903, 636803, 636810, 636904, 636806,
        636906, 636813, 636811, 635201, 636805, 635301, 636808, 636804, 635302,
        636809, 635202, 635305, 636705, 636701, 636001, 636902, 635303, 636352,
        636812, 635111,
      ],
      Salem: [
        636906, 637103, 637303, 637101, 637105, 637301, 637102, 637302, 637104,
        637410, 637304, 637107, 636117, 636106, 636122, 636204, 636308, 636104,
        636004, 636003, 636141, 636105, 636002, 636139, 636108, 636101, 636107,
        636119, 636602, 636115, 637501, 636102, 636103, 636008, 636111, 636006,
        636015, 636109, 636201, 636001, 636112, 636203, 636016, 636007, 636114,
        636116, 636113, 636014, 636140, 636138, 636121, 636601, 636010, 636110,
        636142, 636118, 636501, 636503, 636451, 636404, 636307, 636009, 636502,
        636304, 636302, 636351, 636012, 636455, 636303, 636354, 636309, 636306,
        637502, 636011, 636453, 636005, 637504, 636202, 636454, 636305, 636013,
        636403, 636452, 636458, 636030, 636406, 636402, 636401, 636457, 637407,
        636456, 621110,
      ],
      Erode: [
        638502, 638454, 638501, 638455, 638457, 638453, 638109, 638311, 638752,
        638462, 638151, 638315, 638101, 638506, 638103, 638115, 638503, 638051,
        638301, 638007, 638504, 638004, 638102, 638751, 638312, 638009, 638458,
        638316, 638104, 638505, 638011, 638001, 638002, 638153, 638110, 638112,
        638452, 638476, 638056, 638052, 638107, 638314, 638116, 638003, 638154,
        638456, 638152, 638313, 638055, 638057, 638005, 638053, 638054, 638010,
        638012, 642206, 638673, 638111, 638701, 638105, 638661, 638657, 638459,
        638401, 638461, 638402, 638660, 638702, 638451, 638812, 638106, 638656,
        638672, 638460, 641605, 638706, 638108, 638703, 641607, 639202, 639201,
      ],
      Karur: [
        638151, 639207, 621311, 621313, 639203, 639008, 639003, 639201, 639111,
        639118, 639202, 639206, 639120, 639105, 621301, 639113, 639007, 639004,
        639107, 639110, 639205, 639006, 639136, 639108, 639001, 639119, 639005,
        639102, 639114, 639104, 639116, 639109, 639002, 639117, 621306, 621315,
      ],
      Namakkal: [
        638007, 638006, 637210, 637411, 637202, 637212, 637301, 637503, 637409,
        637101, 638008, 637020, 637013, 637304, 637214, 638182, 637017, 637015,
        637019, 637402, 637405, 637105, 637003, 637002, 637103, 637410, 637209,
        637201, 637018, 637021, 637205, 637204, 637213, 637102, 637014, 637404,
        638183, 637203, 637302, 637207, 637208, 637107, 637206, 637215, 637104,
        637303, 637001, 638181, 637211, 636142, 636118, 636113, 637403, 637505,
        637401, 637406, 636301, 636202, 637412, 637408, 637407, 621215,
      ],
      Krishnagiri: [
        635105, 635108, 635110, 635118, 635119, 635204, 635122, 635002, 635203,
        635104, 635206, 635304, 635102, 635306, 635107, 635307, 635109, 635103,
        635113, 635121, 635116, 635123, 635106, 635115, 635126, 635124, 635120,
        635117, 635114, 635112, 635111, 635001, 635101, 635207,
      ],
      Nilgiris: [
        643102, 643240, 643206, 643216, 643221, 643201, 643202, 643203, 643241,
        643212, 643209, 643224, 643204, 643231, 643214, 643001, 643205, 643220,
        643211, 643101, 643207, 643007, 643002, 643219, 643217, 643005, 643004,
        643006, 643237, 643226, 643103, 643236, 643225, 643213, 643215, 643253,
        643239, 643218, 643242, 643003, 643223, 643238, 643105, 643233, 643228,
        643243,
      ],
      Dindigul: [
        642113, 624614, 624302, 624702, 624212, 624003, 624101, 624709, 624710,
        624303, 624620, 624703, 624613, 624612, 624206, 624622, 624201, 624219,
        624621, 624001, 624308, 624617, 624616, 624619, 624701, 624401, 624304,
        624801, 624211, 624005, 624610, 624202, 624002, 624708, 624802, 624402,
        624615, 624712, 624301, 624204, 624711, 624705, 624004, 624704, 624216,
        624306, 624215, 624103, 624403, 624618, 624706, 624220, 624707, 624210,
        624307, 624208, 624601, 639203,
      ],
      Kanyakumari: [
        629153, 629701, 629167, 629170, 629159, 629101, 629802, 629801, 629204,
        629201, 629851, 629168, 629401, 629301, 629151, 629177, 629704, 629252,
        629202, 629803, 629852, 629001, 629166, 629804, 629161, 629152, 629003,
        629251, 629501, 629002, 629171, 629193, 629901, 629158, 629402, 629004,
        629160, 629203, 629502, 629165, 629162, 629810, 629154, 629169, 629155,
        629702, 629156, 629809, 629157, 629174, 629102, 629703, 629403, 629180,
        629164, 629163, 629302, 629178, 629601, 629602, 629172, 629175, 629173,
        629176, 629179,
      ],
      Sivaganga: [
        630201, 630107, 630003, 630307, 630301, 630303, 630202, 630207, 630101,
        630205, 630102, 630501, 630302, 630005, 630309, 630212, 630108, 630106,
        630001, 630306, 630103, 630314, 630104, 630502, 630002, 630410, 630312,
        630405, 630206, 630105, 630208, 630311, 623401, 623402, 623701, 630321,
        630611, 630305, 630713, 630553, 630556, 630211, 630612, 630551, 630566,
        630702, 630562, 630210, 630561, 630609, 630313, 630602, 630709, 630710,
        630555, 630557, 630559, 630203, 630204, 630606, 630610, 630408, 630552,
        630411, 630554, 630558, 621308,
      ],
      Ramanathapuram: [
        630312, 623601, 623502, 623521, 623705, 623512, 623712, 623701, 623401,
        623308, 623407, 623703, 623527, 623529, 623525, 623538, 623513, 623707,
        623402, 623704, 623514, 623533, 623605, 623566, 623515, 623115, 623516,
        623711, 623523, 623536, 623608, 623603, 623517, 623135, 623403, 623504,
        623530, 623528, 623706, 623531, 623604, 623409, 623120, 623532, 623519,
        623518, 623534, 623520, 623406, 623404, 623537, 623315, 623526, 623522,
        623503, 623708, 623524, 623501, 623806,
      ],
      Tuticorin: [
        628718, 628712, 628714, 628721, 628503, 628901, 628952, 628904, 628502,
        628907, 628905, 628552, 628902, 628716, 628720, 628908, 628903, 628501,
        628722, 628906, 627855, 627758, 628217, 628152, 628401, 628303, 628703,
        628002, 628704, 628206, 628619, 628612, 628215, 628701, 628201, 628210,
        628809, 628702, 628851, 628621, 628802, 628202, 628613, 628005, 628151,
        628003, 628614, 628622, 628008, 628617, 628104, 628001, 628301, 628105,
        628801, 628007, 628656, 628211, 628251, 628402, 628218, 628203, 628252,
        628615, 628618, 628204, 628205, 628304, 628302, 628653, 628103, 628101,
        628623, 628207, 628213, 628208, 628209, 628102, 628616, 628751, 628212,
        628620, 628752, 628219, 628229, 628753, 628601, 628006, 628004, 628216,
        626205, 626202,
      ],
      Tirunelveli: [
        627861, 627803, 627808, 627852, 627719, 627754, 627851, 627862, 627859,
        627758, 627757, 627760, 627814, 627853, 628502, 627855, 627805, 627953,
        627751, 627951, 627802, 627764, 627761, 627857, 627804, 627713, 628552,
        627807, 627753, 627813, 627860, 627854, 627806, 627759, 627755, 627818,
        627809, 627856, 627756, 627858, 627811, 627812, 627113, 627151, 627117,
        627413, 627416, 627428, 627421, 627652, 627201, 627354, 627412, 627425,
        627401, 627651, 627654, 627423, 627120, 627426, 627105, 627418, 627358,
        627108, 627351, 627414, 627111, 627501, 627355, 627101, 627116, 627502,
        627102, 627112, 627110, 627106, 627103, 627008, 627352, 627451, 627424,
        627602, 627104, 627010, 627114, 627007, 627011, 627415, 627202, 627001,
        627109, 627657, 627127, 627659, 627417, 627357, 627152, 627453, 627356,
        627353, 627427, 627107, 627002, 627006, 627133, 627420, 627012, 627005,
        627452, 627601, 627115, 627604, 627359, 627422, 627118, 627009, 627004,
        627603, 627131, 627003, 627119,
      ],
      Madurai: [
        625706, 625514, 625501, 625704, 625301, 625003, 625109, 625017, 625020,
        625218, 625009, 625016, 625106, 625105, 625104, 625108, 625008, 625701,
        625012, 625221, 625207, 625103, 625014, 625503, 625707, 625122, 625703,
        625007, 625019, 625708, 625005, 625201, 625205, 625011, 625702, 625102,
        625101, 625234, 625107, 625001, 625022, 625018, 625002, 625023, 625021,
        625006, 625402, 625004, 625110, 625214, 625015, 625527, 625532, 625705,
        625537, 625535, 625529,
      ],
      Theni: [
        625602, 625605, 625523, 625531, 625512, 625582, 625526, 625518, 625515,
        625517, 625528, 625536, 625513, 625556, 625527, 625516, 625520, 625604,
        625203, 625534, 625562, 625533, 625519, 625603, 625579, 625521, 625522,
        625530, 625524, 625540, 625601, 625525, 625705,
      ],
      Virudhunagar: [
        626203, 626141, 626137, 626129, 626607, 626109, 626130, 626127, 626106,
        626112, 626005, 626124, 626189, 626204, 626101, 626135, 626115, 626138,
        626142, 626102, 626002, 626134, 626202, 626108, 626121, 626139, 626188,
        626612, 626131, 626201, 626103, 626136, 626140, 626149, 626125, 626003,
        626114, 626105, 626104, 626001, 626133, 626107, 626113, 626004, 626126,
        626118, 626111, 626110, 626205, 626119, 626117, 626128, 626116, 626132,
        626122, 626123,
      ],
      Ariyalur: [
        608703, 621719, 621714, 608901, 621715, 612903, 621713, 621701, 612902,
        621718, 621801, 621709, 621802, 621803, 621851, 621704, 621729, 621707,
        621705, 612901, 621730, 621806, 621804, 621218, 612904, 621710, 621805,
        621651, 621653,
      ],
      Tiruchirappalli: [
        621308, 621314, 621310, 621306, 621307, 621312, 621302, 621315, 621305,
        621311, 621211, 621007, 621014, 621210, 621209, 621005, 621003, 620006,
        621208, 621204, 621214, 621215, 621203, 621202, 621001, 621216, 621207,
        621213, 621206, 621112, 620005, 621008, 621105, 621205, 621009, 621004,
        621002, 621012, 621006, 621011, 621111, 621217, 621104, 621110, 621101,
        621010, 620102, 620014, 621712, 621722, 621711, 621702, 620011, 620101,
        621651, 620004, 639101, 621703, 620026, 620013, 620010, 620009, 620015,
        620024, 620001, 620008, 620012, 621218, 639103, 620007, 620025, 620020,
        620021, 621653, 621652, 621706, 620023, 639115, 621715, 621601, 620016,
        620019, 639112, 620017, 620002, 620003, 620018, 620022, 607201,
      ],
      Pudukkottai: [
        621305, 621308, 621312, 614902, 622302, 614629, 622203, 622003, 613301,
        622301, 622401, 614618, 614616, 614805, 622005, 622504, 614617, 622304,
        622101, 622402, 614621, 614801, 614622, 622201, 622506, 622503, 614630,
        614624, 622515, 614619, 622001, 622501, 614620, 622102, 621316, 622412,
        622505, 622002, 622204, 622303, 622502, 622209, 622409, 622411, 622202,
        622404, 622104, 622507, 622403, 622103, 622004, 622422, 622407,
      ],
      Tiruvarur: [
        613705, 612601, 612603, 613702, 613703, 609501, 612604, 612610, 610107,
        612605, 612201, 609503, 609405, 609403, 610105, 611101, 609502, 610203,
        610106, 610201, 613701, 610101, 610103, 610102, 610001, 610104, 613704,
        610205, 610003, 610109, 609608, 610202, 609504, 610004, 609603, 614704,
        614702, 614715, 614703, 614738, 614716, 614711, 614706, 614903, 614713,
        614103, 614403, 612804, 614717, 612801, 614018, 614404, 614016, 612802,
        612701, 612803, 614017, 614001, 610206, 614013, 614708, 614705, 614014,
        614015, 614101, 614102, 614302, 614710, 614019, 614208, 614020,
      ],
      Thanjavur: [
        612101, 612103, 612202, 612105, 612104, 612401, 612106, 612501, 612503,
        612204, 612302, 612703, 612702, 612603, 612303, 612605, 609807, 609804,
        612602, 612504, 612001, 612502, 612402, 612002, 612102, 609802, 612201,
        614602, 614701, 614614, 614615, 614723, 614901, 614626, 614623, 614612,
        614903, 614906, 614613, 614904, 614803, 614902, 614628, 614625, 614804,
        614802, 614704, 614601, 614905, 613402, 612301, 614303, 613101, 613602,
        613601, 614401, 613204, 613003, 614019, 613001, 613205, 613504, 614402,
        614211, 614201, 613403, 613009, 614204, 613104, 614202, 613007, 614302,
        614203, 613005, 613102, 613502, 612802, 613002, 613201, 613202, 614017,
        614015, 613103, 614208, 614301, 613105, 613501, 613303, 614206, 613004,
        613006, 613203, 614210, 612804, 614205, 614207, 613503, 613010, 613008,
        613401,
      ],
      Nagapattinam: [
        609801, 612201, 609204, 609805, 609501, 609811, 612203, 609806, 609802,
        609807, 609808, 609804, 612102, 609810, 609803, 613702, 609403, 609101,
        609301, 609118, 609503, 609102, 609103, 609109, 609302, 609111, 609203,
        609309, 609117, 609303, 609312, 609307, 609003, 609001, 609115, 609401,
        609116, 609108, 609201, 609308, 609104, 609304, 609112, 609105, 609107,
        609106, 609402, 609202, 609314, 609113, 609404, 609313, 609114, 609305,
        609306, 609205, 609310, 609110, 609311, 609703, 611106, 609604, 611104,
        610106, 611102, 611105, 611108, 611002, 609701, 611109, 609702, 610204,
        611101, 611110, 610101, 611103, 610207, 611112, 610201, 611001, 611003,
        609704, 611111, 609504, 610203, 614707, 614810, 614714, 614809, 614711,
        614806, 614808, 614807, 614712, 614716,
      ],
      Perambalur: [
        621103, 621118, 621708, 621108, 621107, 621109, 621101, 621717, 621102,
        621219, 621212, 621115, 621113, 621104, 621133, 621106, 621110, 621716,
        621117, 621114, 621116, 621220, 621713,
      ],
    },
    name: 'TN',
  },
  TS: {
    cities: {
      Adilabad: [
        504273, 504293, 504307, 504001, 504251, 504309, 504201, 504110, 504202,
        504296, 504231, 504109, 504299, 504002, 504204, 504312, 504313, 504101,
        504205, 504203, 504295, 504106, 504306, 504304, 504103, 504308, 504311,
        504272, 504323, 504215, 504346, 504310, 504294, 504302, 504206, 504102,
        504218, 504207, 504209, 504104, 504292, 504297, 504219, 504208, 504216,
        504214, 504105, 504301, 504220, 504107, 504303,
      ],
      Warangal: [
        506144, 506343, 506145, 506169, 506355, 506366, 506172, 506342, 506224,
        506223, 506221, 506371, 506352, 506367, 506303, 506244, 506003, 506344,
        506345, 506015, 506347, 506349, 506252, 506165, 506301, 506170, 506356,
        506168, 506319, 506391, 506175, 506011, 506348, 506370, 506302, 506142,
        506004, 506143, 506201, 506001, 506151, 506167, 506009, 506164, 506310,
        506315, 506324, 506007, 506102, 506112, 506122, 506381, 506163, 506365,
        506369, 506006, 506005, 506132, 506317, 506134, 506105, 506313, 506002,
        506135, 506318, 506104, 506332, 506222, 506329, 506316, 506330, 506331,
        506008, 506314, 506013, 506368, 506101, 506166,
      ],
      'Karim Nagar': [
        505445, 505305, 505532, 505330, 505531, 505466, 505527, 505460, 505526,
        505306, 505450, 505402, 505524, 505469, 505302, 505455, 505001, 505452,
        505415, 505529, 505401, 505325, 505405, 505403, 505303, 505404, 505473,
        505454, 505528, 505453, 505462, 505301, 505501, 505467, 505331, 505304,
        505451, 505425, 505530, 505481, 505327, 505307, 505326, 505215, 505208,
        505184, 505212, 505472, 505102, 505474, 505504, 505480, 505470, 505503,
        505514, 505174, 505187, 505101, 505129, 505497, 505475, 505416, 505186,
        505498, 505505, 505122, 505476, 505502, 505471, 505525, 505490, 505188,
        505210, 505153, 505185, 505209, 505152, 505211, 505468, 505162, 505172,
        505214,
      ],
      'Mahabub Nagar': [
        509210, 509382, 509002, 509352, 509152, 509132, 509130, 509340, 509336,
        509371, 509407, 509335, 509208, 509131, 509338, 509409, 509204, 509339,
        509411, 509353, 509205, 509127, 509128, 509129, 509334, 509126, 509135,
        509311, 509350, 509351, 509125, 509337, 509380, 509219, 509001, 509153,
        509375, 509207, 509209, 509360, 509110, 509321, 509412, 509408, 509381,
        509401, 509104, 509201, 509202, 509357, 509406, 509327, 509302, 509105,
        509215, 509203, 509206, 509120, 509324, 509216, 509325, 509410, 509349,
        509358, 509385, 509106, 509103, 509320, 509235, 509228, 509102, 509376,
        509217, 509326, 509301,
      ],
      'K.V.Rangareddy': [
        509339, 509335, 509371, 509325, 509217, 509410, 509358, 500008, 500075,
        500018, 500032, 500084, 500019, 500030, 501510, 501506, 501509, 501512,
        501508, 500048, 500005, 501505, 500060, 501218, 501359, 500052, 500035,
        500079, 501511, 500076, 500068, 500074, 500070, 500039, 501142, 501144,
        501502, 501141, 501503, 501504, 501202, 501102, 501111, 501401, 500090,
        501106, 501143, 501203, 500078, 500043, 501158, 501501, 501121, 500100,
        501301, 500049, 500088,
      ],
      Medak: [
        502278, 502108, 502115, 502311, 502280, 502281, 502310, 502247, 502103,
        502109, 502267, 502277, 502114, 502302, 502113, 502375, 502117, 502334,
        502279, 502102, 502381, 502255, 502276, 502301, 502107, 502130, 502248,
        502335, 502336, 502312, 502372, 502331, 502125, 502303, 502110, 502101,
        502032, 502286, 502325, 502314, 502270, 502318, 502269, 502273, 502345,
        502306, 502313, 502287, 502291, 502371, 502293, 502305, 502210, 502296,
        502290, 502228, 502256, 502221, 502271, 502285, 502319, 502321, 502307,
        502251, 502300, 502294, 502295, 502246, 502257, 502324, 502329, 502249,
        502316, 502205, 502001, 502220,
      ],
      Nalgonda: [
        508277, 508114, 508254, 508101, 508377, 508285, 508117, 508255, 508245,
        508002, 508112, 508111, 508243, 508105, 508126, 508116, 508244, 508113,
        508258, 508001, 508202, 508256, 508286, 508253, 508004, 508257, 508252,
        508250, 508248, 508115, 508373, 508284, 508266, 508208, 508210, 508374,
        508221, 508205, 508233, 508204, 508206, 508213, 508278, 508280, 508212,
        508224, 508376, 508223, 508211, 508218, 508355, 508247, 508246, 508279,
        508201, 508238, 508234, 508217, 508207,
      ],
      Nizamabad: [
        503245, 503302, 503122, 503145, 503112, 503246, 503311, 503223, 503235,
        503123, 503180, 503003, 503188, 503186, 503213, 503301, 503144, 503310,
        503164, 503102, 503174, 503110, 503224, 503307, 503212, 503230, 503217,
        503187, 503321, 503225, 503101, 503305, 503125, 503306, 503185, 503218,
        503175, 503165, 503206, 503108, 503308, 503120, 503207, 503309, 503219,
        503202, 503001, 503114, 503002, 503201, 503111, 503124, 503322,
      ],
      Hyderabad: [
        500004, 500045, 500091, 500034, 500075, 500022, 500046, 500081, 500008,
        500033, 500018, 500096, 500029, 500001, 500028, 500082, 500031, 500006,
        500084, 500063, 500089, 500032, 500095, 500041, 500038, 500073, 500057,
        500044, 500013, 500058, 500064, 500027, 500012, 500092, 500005, 500024,
        500086, 500053, 500065, 500097, 500068, 500066, 500051, 500002, 500048,
        500076, 500077, 500030, 500074, 500036, 500098, 500060, 500039, 500069,
        500059, 500035, 500052, 500079, 500070, 500023, 500007, 500043, 500101,
        501102, 500010, 500047, 501301, 500015, 500040, 500020, 500037, 500003,
        500016, 500078, 500011, 500050, 501401, 500062, 500055, 500080, 500014,
        500042, 500025, 500054, 500087, 500085, 500088, 500100, 500072, 500017,
        500009, 500049, 500083, 500026, 500056, 500090, 500094, 500061, 500067,
        501101, 500093,
      ],
      Khammam: [
        507316, 507121, 507160, 507204, 507124, 507203, 507318, 507133, 507114,
        507116, 507305, 507158, 507301, 507117, 507208, 507306, 507167, 507169,
        507164, 507163, 507168, 507137, 507304, 507202, 507123, 507111, 507161,
        507211, 507002, 507118, 507209, 507303, 507302, 507157, 507101, 507210,
        507182, 507001, 507122, 507136, 507129, 507170, 507128, 507135, 507113,
        507166, 507003, 507183, 507115, 507201, 507134, 507165, 507120, 507159,
        507140, 507138, 507125, 507103, 507119, 507154,
      ],
    },
    name: 'TS',
  },
  TR: {
    cities: {
      'South Tripura': [
        799013, 799155, 799101, 799143, 799157, 799115, 799144, 799114, 799103,
        799145, 799104, 799105, 799045, 799142, 799141, 799125, 799156, 799150,
        799120, 799153, 799015,
      ],
      'West Tripura': [
        799005, 799009, 799001, 799004, 799014, 799010, 799002, 799103, 799130,
        799003, 799045, 799211, 799212, 799007, 799006, 799115, 799131, 799015,
        799102, 799210, 799035, 799105, 799012, 799008, 799046, 799153, 799022,
        799201, 799205, 799207, 799203, 799202,
      ],
      Dhalai: [
        799286, 799289, 799285, 799204, 799284, 799273, 799275, 799278, 799287,
        799266,
      ],
      'North Tripura': [
        799260, 799253, 799261, 799271, 799263, 799281, 799254, 799251, 799280,
        799262, 799269, 799266, 799277, 799279, 799264, 799273, 799288, 799250,
        799290, 799270, 799256,
      ],
    },
    name: 'TR',
  },
  UP: {
    cities: {
      Agra: [
        282001, 283101, 282003, 282004, 283202, 283201, 283102, 283110, 283111,
        282007, 283105, 283124, 282002, 283104, 283126, 283115, 282009, 282006,
        283125, 283123, 283119, 283122, 283113, 283121, 282010, 283112, 283114,
        282005, 282008, 202124,
      ],
      Aligarh: [
        202133, 202138, 202002, 202135, 202121, 202140, 202129, 202001, 202122,
        204215, 202132, 204213, 202282, 202280, 202131, 202134, 202130, 202137,
        202143, 202128, 202126, 202125, 202150, 202281, 202165, 202145, 202124,
        202141, 202142, 202170, 202139, 202127, 202155, 202123, 202136, 202146,
        204102,
      ],
      Hathras: [
        204101, 204102, 204215, 204212, 204213, 204214, 204216, 204211, 202002,
        202139, 202121, 281307, 281306, 281104, 281308, 281001,
      ],
      Bulandshahr: [
        203002, 203131, 203411, 203155, 203398, 203392, 203150, 203001, 203405,
        203395, 203391, 203390, 203393, 203408, 203132, 203129, 203205, 203401,
        203412, 203409, 203396, 203402, 203394, 203403, 203397, 203389, 203141,
        203407, 203399, 203201, 203203, 203202, 203206,
      ],
      'Gautam Buddha Nagar': [
        203202, 203203, 203155, 203209, 203141, 203135, 203201, 203207, 201310,
        201313, 201304, 201008, 201306, 201314, 201307, 201311, 201312, 201309,
        201305, 201301, 201303,
      ],
      Etah: [
        207241, 207125, 207001, 207247, 207250, 207244, 207121, 207245, 207002,
        207243, 207246, 207301, 207302, 207401, 207242, 207123, 207249, 207120,
        207248, 207402, 207124, 207003, 207122, 207403,
      ],
      Firozabad: [
        207301, 283151, 283203, 283136, 283141, 283204, 283142, 283103, 283135,
        283130, 283206, 283152, 283205, 283145, 283207, 205262,
      ],
      Etawah: [
        206253, 206002, 206120, 206131, 206128, 206001, 206125, 206127, 206242,
        206126, 206123, 206124, 206245, 206003, 206130,
      ],
      Auraiya: [
        206241, 206247, 206244, 206249, 206252, 206121, 206243, 206122, 206129,
        206251, 206246, 206250, 206248, 206255,
      ],
      Jhansi: [
        284135, 284003, 284302, 284204, 284205, 284419, 284306, 284303, 284202,
        284301, 284401, 284304, 284002, 284121, 284206, 284201, 284127, 284120,
        284128, 284001, 284203, 285205, 284123, 284305, 284405, 285125,
      ],
      Jalaun: [
        285130, 285001, 285223, 285201, 285129, 285205, 285123, 285203, 285202,
        285121, 285124, 285204, 285122, 285206, 285125, 285128, 285126, 284204,
        285127, 284306, 284203, 284303,
      ],
      Lalitpur: [
        284122, 284406, 284403, 284123, 284126, 284405, 284404, 284136, 284402,
        284124, 284501, 284125,
      ],
      Mainpuri: [
        205263, 205247, 205262, 205304, 205001, 205265, 205264, 205268, 205267,
        205121, 205301, 205261, 205303, 205119,
      ],
      Mathura: [
        281006, 281404, 281201, 281204, 281406, 281301, 281308, 281502, 281501,
        281202, 281001, 281123, 281504, 281302, 281005, 281403, 281405, 281004,
        281122, 281205, 281401, 281203, 281121, 281206, 281003, 281303, 281305,
      ],
      Azamgarh: [
        281401, 276205, 223221, 276301, 276126, 276122, 276124, 276125, 276403,
        276142, 223222, 223227, 276404, 276138, 276139, 276406, 223223, 276001,
        276305, 276204, 276141, 276128, 276201, 276288, 276206, 223226, 276303,
        276143, 276304, 276123, 276136, 276129, 276121, 276127, 276306, 276203,
        275307, 276302, 221602, 276202, 223224, 276135, 276208, 276131, 276405,
        276140, 276207, 276137, 223225, 275305, 275304, 276402, 275306, 221603,
        275101, 221706, 275301, 275302,
      ],
      Allahabad: [
        212303, 211007, 211003, 212208, 212217, 212301, 229411, 211005, 211001,
        211017, 211002, 211006, 229413, 212401, 221508, 211008, 212503, 211012,
        229412, 221502, 212306, 221507, 212404, 212502, 212111, 212402, 212109,
        212106, 212507, 221503, 212104, 212201, 212107, 212405, 221505, 212307,
        212302, 212108, 212213, 212305, 211014, 211004, 212203, 211019, 212105,
        212204, 211010, 211011, 211016, 211013, 212216, 212212, 212218, 211018,
        211015, 211009,
      ],
      Kaushambi: [
        212217, 212205, 212213, 212214, 212202, 212216, 212218, 212203, 212201,
        212207, 211011, 212206, 212204, 212401, 212507, 212208,
      ],
      Ghazipur: [
        233227, 232331, 233222, 233002, 275204, 233305, 233302, 275203, 232333,
        233221, 233223, 233231, 232336, 233225, 233300, 233301, 275201, 232329,
        233310, 233229, 232325, 275202, 233226, 233311, 233232, 275205, 233306,
        232339, 233304, 233303, 232340, 233228, 232327, 232332, 233307, 233224,
        233001, 233233, 232328, 232326, 232330, 233230,
      ],
      Jaunpur: [
        222133, 223102, 222203, 222141, 222180, 222161, 222201, 222162, 222142,
        222165, 222170, 223104, 222139, 222101, 222145, 222136, 222137, 222003,
        222105, 222127, 222125, 222175, 223101, 222129, 222143, 222128, 222181,
        222144, 222109, 222202, 223103, 222149, 222148, 222002, 222135, 222132,
        223105, 222204, 222138, 222146, 222001, 222131,
      ],
      Sonbhadra: [
        231205, 231216, 231210, 231212, 231225, 231208, 231223, 231226, 231213,
        231221, 231220, 231217, 231219, 231206, 231207, 231215, 231209, 231224,
        231222, 231218,
      ],
      Mirzapur: [
        231302, 231301, 231305, 231211, 231307, 231306, 231304, 231210, 231313,
        231312, 231501, 231309, 231303, 231311, 231001, 231314,
      ],
      Pratapgarh: [
        230141, 230304, 230131, 229410, 230142, 230204, 230144, 230132, 229408,
        230301, 230124, 230125, 230139, 230501, 230401, 230143, 230126, 230402,
        230137, 230135, 230202, 230403, 230134, 230129, 230127, 230502, 230201,
        230001, 230128, 230404, 230302, 230121, 230503, 230405, 230136, 230002,
        230138, 230306, 230130, 230133, 222301,
      ],
      Varanasi: [
        232110, 221101, 232102, 221007, 221104, 232111, 232118, 232106, 221005,
        221011, 232107, 232109, 221112, 221110, 221001, 232103, 232104, 232101,
        221116, 221115, 221008, 232108, 232105, 221002, 221201, 221010, 221202,
        221006, 221311, 221403, 221204, 221207, 221402, 221405, 221106, 221206,
        221307, 221108, 221105, 221003, 221004, 221305, 221313, 221302, 221208,
        221401, 221306, 221107, 221103, 221304,
      ],
      Chandauli: [
        232101, 232118, 232110, 232105, 232109, 232108, 232106, 232102, 232104,
        232103, 232111, 232120, 221115, 232107, 221009,
      ],
      'Sant Ravidas Nagar': [
        221404, 221304, 221406, 221402, 221303, 221401, 221301, 221314, 221310,
        221309, 221308, 221306, 221409,
      ],
      Pilibhit: [
        262122, 262201, 262121, 262203, 262001, 262202, 262124, 262302, 243123,
        243003, 262305,
      ],
      Bareilly: [
        262406, 243501, 243407, 243002, 243004, 243401, 243302, 243503, 243301,
        243202, 243201, 243505, 243123, 243003, 243402, 243303, 243001, 243506,
        243203, 243504, 243122, 262201, 243126, 243502, 243403, 262203, 243006,
        262302, 243005,
      ],
      Bijnor: [
        246722, 246701, 246734, 246725, 246764, 246733, 246736, 246762, 246747,
        246726, 246761, 246727, 246729, 246724, 246745, 246721, 246731, 246723,
        246749, 246735, 246746, 246763, 246728, 246732, 246737,
      ],
      Budaun: [
        243639, 243631, 243638, 243725, 243723, 243633, 243601, 243722, 243632,
        243635, 243751, 243726, 243634, 243720, 243630, 243724, 243636, 243641,
        243727, 243637, 242021,
      ],
      Hardoi: [
        241123, 241407, 241403, 241121, 241202, 241125, 241301, 241124, 241402,
        241305, 241204, 241203, 241126, 241303, 241001, 241122, 241201, 241404,
        241401, 241406, 241304, 241405, 241302, 241127,
      ],
      Kheri: [
        262727, 262724, 262722, 262903, 261506, 262802, 262804, 261501, 262721,
        262901, 262723, 262904, 262902, 262728, 261505, 262726, 261502, 262701,
        262805, 262908, 262906, 262725, 262801, 262907, 262702, 262905, 262803,
        271855,
      ],
      Meerut: [
        250406, 250001, 245206, 250401, 250221, 250502, 250002, 250104, 250341,
        250342, 250404, 250501, 250344, 250103, 250205, 250223, 250004, 250402,
        250110, 250106, 250222, 250003, 250005,
      ],
      Bagpat: [
        250601, 250609, 250611, 250606, 250623, 250622, 250617, 250626, 250620,
        250621, 250101, 250345, 250615, 250619, 250625,
      ],
      Moradabad: [
        244001, 244414, 244504, 244302, 244104, 244411, 244401, 244410, 244303,
        244412, 244301, 244601, 244402, 244415, 244102, 244501, 244602, 244304,
        244923, 244413, 244103, 244925,
      ],
      'Jyotiba Phule Nagar': [
        244255, 244231, 244501, 244221, 244304, 244236, 244251, 244225, 244242,
        244223, 244235, 244241, 244102, 244222, 244245,
      ],
      Rampur: [
        244901, 244927, 244921, 244701, 244922, 244924, 244923, 244925, 244928,
        244926,
      ],
      Muzaffarnagar: [
        251001, 247771, 251309, 251301, 251306, 251201, 251305, 251202, 247776,
        251307, 251327, 251203, 251314, 247772, 251310, 247774, 251308, 251316,
        247777, 251319, 251315, 251311, 247778, 251318, 247775, 247773, 251320,
        251003, 251002,
      ],
      Saharanpur: [
        247451, 247342, 247232, 247340, 247554, 247452, 247129, 247120, 247551,
        247001, 247122, 247453, 247662, 247341, 247231, 247121, 247669, 247002,
        247343, 247665,
      ],
      Shahjahanpur: [
        242001, 242401, 242305, 242220, 242221, 242223, 242407, 242127, 242303,
        242226, 242042, 242406, 242301, 242306, 242307, 242123, 242405,
      ],
      Mau: [
        275102, 275304, 221706, 275305, 276403, 275301, 221705, 275105, 221602,
        275306, 275103, 221603, 276405, 221601, 275302, 276306, 276129, 275303,
        276402, 275101, 275307, 223222, 276126, 276305,
      ],
      Shrawasti: [
        271831, 271803, 271840, 271845, 271821, 271804, 271802, 271835, 271875,
        271871, 271865, 271805, 271870, 271201,
      ],
      Bahraich: [
        271870, 271871, 271802, 271851, 271882, 271865, 271904, 271881, 271903,
        271902, 271801, 271830, 271855, 271875, 271841, 271825, 271872, 271901,
        271804, 271821, 271845, 271824,
      ],
      Ballia: [
        277209, 277401, 221715, 221713, 221712, 277501, 277203, 277502, 277304,
        277302, 221701, 221711, 221716, 277402, 277303, 221717, 277207, 277001,
        277216, 277201, 277202, 277121, 277205, 277301, 277403, 277211, 221709,
        277503, 277124, 277208, 277214, 221718, 277210, 277204, 277213, 277219,
        277123, 277506, 277504,
      ],
      Siddharthnagar: [
        272152, 272204, 272153, 272202, 272205, 272208, 272206, 272192, 272154,
        272195, 272189, 272191, 272193, 272207, 272129, 272203, 272201, 272148,
        272151, 272194,
      ],
      'Sant Kabir Nagar': [
        272170, 272173, 272162, 272165, 272126, 272199, 272152, 272175, 272271,
        272164, 272270, 272176, 272125, 272172, 272148, 272154,
      ],
      Basti: [
        272163, 272194, 272155, 272191, 272150, 272127, 272190, 272153, 272151,
        272175, 272201, 272161, 272165, 272170, 272002, 272302, 272301, 272131,
        272125, 272123, 272177, 272126, 272128, 272001, 272181, 272182, 272130,
        272124, 272148, 272129, 272171, 271305,
      ],
      Deoria: [
        274509, 274702, 274402, 274508, 274405, 274604, 274001, 274502, 274505,
        274404, 274208, 274501, 274201, 274408, 274202, 274705, 274704, 274506,
        274703, 274603, 274601, 274205, 274204, 274701, 274602, 274182, 274808,
        274806, 274807,
      ],
      Kushinagar: [
        274409, 274149, 274302, 274305, 274203, 274301, 274304, 274407, 274802,
        274401, 274207, 274303, 274206, 274306, 274801, 274402, 274406, 274403,
      ],
      Gonda: [
        271124, 271307, 271401, 271503, 271305, 271402, 271309, 271504, 271312,
        271403, 271302, 271204, 271303, 271202, 271126, 271002, 271313, 271603,
        271125, 271129, 271122, 271602, 271003, 271310, 271311, 271123, 271209,
        271601, 271208, 271001, 271502, 271604, 271301, 271319, 271308, 271304,
      ],
      Balrampur: [
        271215, 271604, 271206, 271203, 271205, 271306, 271201, 271210, 271861,
        271208, 271207, 271209, 271204, 271307, 271609, 271607, 271504,
      ],
      Gorakhpur: [
        273002, 273213, 273001, 273202, 273212, 273003, 273407, 273004, 273013,
        273404, 273306, 273201, 273403, 273016, 273158, 273413, 273007, 273402,
        273165, 273412, 273406, 273409, 273211, 273157, 273405, 273209, 273411,
        273152, 273401, 273408, 273203, 273303, 273301, 273015, 273005, 273006,
        273009, 273012, 273014, 273010, 273163, 273008, 273017,
      ],
      Maharajganj: [
        273164, 273157, 273155, 273163, 273304, 273207, 273303, 273161, 273302,
        273151, 273162, 273301, 273305, 273309, 273405, 273311, 273310, 273306,
        273308,
      ],
      Banda: [
        210001, 210126, 210203, 210121, 210128, 210201, 210120, 210125, 210202,
        210129, 210123, 210208, 210209, 210207, 210206,
      ],
      Chitrakoot: [
        210205, 210206, 210207, 210208, 210209, 210204, 210202, 210203,
      ],
      Mahoba: [
        210425, 210423, 210421, 210433, 210426, 210429, 210424, 210427, 210507,
        210504, 210431,
      ],
      Hamirpur: [
        210430, 210432, 210421, 210507, 210502, 210422, 210431, 210501, 210341,
        210506, 210505, 210429, 210504, 210427, 210428, 210424, 210301, 210425,
      ],
      Kannauj: [
        209723, 209731, 209733, 209728, 209720, 209729, 209736, 209721, 209732,
        209727, 209734, 209747, 209725, 209738, 209722, 209726, 209735,
      ],
      Farrukhabad: [
        209502, 209721, 209621, 209745, 209622, 209652, 209625, 209501, 209651,
        209601, 209724, 209749, 209602, 209505, 209739, 209743, 209504, 209503,
      ],
      Fatehpur: [
        212665, 212601, 212653, 212651, 212641, 212655, 212620, 212661, 212652,
        212635, 212659, 212631, 212650, 212658, 212656, 212664, 212622, 212663,
        212657, 212645, 212621, 212654,
      ],
      'Kanpur Nagar': [
        208002, 209401, 208011, 208003, 208009, 208017, 208001, 209217, 208027,
        209402, 209305, 209214, 208024, 209304, 208007, 208008, 208013, 208012,
        208006, 208005, 208016, 208026, 208010, 208014, 208004, 208021, 208023,
        208025, 208015, 208020, 208022, 208019, 209203, 209206,
      ],
      Unnao: [
        209866, 209801, 209821, 209831, 209867, 209862, 209863, 209827, 209868,
        209859, 209870, 209871, 209825, 209869, 209865, 209864, 209841, 209861,
        209881, 209101,
      ],
      'Kanpur Dehat': [
        209202, 208001, 209302, 209111, 209206, 209101, 209112, 209301, 209115,
        209204, 209312, 209125, 209306, 209310, 209209, 209208, 209303, 209311,
        209308, 209307, 209205, 209121, 209210, 209203,
      ],
      Barabanki: [
        225208, 225207, 225412, 225122, 225401, 225409, 225205, 225124, 225302,
        225416, 225003, 225301, 225306, 225201, 225415, 225001, 225204, 225123,
        225126, 225002, 225414, 225121, 225305, 225303, 225405, 225119, 225120,
        225202, 225125, 225206, 225203, 225403, 225404, 225304, 225413, 224120,
        224116, 224118, 224119, 224117,
      ],
      Faizabad: [
        224116, 224001, 224225, 224208, 224161, 224135, 224121, 224141, 224164,
        224209, 224188, 224207, 224123, 224189, 224153, 224204, 224126, 224182,
        224206, 224228, 224229, 224203, 224152, 224118, 224201, 224284, 224127,
        224120, 224234, 224195, 224158, 224117, 224202, 224205, 224119, 224171,
      ],
      'Ambedkar Nagar': [
        224129, 224168, 224147, 224228, 224157, 224139, 224137, 224145, 224190,
        224122, 224181, 224186, 224149, 224172, 224143, 224152, 224141, 224125,
        224151, 224284, 224234, 224123, 224161, 224132, 224205, 224176, 224201,
        224230, 224203, 224227, 224195, 224210, 224127, 224231, 224159, 224206,
        224202, 224155, 224133, 224171, 224135, 224189, 224232, 224146, 224153,
        224158, 224229, 224183, 224235, 224121, 224207, 224164, 224182, 224208,
        224209, 224238,
      ],
      Ghaziabad: [
        201206, 245101, 201015, 245208, 245201, 245304, 201009, 201001, 245205,
        201003, 201102, 245207, 201204, 201010, 201005, 201011, 201006, 201201,
        201016, 245301, 201013, 201004, 201002, 201012, 201014, 201007, 201301,
        201303, 201017, 201103, 201019,
      ],
      Lucknow: [
        226023, 226004, 226001, 226012, 226303, 226005, 226401, 226203, 226017,
        226024, 226009, 226008, 226003, 226501, 226101, 226018, 226028, 226104,
        226002, 226201, 226025, 226301, 226026, 226021, 226102, 226015, 226020,
        226103, 226302, 226202, 226016, 226010, 226006, 226013, 226019, 226031,
        226022, 226011, 226007, 226014, 226030, 226027, 226029,
      ],
      Raebareli: [
        229001, 229802, 229135, 229316, 229309, 229121, 229206, 229126, 229404,
        229307, 229204, 229103, 229306, 229301, 229129, 229210, 229130, 229303,
        229305, 229401, 229128, 229311, 229203, 229308, 229216, 229211, 229123,
        229207, 229801, 229205, 229122, 229208, 229125, 229201, 229402, 229127,
        229302, 229405, 229202, 229310, 229212, 229209, 229215, 229406, 229124,
        229304, 229010, 229120,
      ],
      Sitapur: [
        261001, 261202, 261301, 261201, 261208, 261401, 261135, 261121, 261303,
        261405, 261207, 261204, 261131, 261402, 261403, 261206, 261141, 261203,
        261151, 261205, 261302, 261145, 261125, 261404, 261136,
      ],
      Sultanpur: [
        228001, 227801, 227813, 227405, 228121, 228132, 227409, 227814, 228171,
        228151, 227816, 227805, 228161, 228141, 228118, 227304, 228120, 228133,
        227808, 222302, 228119, 222301, 228125, 228131, 228145, 228155, 227812,
        227807, 227407, 228142, 227806, 227406, 227408, 227413, 222303, 227815,
        227411, 227412, 227809, 227811, 227817, 228159,
      ],
    },
    name: 'UP',
  },
  UK: {
    cities: {
      Haridwar: [
        246763, 247662, 249403, 247663, 249404, 249407, 249402, 247667, 247661,
        247668, 247671, 249401, 247666, 249408, 247670, 247665, 247664, 247656,
        249405, 249410, 249411,
      ],
      Almora: [
        263652, 263665, 263646, 263645, 263601, 263676, 263623, 263625, 263653,
        263622, 263626, 263621, 263655, 263659, 263624, 263636, 263661, 263680,
        263663, 263678, 263656, 263637, 263667, 263664, 263629, 263651, 263643,
        263660, 263658, 263639, 263620, 263638, 263628, 244715, 263138,
      ],
      Bageshwar: [
        263642, 263641, 263628, 263632, 263634, 263619, 263633, 263640, 263679,
        263635, 263630, 263631, 263624,
      ],
      Chamoli: [
        246440, 246446, 246428, 246455, 246424, 246486, 246422, 246449, 246444,
        246487, 246401, 246427, 246443, 246435, 246488, 246429, 246431, 246473,
        246472, 246482, 246481, 246426, 246441, 246453, 246474, 246483,
      ],
      Rudraprayag: [
        246442, 246439, 246425, 246421, 246471, 246419, 246141, 246171, 246429,
        246475, 246495, 246469, 246445, 246448,
      ],
      Dehradun: [
        248121, 248125, 248007, 248003, 248199, 248001, 248158, 248143, 248140,
        248005, 248196, 248008, 248122, 248124, 248197, 248009, 248123, 248159,
        249204, 248002, 248145, 248012, 248165, 248142, 249205, 248179, 248006,
        248195, 248013, 248171, 247670, 248014, 249202, 248198, 249203, 249201,
        248146, 248011, 248015,
      ],
      'Udham Singh Nagar': [
        263153, 263152, 244716, 263148, 262401, 244712, 262405, 262308, 244713,
        263149, 263160, 263145, 262311, 263150, 244715, 244717, 263151,
      ],
      Nainital: [
        263157, 263159, 263126, 263139, 263136, 263140, 263128, 263134, 263132,
        262402, 263127, 244715, 263158, 263135, 263138, 263156, 244713, 263001,
        263137, 262580,
      ],
      Champawat: [
        262310, 262308, 262309, 262525, 262524, 262527, 262528, 262523, 262580,
        262561,
      ],
      'Pauri Garhwal': [
        246155, 246277, 246146, 246176, 246285, 246121, 246173, 246167, 246149,
        246131, 246179, 246130, 246169, 246275, 246161, 246123, 246127, 246128,
        246129, 246159, 246278, 246172, 246276, 246175, 246162, 246144, 246113,
        246001, 246166, 246164, 246147, 246148, 249306, 246177, 246124, 246194,
        246125, 249301, 249304, 246279, 246174, 246193, 246163, 246142, 249302,
        246165,
      ],
      Pithoragarh: [
        262551, 262534, 262530, 262543, 262542, 262521, 262544, 262552, 262545,
        262576, 262541, 262532, 262501, 262555, 262540, 262554, 262531, 262520,
        262529, 262553, 262561, 262522, 262502, 262547, 262533, 262523, 262546,
        262526, 262550,
      ],
      'Tehri Garhwal': [
        249175, 249155, 249131, 249122, 249146, 249145, 249121, 249192, 249161,
        249199, 249132, 249180, 249181, 249124, 249126, 249165, 249125, 249123,
        249137, 249130, 249141, 249196, 249001, 249186, 249128,
      ],
      Uttarkashi: [
        249128, 249196, 249171, 249152, 249135, 249193, 249141, 249151, 249131,
        249185, 249194, 249195, 249165,
      ],
    },
    name: 'UK',
  },
  WB: {
    cities: {
      Kolkata: [
        700027, 700007, 700020, 700044, 700086, 700022, 700019, 700008, 700018,
        700034, 700025, 700066, 700032, 700042, 700088, 700031, 700029, 700107,
        700047, 700024, 700075, 700095, 700078, 700082, 700033, 700061, 700068,
        700053, 700063, 700026, 700099, 700023, 700045, 700060, 700040, 700094,
        700041, 700092, 700038, 700043, 700014, 700012, 700073, 700001, 700013,
        700016, 700069, 700021, 700072, 700071, 700087, 700017, 700062, 700046,
        700010, 700054, 700085, 700089, 700011, 700009, 700015, 700005, 700035,
        700003, 700108, 700036, 700006, 700077, 700037, 700002, 700074, 700028,
        700065, 700030, 700080, 700052, 700067, 700090, 700004, 700050,
      ],
      'North 24 Parganas': [
        743456, 700155, 743425, 743221, 743248, 700131, 743710, 700135, 743263,
        743249, 743435, 743251, 743445, 743273, 743401, 743235, 743437, 743222,
        743446, 743438, 743427, 743292, 700128, 743232, 743423, 743245, 743262,
        743442, 743270, 743286, 743233, 700124, 743247, 743426, 743411, 743412,
        743701, 743711, 743422, 743439, 743290, 743234, 700126, 743294, 743405,
        743424, 743291, 743287, 743429, 700129, 743293, 743252, 700132, 743289,
        743704, 743268, 743223, 743271, 700127, 700125, 743272, 743428, 700130,
        700133, 743297, 700136, 743702, 700059, 700159, 700055, 700064, 700091,
        700106, 700098, 700157, 700102, 700089, 700160, 700156, 700105, 700048,
        700101, 700097, 700109, 743144, 700122, 700057, 743128, 700116, 743145,
        700119, 700114, 700120, 700123, 700056, 743122, 700121, 743123, 700110,
        700051, 700158, 700076, 743130, 700083, 700058, 743124, 743127, 743129,
        743133, 700111, 743125, 743166, 743134, 743135, 700079, 700117, 743193,
        743126, 700113, 743194, 743136, 743165, 700134, 700049, 700112, 700118,
        700081, 700115, 743611, 743329,
      ],
      'South 24 Parganas': [
        700135, 700039, 700105, 700100, 743368, 700138, 743383, 743329, 700140,
        743347, 743355, 700104, 743370, 743337, 743378, 743312, 743504, 743336,
        743503, 743377, 700141, 743374, 743513, 743349, 743357, 743372, 743610,
        743399, 743318, 743354, 743338, 700145, 743373, 743502, 743371, 743375,
        700070, 743363, 743332, 700152, 743387, 700144, 743611, 700137, 743395,
        743376, 743348, 743613, 743609, 743345, 700103, 700154, 700096, 743330,
        700149, 743331, 700151, 700139, 743351, 700084, 743356, 700150, 700148,
        700146, 700153, 700093, 700142, 700143, 700147,
      ],
      Birbhum: [
        731303, 731121, 731204, 731201, 731130, 731302, 731222, 731219, 731127,
        731242, 731233, 731243, 731101, 731125, 731234, 731240, 731123, 731215,
        731237, 731221, 731103, 731202, 731223, 731301, 731220, 731245, 731236,
        731126, 731238, 731216, 731102, 731244, 731104, 731213, 731241, 731214,
        731133, 731129, 731124, 731132, 731224, 731235,
      ],
      Murshidabad: [
        742122, 742227, 742226, 742223, 742135, 742224, 742301, 742123, 742406,
        742136, 742202, 742121, 742168, 742189, 742138, 742148, 742159, 742201,
        742147, 742302, 742187, 742308, 742163, 742212, 742165, 742237, 742306,
        742102, 742235, 742213, 742132, 742133, 742175, 742140, 742101, 742134,
        742149, 742303, 742184, 742161, 742407, 742405, 742166, 742305, 742104,
        742103, 742174, 742113, 742401, 742225, 742304, 742137, 742404, 742151,
        742236, 742160, 742238, 742164, 742408, 742409, 742402, 713123,
      ],
      Nadia: [
        741137, 741317, 741315, 741101, 741165, 741125, 741122, 741126, 741161,
        741316, 741123, 741154, 741152, 741155, 741156, 741153, 741313, 741124,
        741150, 741103, 741163, 741181, 741102, 741167, 741157, 741319, 741138,
        741302, 741162, 741160, 741301, 741140, 741158, 741164, 741139, 741166,
        741402, 741245, 741253, 741255, 741501, 741121, 741404, 741502, 741223,
        741503, 741221, 741504, 741507, 741250, 741256, 741505, 741248, 741235,
        741127, 741201, 741222, 741509, 741202, 741151, 741251, 741232, 741238,
        741508, 741257, 741401, 741506, 741249, 741234, 741246, 741254, 741252,
        741247, 741159,
      ],
      'Cooch Behar': [
        736156, 736157, 736133, 736160, 736146, 736159, 736145, 736131, 736135,
        736168, 736158, 736101, 736172, 736169, 736134, 736167, 736165, 736206,
        736170, 735217, 736171, 736204, 736176, 736179, 735224, 735303, 735211,
        735304, 735122, 735301,
      ],
      Jalpaiguri: [
        736122, 736123, 736121, 735217, 736206, 735227, 736207, 736203, 736208,
        736202, 736201, 736204, 735214, 735208, 735215, 736182, 736205, 735226,
        734007, 734004, 734015, 734006, 734001, 735101, 735216, 735210, 735207,
        735218, 735202, 735220, 735211, 735302, 734501, 735121, 735305, 735135,
        735233, 735224, 735230, 735206, 735221, 735133, 735132, 735232, 735203,
        735204, 735205, 735219, 735225, 735102, 735209, 735213, 735228, 735134,
        735212, 735234, 735122, 735223, 735303, 735222, 735229,
      ],
      Darjiling: [
        734301, 734427, 734314, 734203, 734105, 734429, 734421, 734014, 734224,
        734008, 734219, 734104, 734201, 734312, 734221, 734423, 734424, 734101,
        734102, 734426, 734003, 734436, 734223, 734220, 734004, 734215, 734121,
        734204, 734214, 734317, 734226, 734009, 734434, 734103, 734217, 734005,
        734011, 734311, 734320, 734007, 734213, 734319, 734316, 734001, 734010,
        734313, 734315, 734013, 734218, 734216, 734122, 734123, 734012, 734321,
        734431, 734002, 734227, 734222, 734124, 735231, 734503, 735206,
      ],
      Malda: [
        732128, 732122, 732138, 732124, 732121, 732216, 732201, 732139, 732208,
        732214, 732143, 732123, 732142, 732125, 732205, 732102, 732210, 732203,
        732206, 732101, 732147, 732207, 732140, 732209, 732126, 732204, 732127,
        732202, 732103, 732212, 732141, 732150, 732144, 732211, 732215, 732213,
        733142, 733124,
      ],
      'South Dinajpur': [
        733127, 733132, 733103, 733141, 733158, 733121, 733125, 733101, 733140,
        733128, 733102, 733142, 733133, 733124, 733145, 733126,
      ],
      'North Dinajpur': [
        733129, 733215, 733208, 733202, 733201, 733207, 733209, 733210, 733134,
        733128, 733125, 733156, 733143, 733123, 733130, 733121, 733132,
      ],
      Bardhaman: [
        713335, 713359, 713381, 713331, 713212, 713214, 713203, 713358, 713321,
        713347, 713215, 713360, 713301, 713304, 713303, 713362, 713322, 713363,
        713323, 713324, 713334, 713204, 713213, 713375, 713378, 713337, 713371,
        713332, 713325, 713330, 713339, 713365, 713326, 713368, 713216, 713302,
        713205, 713376, 713333, 713206, 713208, 713202, 713201, 713210, 713209,
        713211, 713207, 713219, 713377, 713315, 713336, 713338, 713340, 713369,
        713373, 713341, 713342, 713380, 713343, 713385, 713344, 713218, 713370,
        713217, 713346, 713384, 713372, 713305, 713386, 713357, 713383, 713361,
        713144, 713166, 713428, 713148, 713123, 713502, 713512, 713101, 713401,
        713157, 713154, 713141, 713155, 713125, 713129, 713423, 713514, 713408,
        713122, 713121, 713402, 713145, 713405, 713147, 713130, 713143, 713156,
        713146, 713501, 713406, 713104, 713427, 713407, 713152, 713131, 713150,
        713421, 713158, 713409, 713429, 713140, 713124, 713422, 713102, 713126,
        713149, 713426, 713153, 713432, 713142, 713404, 713430, 713103, 713127,
        713424, 713403, 713151, 713128, 713515, 713160, 713162, 713519, 713419,
        713165, 713434, 713520, 713167, 713168, 713420, 713516, 713169, 713170,
        713171, 713172, 713173, 713433, 712410,
      ],
      Bankura: [
        722144, 722173, 722122, 722206, 722134, 722148, 722201, 722137, 722133,
        722135, 722141, 722207, 722102, 722146, 722161, 722121, 722143, 722154,
        722138, 722136, 722139, 722140, 722153, 722151, 722142, 722164, 722101,
        722160, 722150, 722203, 722162, 722202, 722155, 722157, 722156, 722152,
        722158, 722132, 722149, 722204, 722205, 722183, 722208, 722147, 713150,
        713513, 713519, 713512, 713514, 713425, 713517,
      ],
      'West Midnapore': [
        721467, 721424, 721457, 721436, 721133, 721143, 721426, 721445, 721437,
        721135, 721451, 721125, 721443, 721425, 721435, 721159, 721102, 721222,
        721121, 721501, 721517, 721150, 721156, 721504, 721253, 721140, 721506,
        721232, 721260, 721513, 721157, 721505, 721201, 721122, 721128, 721144,
        721124, 721126, 721515, 721149, 721166, 721155, 721503, 721301, 721212,
        721516, 721514, 721160, 721136, 721211, 721129, 721147, 721101, 721127,
        721146, 721131, 721145, 721242, 721304, 721305, 721306, 721507, 721303,
        721302, 721161, 721132, 721148, 721641, 721130, 721153, 721627,
      ],
      'East Midnapore': [
        721401, 721430, 721439, 721420, 721441, 721454, 721427, 721444, 721456,
        721422, 721446, 721432, 721442, 721423, 721440, 721449, 721458, 721450,
        721443, 721448, 721429, 721431, 721135, 721434, 721452, 721433, 721455,
        721425, 721438, 721435, 721453, 721463, 721428, 721447, 721437, 721131,
        721253, 721636, 721635, 721650, 721137, 721134, 721631, 721656, 721628,
        721642, 721139, 721626, 721659, 721633, 721151, 721627, 721649, 721158,
        721645, 721152, 721652, 721648, 721647, 721657, 721651, 721658, 721654,
        721602, 721601, 721629, 721644, 721653, 721154, 721634, 721632, 721167,
        721172, 721603, 721643, 721646, 721130, 721606, 721607, 721604, 721625,
        721641, 721655, 721171, 721153,
      ],
      Hooghly: [
        712121, 712512, 712148, 712414, 712305, 712301, 712149, 712601, 712413,
        712146, 712616, 712611, 712122, 712602, 712501, 712416, 712303, 712134,
        712135, 712123, 712515, 712502, 712617, 712412, 712615, 712302, 712613,
        712415, 712103, 712417, 712503, 712105, 712504, 712147, 712402, 712101,
        712102, 712308, 712614, 712513, 712406, 712612, 712104, 712152, 712514,
        712401, 712701, 712409, 712221, 712706, 712223, 712424, 712404, 712405,
        712203, 712222, 712410, 712407, 712304, 712250, 712248, 712246, 712306,
        712403, 712232, 712124, 712136, 712310, 712702, 712204, 712235, 712311,
        712708, 712137, 712408, 712233, 712707, 712419, 712138, 712201, 712234,
        712705, 712704, 712202, 712245, 712139, 712418, 712249, 712426, 712247,
        712125, 712258, 712411,
      ],
      Howrah: [
        712408, 711204, 711106, 711205, 711303, 711312, 711315, 711401, 711227,
        711301, 711302, 711103, 711316, 711226, 711102, 711110, 711109, 711113,
        711201, 711405, 711322, 711304, 711403, 711404, 711305, 711411, 711101,
        711202, 711313, 711203, 711310, 711307, 711104, 711114, 711308, 711412,
        711314, 711105, 711410, 711309, 711413, 711107, 711112, 711414, 711111,
        711408, 711306, 711409, 711108, 711225, 711317,
      ],
      Medinipur: [721101],
      Puruliya: [
        723145, 723121, 723133, 723129, 723130, 723154, 723152, 723101, 723127,
        723148, 723126, 723201, 723212, 723151, 723147, 723202, 723215, 723146,
        723128, 723149, 723213, 723132, 723153, 723103, 723131, 723161, 723102,
        723143, 723155, 723168, 723156, 723142, 723104,
      ],
    },
    name: 'WB',
  },
};

export default STATES;
